import type { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** java.math.BigDecimal */
  BigDecimal: { input: number; output: number; }
  /** Long type */
  Long: { input: number; output: number; }
  /** Scalar-Map-Type */
  ScalarMap: { input: Map<unknown, unknown>; output: Map<unknown, unknown>; }
  /** Short as Int */
  Short: { input: number; output: number; }
};

export type AaFeature = PageRow & {
  aaFeatureType: Maybe<AaFeatureType>;
  description: Maybe<Scalars['String']['output']>;
  genome: Maybe<Organism>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Maybe<Scalars['String']['output']>;
  pValue: Maybe<Scalars['String']['output']>;
  protein: Maybe<Protein>;
  range: Maybe<Range>;
  region: Maybe<Region>;
  score: Maybe<Scalars['Float']['output']>;
  version: Maybe<Scalars['String']['output']>;
};

/** AaFeatureStats object for aa_feature table rows */
export type AaFeatureStats = {
  associatedProteins: Scalars['Long']['output'];
  count: Scalars['Long']['output'];
  featureTypeColor: Maybe<Scalars['String']['output']>;
  featureTypeId: Scalars['Long']['output'];
  featureTypeName: Scalars['String']['output'];
};

/** Represents an AaFeatureType */
export type AaFeatureType = {
  color: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type ActivityExtendedInstance = {
  default: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  disabled: Maybe<Scalars['Boolean']['output']>;
  executor: Maybe<SupportedExecutorsEnum>;
  identifier: Scalars['String']['output'];
  label: Scalars['String']['output'];
  metadata: Metadata;
  name: Scalars['String']['output'];
  outputFolder: Maybe<ProjectFile>;
  parameters: Array<ActivityInstanceExtendedParameter>;
  skipped: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<WorkflowActivityStatusEnum>;
  tags: Maybe<Array<Tag>>;
  version: Scalars['String']['output'];
};

export type ActivityIo = {
  description: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ActivityInstance = {
  disabled: Maybe<Scalars['Boolean']['output']>;
  executor: Maybe<SupportedExecutorsEnum>;
  identifier: Scalars['String']['output'];
  metadata: Metadata;
  name: Scalars['String']['output'];
  outputFolder: Maybe<ProjectFile>;
  parameters: Array<ActivityInstanceParameter>;
  skipped: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<WorkflowActivityStatusEnum>;
  version: Scalars['String']['output'];
};

export type ActivityInstanceExtendedParameter = {
  disabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  optional: Maybe<Scalars['Boolean']['output']>;
  parameterDefinition: ActivityParameter;
  sortOrder: Maybe<Scalars['Short']['output']>;
  staged: Scalars['Boolean']['output'];
  values: Maybe<ParameterValue>;
};

export type ActivityInstanceParameter = {
  disabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  staged: Scalars['Boolean']['output'];
  values: Maybe<ParameterValue>;
};

export type ActivityLog = {
  activityIdentifier: Scalars['String']['output'];
  errContents: Array<Scalars['String']['output']>;
  logContents: Array<Scalars['String']['output']>;
};

export type ActivityParameter = {
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  optional: Scalars['Boolean']['output'];
  type: WorkflowParameterTypeEnum;
};

export type ActivityProcess = {
  executors: Array<SupportedExecutorsEnum>;
};

export enum ActivityTypeEnum {
  /** ADDED_COORDINATE_LIST */
  AddedCoordinateList = 'ADDED_COORDINATE_LIST',
  /** ADDED_GENOME_FLAG */
  AddedGenomeFlag = 'ADDED_GENOME_FLAG',
  /** ADDED_MEMBER */
  AddedMember = 'ADDED_MEMBER',
  /** ADDED_PROJECT_FILE */
  AddedProjectFile = 'ADDED_PROJECT_FILE',
  /** ADDED_SAMPLE_PARENT */
  AddedSampleParent = 'ADDED_SAMPLE_PARENT',
  /** COMMENT */
  Comment = 'COMMENT',
  /** CREATED_PROJECT */
  CreatedProject = 'CREATED_PROJECT',
  /** DELETED_COORDINATE_LIST */
  DeletedCoordinateList = 'DELETED_COORDINATE_LIST',
  /** DELETED_GENOME_FLAG */
  DeletedGenomeFlag = 'DELETED_GENOME_FLAG',
  /** DELETED_GROUP */
  DeletedGroup = 'DELETED_GROUP',
  /** DELETED_MEMBER */
  DeletedMember = 'DELETED_MEMBER',
  /** DELETED_PROJECT_FILE */
  DeletedProjectFile = 'DELETED_PROJECT_FILE',
  /** DELETED_SAMPLE_PARENT */
  DeletedSampleParent = 'DELETED_SAMPLE_PARENT',
  /** DELETED_VIEW */
  DeletedView = 'DELETED_VIEW',
  /** EDIT_PROJECT */
  EditProject = 'EDIT_PROJECT',
  /** EXECUTED_PLAYBOOK */
  ExecutedPlaybook = 'EXECUTED_PLAYBOOK',
  /** MODIFIED_COORDINATE_LIST */
  ModifiedCoordinateList = 'MODIFIED_COORDINATE_LIST',
  /** MODIFIED_GENOME_FLAG */
  ModifiedGenomeFlag = 'MODIFIED_GENOME_FLAG',
  /** MODIFIED_GROUP */
  ModifiedGroup = 'MODIFIED_GROUP',
  /** MODIFIED_MEMBER */
  ModifiedMember = 'MODIFIED_MEMBER',
  /** MODIFIED_PROJECT */
  ModifiedProject = 'MODIFIED_PROJECT',
  /** MODIFIED_PROJECT_FILE */
  ModifiedProjectFile = 'MODIFIED_PROJECT_FILE',
  /** MODIFIED_SAMPLE_PARENT */
  ModifiedSampleParent = 'MODIFIED_SAMPLE_PARENT',
  /** MODIFIED_VIEW */
  ModifiedView = 'MODIFIED_VIEW',
  /** SAVED_GROUP */
  SavedGroup = 'SAVED_GROUP',
  /** SAVED_VIEW */
  SavedView = 'SAVED_VIEW'
}

/** The parent component for the content browser for usergroup assignments in the admin section. */
export type AdminBrowser = {
  /** Analog to sequenceGenomes but returns all organisms, sequenced or not, for all usergroups. */
  allGenomes: Maybe<GenomeSearch>;
  /** All possible LDAP users: LDAP users, that do not have a session. */
  allPossibleLdapUsers: Maybe<Array<Maybe<User>>>;
  /** All possible Oracle users: users, that have an Oracle account but no session. */
  allPossibleOracleUsers: Maybe<Array<Maybe<User>>>;
  /** All users of the organisation that potentially use the application. */
  allUsers: Maybe<Array<Maybe<User>>>;
  organisms: Maybe<AdminBrowserOrganisms>;
  sampleTypes: Maybe<AdminBrowserSamplesType>;
  users: Maybe<AdminBrowserUsers>;
};


/** The parent component for the content browser for usergroup assignments in the admin section. */
export type AdminBrowserAllGenomesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type AdminBrowserOrganisms = {
  /** The total count of genomes */
  count: Maybe<Scalars['Int']['output']>;
  creationTime: Maybe<OrganismsByCreationTime>;
  userGroup: Maybe<OrganismsByUserGroup>;
};

export type AdminBrowserSamplesType = {
  /** The total count of sample types. */
  count: Maybe<Scalars['Int']['output']>;
  userGroup: Maybe<SampleTypesByProjectGroup>;
};

export type AdminBrowserUsers = {
  /** The total count of users that are not hidden. */
  count: Maybe<Scalars['Int']['output']>;
  userGroup: Maybe<UsersByUserGroup>;
};

/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutation = {
  /** Create a new Playbook */
  createPlaybook: Maybe<Playbook>;
  /** Create a new playbook category */
  createPlaybookCategory: Maybe<PlaybookCategory>;
  /** Adds a role with specified capabilities */
  createRole: Maybe<Role>;
  /** Creates new user accounts */
  createUsers: Maybe<Array<Maybe<User>>>;
  /** Delete existing playbook categories */
  deletePlaybookCategories: Maybe<Array<Maybe<PlaybookCategory>>>;
  /** Force the user(s) to change the password(s) */
  forcePasswordChange: Maybe<Scalars['Boolean']['output']>;
  /** Modify an existing playbook */
  modifyPlaybook: Maybe<Playbook>;
  /** Modify an existing playbook category */
  modifyPlaybookCategory: Maybe<PlaybookCategory>;
  /** Modify a user account */
  modifyUser: Maybe<User>;
  /** The container for the admin tools */
  tools: Maybe<AdminToolsMutation>;
  /** Updates role (name, description, user/capability list). Null values will be skipped. */
  updateRole: Maybe<Role>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationCreatePlaybookArgs = {
  playbookInput: InputMaybe<InputPlaybookInput>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationCreatePlaybookCategoryArgs = {
  playbookCategoryInput: InputMaybe<InputPlaybookCategoryInput>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationCreateRoleArgs = {
  roleInput: InputMaybe<InputRoleInput>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationCreateUsersArgs = {
  newUsers: InputMaybe<Array<InputMaybe<InputUserAccountInput>>>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationDeletePlaybookCategoriesArgs = {
  playbookCategoryIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationForcePasswordChangeArgs = {
  userNames: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationModifyPlaybookArgs = {
  playbookInput: InputMaybe<InputPlaybookInput>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationModifyPlaybookCategoryArgs = {
  playbookCategoryInput: InputMaybe<InputPlaybookCategoryInput>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationModifyUserArgs = {
  user: InputMaybe<InputUserAccountInput>;
};


/** The container for the data modification endpoints that require admin privileges. */
export type AdminMutationUpdateRoleArgs = {
  roleInput: InputMaybe<InputRoleInput>;
};

/** The container for the data query endpoints that require admin privileges. */
export type AdminQuery = {
  /** The list role/playbook capabilities filtered by license */
  capabilities: Maybe<Array<Maybe<Capability>>>;
  /** Test whether a username is a permitted for a new Oracle user account. */
  isAcceptableNewOracleAccountName: Maybe<Scalars['Boolean']['output']>;
  /** Test whether a username already has an associated Oracle user account. */
  isExistingOracleUser: Maybe<Scalars['Boolean']['output']>;
  /** All non archived jobs + a limited list of the latest archived jobs. */
  jobs: Maybe<Array<Maybe<JobAdmin>>>;
  /** The playbook for this id */
  playbook: Maybe<Playbook>;
  /** The list of all existing playbook categories. */
  playbookCategories: Maybe<Array<Maybe<PlaybookCategory>>>;
  /** Validate a playbook name exists */
  playbookNameExists: Maybe<Scalars['Boolean']['output']>;
  /** The list of all configurable, licensed playbooks. */
  playbooks: Maybe<Array<Maybe<Playbook>>>;
  /** All roles in the system  */
  roles: Maybe<Array<Maybe<Role>>>;
  /** Access server components */
  server: Maybe<Server>;
  table: Maybe<Table>;
  /** The container for the admin tools */
  tools: Maybe<AdminTools>;
};


/** The container for the data query endpoints that require admin privileges. */
export type AdminQueryIsAcceptableNewOracleAccountNameArgs = {
  username: InputMaybe<Scalars['String']['input']>;
};


/** The container for the data query endpoints that require admin privileges. */
export type AdminQueryIsExistingOracleUserArgs = {
  username: InputMaybe<Scalars['String']['input']>;
};


/** The container for the data query endpoints that require admin privileges. */
export type AdminQueryPlaybookArgs = {
  playbookId: InputMaybe<Scalars['Long']['input']>;
};


/** The container for the data query endpoints that require admin privileges. */
export type AdminQueryPlaybookNameExistsArgs = {
  playbookName: InputMaybe<Scalars['String']['input']>;
  suffix: InputMaybe<Scalars['String']['input']>;
};


/** The container for the data query endpoints that require admin privileges. */
export type AdminQueryTableArgs = {
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
};

/** The parent query component for the admin tools in the admin section. */
export type AdminTools = {
  /** List of all available admin tools. */
  allAdminTools: Maybe<Array<Maybe<Tool>>>;
  /** List of all available genome taxonomies. */
  allDatabases: Maybe<Array<Maybe<Database>>>;
  /** List of all available genome taxonomies. */
  allTaxonomies: Maybe<Array<Maybe<Taxonomy>>>;
  /** List of genome assemblies available at NCBI RefSeq. */
  genomeAssemblies: Maybe<Array<Maybe<GenomeAssembly>>>;
  /** Test whether we can connect to the internet. */
  hasInternetConnection: Maybe<Scalars['Boolean']['output']>;
};


/** The parent query component for the admin tools in the admin section. */
export type AdminToolsGenomeAssembliesArgs = {
  ids: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** The parent query component for the admin tools in the admin section. */
export type AdminToolsHasInternetConnectionArgs = {
  url: InputMaybe<Scalars['String']['input']>;
};

/** Administration modification */
export type AdminToolsMutation = {
  /** Install NCBI genomes list */
  installNCBIGenomes: Maybe<Scalars['Boolean']['output']>;
  /** Update NCBI RefSeq genome list */
  updateNCBIGenomes: Maybe<Scalars['Boolean']['output']>;
};


/** Administration modification */
export type AdminToolsMutationInstallNcbiGenomesArgs = {
  inputData: InputMaybe<InputGenomeAssembliesInput>;
};


/** Administration modification */
export type AdminToolsMutationUpdateNcbiGenomesArgs = {
  arg0: InputMaybe<Scalars['Boolean']['input']>;
};

/** The necessary data to set up the advanced search panel. */
export type AdvancedSearchConfig = {
  searchAttributes: Maybe<Array<Maybe<SearchAttribute>>>;
  searchTypes: Maybe<Array<Maybe<SearchType>>>;
};


/** The necessary data to set up the advanced search panel. */
export type AdvancedSearchConfigSearchAttributesArgs = {
  entityType: InputMaybe<Scalars['String']['input']>;
  subTypeId: InputMaybe<Scalars['Long']['input']>;
};

/** Parameters of an advanced search */
export type AdvancedSearchParams = {
  attributesQueryExpression: Maybe<Scalars['String']['output']>;
  quickSearchQuery: Maybe<Scalars['String']['output']>;
  restrictionType: Maybe<Scalars['String']['output']>;
  restrictions: Maybe<Array<Maybe<SearchScope>>>;
  searchSubTypeId: Maybe<Scalars['Long']['output']>;
  searchType: Maybe<Scalars['String']['output']>;
};

/** Metadata about an advanced search */
export type AdvancedSearchPreview = {
  elapsedTime: Maybe<Scalars['Long']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  resultSize: Maybe<Scalars['Long']['output']>;
};

export type AnalystSession = PageRow & SavedItem & {
  created: Scalars['String']['output'];
  creator: Maybe<User>;
  deletable: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  identifier: Maybe<Scalars['String']['output']>;
  itemTags: Maybe<Array<Maybe<ItemTag>>>;
  modified: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
  samples: Maybe<Array<Maybe<Sample>>>;
  shared: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<Scalars['String']['output']>;
  typeDisplayName: Maybe<Scalars['String']['output']>;
};

/** A pair of entity type and ids in order to launch analyzers. */
export type AnalyzerIdMapping = {
  entityType: Maybe<Scalars['String']['output']>;
  idRanges: Maybe<Array<Maybe<IdRangePair>>>;
};

/** The application configuration parameters */
export type AppConfiguration = {
  baseUrlClassic: Maybe<Scalars['String']['output']>;
  buildstamp: Maybe<Scalars['String']['output']>;
  cloudEnabled: Maybe<Scalars['Boolean']['output']>;
  contactHtml: Maybe<Scalars['String']['output']>;
  databaseHost: Maybe<Scalars['String']['output']>;
  databaseServiceName: Maybe<Scalars['String']['output']>;
  disableClassicProcessor: Maybe<Scalars['Boolean']['output']>;
  disableClassicUi: Maybe<Scalars['Boolean']['output']>;
  documentationUrl: Maybe<Scalars['String']['output']>;
  externalAuthentication: Maybe<Scalars['Boolean']['output']>;
  forbiddenUploads: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  helpdeskEmail: Maybe<Scalars['String']['output']>;
  hpcEnabled: Maybe<Scalars['Boolean']['output']>;
  htmlFilePreview: Maybe<Scalars['String']['output']>;
  maxDiskBuffer: Maybe<Scalars['Long']['output']>;
  maxSelectedTableRows: Maybe<Scalars['Int']['output']>;
  maxVisibleVariantGenomes: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  revision: Maybe<Scalars['String']['output']>;
  serverHost: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['String']['output']>;
};

/** Represents an attribute. */
export type Attribute = PageRow & {
  attributeName: Scalars['String']['output'];
  attributeType: AttributeType;
  automatic: Scalars['Boolean']['output'];
  /** A conditional statement to trigger the highlight of attribute values. */
  coloringRule: Maybe<Scalars['String']['output']>;
  columnSet: ColumnSet;
  /** The amount of decimal numbers. Limited to a two digit number. */
  decimals: Maybe<Scalars['Int']['output']>;
  /** The attributes this attribute references in its formula. */
  dependsOn: Array<Attribute>;
  disabled: Scalars['Boolean']['output'];
  /** The dynamic terms defined by the attribute query. */
  dynamicTerms: Array<DynamicTerm>;
  editOnce: Scalars['Boolean']['output'];
  /** Indicates if the values for this attribute can be changed by the user. */
  editable: Scalars['Boolean']['output'];
  /** The file type for attribute if available (only for attributes of type 'file'), null otherwise. */
  fileType: Maybe<FileType>;
  formulaText: Maybe<Scalars['String']['output']>;
  frozen: Scalars['Boolean']['output'];
  groupName: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  /** True if there is one or more attribute value for the attribute. */
  hasData: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  idAccessor: Maybe<Scalars['String']['output']>;
  /** True if the attribute is a head attribute of an multi-value attribute group. */
  isHead: Scalars['Boolean']['output'];
  /** Artificial field for making it easier to mix up Tracker Attributes with Workflow Parameters, not now in use only on client side. */
  isWorkflowParam: Scalars['Boolean']['output'];
  mandatory: Scalars['Boolean']['output'];
  maxLength: Maybe<Scalars['Int']['output']>;
  maxValue: Maybe<Scalars['Float']['output']>;
  minValue: Maybe<Scalars['Float']['output']>;
  modifiable: Scalars['Boolean']['output'];
  /** True if the attribute accepts multiple values. */
  multipleValues: Scalars['Boolean']['output'];
  /** The parent type for parent attributes, null otherwise. */
  parentType: Maybe<ParentType>;
  pattern: Maybe<Scalars['String']['output']>;
  patternHint: Maybe<Scalars['String']['output']>;
  /** The attributes that reference this attribute in their formula. */
  referencedBy: Array<Attribute>;
  representedColumn: Maybe<Scalars['String']['output']>;
  /** The sample types related to this attribute. */
  sampleTypes: Array<SampleType>;
  sqlStatement: Maybe<Scalars['String']['output']>;
  tableColumn: Column;
  usage: Maybe<Scalars['String']['output']>;
  valueUniqueConstraint: Scalars['Boolean']['output'];
  /** All vocabulary terms for this attribute. */
  vocabularyTerms: Array<VocabularyTerm>;
};

export type AttributeChange = {
  attribute: Maybe<Scalars['String']['output']>;
  groupName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  newValue: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type AttributeDefaultValue = {
  defaultNumber: Maybe<Scalars['Float']['output']>;
  defaultTerm: Maybe<VocabularyTerm>;
  defaultText: Maybe<Scalars['String']['output']>;
  template: Maybe<Scalars['String']['output']>;
};

export type AttributeDefaultValueMapEntry = {
  attributeId: Maybe<Scalars['Long']['output']>;
  data: Maybe<AttributeDefaultValue>;
};

/** Represents a dynamically defined sample attribute value. */
export type AttributeMultiValue = {
  attribute: Maybe<Attribute>;
  formattedValue: Maybe<Scalars['String']['output']>;
  valueList: Maybe<Array<Maybe<AttributeValue>>>;
};

/** Represents an attribute type. */
export type AttributeType = {
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

/** Represents a dynamically defined sample attribute value. */
export type AttributeValue = {
  applicable: Scalars['Boolean']['output'];
  attribute: Attribute;
  booleanValue: Maybe<Scalars['Boolean']['output']>;
  /** The color calculated inferred from the coloring rule assigned to the attribute. */
  color: Maybe<Scalars['String']['output']>;
  dateValue: Maybe<Scalars['String']['output']>;
  /** The dynamic term information */
  dynamicTerm: Maybe<DynamicVocabularyTerm>;
  floatValue: Maybe<Scalars['BigDecimal']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  longValue: Maybe<Scalars['Long']['output']>;
  /** The parent for an parent attribute value or null. Use with caution to avoid performance issues. */
  parent: Maybe<Parent>;
  /** The project file for a sample attribute or null. */
  projectFile: Maybe<ProjectFile>;
  /** The sample for an sample attribute value or null. Use with caution to avoid performance issues. */
  sample: Maybe<Sample>;
  stringListValue: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  stringValue: Maybe<Scalars['String']['output']>;
  valueIndex: Maybe<Scalars['Long']['output']>;
};

export type AuditEvent = {
  created: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  message: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

export type AuditEventType = {
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type AuditFilterOption = {
  eventTypes: Maybe<Array<AuditEventType>>;
  playbooks: Maybe<Array<Playbook>>;
  roles: Maybe<Array<Role>>;
  users: Maybe<Array<User>>;
};

/** Custom columns for BED feature table rows */
export type BedCustomColumn = {
  stringValue: Maybe<Scalars['String']['output']>;
};

/** BED Feature object for BED feature table rows */
export type BedFeature = PageRow & {
  customColumn: Maybe<BedCustomColumn>;
  description: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Maybe<Scalars['String']['output']>;
  region: Maybe<Region>;
  score: Maybe<Scalars['BigDecimal']['output']>;
  type: Maybe<Scalars['String']['output']>;
};


/** BED Feature object for BED feature table rows */
export type BedFeatureCustomColumnArgs = {
  customColumn: InputMaybe<Scalars['String']['input']>;
};

export type BamSummary = {
  bamFile: Maybe<ProjectFile>;
  id: Maybe<Scalars['Long']['output']>;
  maxMappedReadLength: Maybe<Scalars['Int']['output']>;
  minMappedReadLength: Maybe<Scalars['Int']['output']>;
};

/** The raw formatted advanced BLAST options. */
export type BlastAdvancedOptions = {
  compositionalAdjustments: Maybe<Scalars['String']['output']>;
  expectThreshold: Maybe<Scalars['Float']['output']>;
  filterLowComplexity: Maybe<Scalars['Boolean']['output']>;
  gapCost: Maybe<Scalars['String']['output']>;
  genCode: Maybe<Scalars['Int']['output']>;
  maskLower: Maybe<Scalars['Boolean']['output']>;
  maskTable: Maybe<Scalars['Boolean']['output']>;
  matchMismatchScores: Maybe<Scalars['String']['output']>;
  matrix: Maybe<Scalars['String']['output']>;
  /** The max number of HSPs per hit */
  maxMatches: Maybe<Scalars['Int']['output']>;
  /** The number of hits */
  maxTargetSeqs: Maybe<Scalars['Int']['output']>;
  shortQueries: Maybe<Scalars['Boolean']['output']>;
  wordSize: Maybe<Scalars['Int']['output']>;
};

/** Blast hit object for blast hit table rows */
export type BlastHit = PageRow & {
  /** The HSP with the lowest rank */
  bestHsp: Maybe<BlastHsp>;
  /** E-Value of the best HSP (double precision) */
  eValue: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  /** Number of HSPs */
  hspCount: Maybe<Scalars['Int']['output']>;
  /** HSPs for this hit */
  hsps: Maybe<Array<Maybe<BlastHsp>>>;
  id: Scalars['Long']['output'];
  jobId: Maybe<Scalars['Long']['output']>;
  maxScore: Maybe<Scalars['Long']['output']>;
  /** The protein that was hit or null otherwise */
  protein: Maybe<Protein>;
  queryId: Maybe<Scalars['Long']['output']>;
  rank: Maybe<Scalars['Int']['output']>;
  /** The target sequence. Either internal or external. */
  target: Maybe<BlastHitTarget>;
  /** Sum of all hsp scores */
  totalScore: Maybe<Scalars['Long']['output']>;
};

/** Blast Hit Target object */
export type BlastHitTarget = {
  accession: Maybe<Scalars['String']['output']>;
  blastIndex: Maybe<BlastIndex>;
  database: Maybe<Database>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  isExternal: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organism: Maybe<Organism>;
  sequence: Maybe<Scalars['String']['output']>;
  sequenceId: Maybe<Scalars['String']['output']>;
  species: Maybe<Species>;
  type: Maybe<SequenceGroup>;
  version: Maybe<Scalars['Int']['output']>;
  virtualGenomes: Maybe<Array<Maybe<Organism>>>;
};


/** Blast Hit Target object */
export type BlastHitTargetSequenceArgs = {
  seqLengthLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Blast HSP object */
export type BlastHsp = PageRow & {
  /** Alignment length of the HSP */
  alignmentLength: Maybe<Scalars['Long']['output']>;
  blastHit: Maybe<BlastHit>;
  eValue: Maybe<Scalars['String']['output']>;
  frame: Maybe<Scalars['String']['output']>;
  /** Percentage gaps of the HSP (double precision) */
  gaps: Maybe<Scalars['Float']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  /** Percentage identity of the HSP (double precision) */
  ident: Maybe<Scalars['Float']['output']>;
  jobId: Maybe<Scalars['Long']['output']>;
  midline: Maybe<Scalars['String']['output']>;
  pValue: Maybe<Scalars['String']['output']>;
  /** Percentage positives of the HSP (double precision) */
  pos: Maybe<Scalars['Float']['output']>;
  /** Percent query coverage of the HSP */
  queryCoverage: Maybe<Scalars['Float']['output']>;
  queryId: Maybe<Scalars['Long']['output']>;
  querySequence: Maybe<Scalars['String']['output']>;
  /** Start of alignment is subject sequence */
  queryStart: Maybe<Scalars['Long']['output']>;
  /** End of alignment is subject sequence */
  queryStop: Maybe<Scalars['Long']['output']>;
  queryStrand: Maybe<Scalars['String']['output']>;
  rank: Maybe<Scalars['Int']['output']>;
  rawScore: Maybe<Scalars['Int']['output']>;
  /** Genes that overlap with the blast hsp. */
  relatedGenes: Maybe<Array<Maybe<Gene>>>;
  score: Maybe<Scalars['Int']['output']>;
  sequenceId: Maybe<Scalars['String']['output']>;
  targetSequence: Maybe<Scalars['String']['output']>;
  /** Start of alignment is subject sequence */
  targetStart: Maybe<Scalars['Long']['output']>;
  /** End of alignment is subject sequence */
  targetStop: Maybe<Scalars['Long']['output']>;
  targetStrand: Maybe<Scalars['String']['output']>;
};

/** The BLAST index */
export type BlastIndex = {
  dbSize: Maybe<Scalars['Long']['output']>;
  /** Either ORS_ID, DBS_ID, EXY_ID, or EXD_ID depending on the type of the index */
  id: Maybe<Scalars['Long']['output']>;
  indexName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  secondaryName: Maybe<Scalars['String']['output']>;
  sequenceType: Maybe<Scalars['String']['output']>;
  /** Either genome, database or extDatabase depending on the source table */
  type: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  /** Genome indexes can be virtual */
  virtual: Maybe<Scalars['Boolean']['output']>;
};

/** A Blast Job */
export type BlastJob = JobData & {
  created: Maybe<Scalars['String']['output']>;
  errorDescription: Maybe<Scalars['String']['output']>;
  event: Maybe<PlaybookEvent>;
  eventDescription: Maybe<Scalars['String']['output']>;
  eventName: Maybe<Scalars['String']['output']>;
  /** The expiation date, or null if the job isn't scheduled for purging (yet). */
  expirationDate: Maybe<Scalars['String']['output']>;
  firstResultId: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  notification: Maybe<Notification>;
  owner: Maybe<User>;
  params: Maybe<JobParams>;
  resultCount: Maybe<Scalars['Int']['output']>;
  results: Maybe<Array<Maybe<JobResult>>>;
  status: Maybe<JobStatusEnum>;
  tool: Maybe<Scalars['String']['output']>;
};


/** A Blast Job */
export type BlastJobResultsArgs = {
  queryIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Parameters for a BLAST run. */
export type BlastParams = {
  advancedOptions: Maybe<BlastAdvancedOptions>;
  blastType: Maybe<Scalars['String']['output']>;
  /** Possibly empty list of uploaded files */
  files: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of stringified BlastIndex input elements. */
  indexes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** content of textarea (seq or accessions) */
  sequenceQuery: Maybe<Scalars['String']['output']>;
  /** List of the blast index data for output. */
  targets: Maybe<Array<Maybe<BlastIndex>>>;
};

/** Blast Result DTO */
export type BlastResult = {
  alignment: Maybe<Scalars['String']['output']>;
  eValue: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  identicals: Maybe<Scalars['Int']['output']>;
  pValue: Maybe<Scalars['String']['output']>;
  positives: Maybe<Scalars['Int']['output']>;
  protein: Maybe<Protein>;
  queryStart: Maybe<Scalars['Int']['output']>;
  queryStop: Maybe<Scalars['Int']['output']>;
  score: Maybe<Scalars['Int']['output']>;
  targetStart: Maybe<Scalars['Int']['output']>;
  targetStop: Maybe<Scalars['Int']['output']>;
};

/** The expanded blast view state object */
export type BlastViewState = {
  colorMismatchesOnly: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanParam = ActivityParameter & {
  defaultValue: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  optional: Scalars['Boolean']['output'];
  type: WorkflowParameterTypeEnum;
};

export type BooleanValue = ParameterValue & {
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  value: Scalars['Boolean']['output'];
};

export type Capability = {
  description: Maybe<Scalars['String']['output']>;
  groupName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  playbook: Maybe<Playbook>;
  type: Maybe<Scalars['String']['output']>;
};

/** A global search result category */
export type Category = {
  categoryName: Maybe<Scalars['String']['output']>;
  categoryType: Maybe<Scalars['String']['output']>;
  items: Maybe<Array<Maybe<Item>>>;
  /** The optional sub-type id. */
  subTypeId: Maybe<Scalars['Long']['output']>;
  totalItemCount: Maybe<Scalars['Long']['output']>;
};

/** A chart layout */
export type ChartLayoutState = {
  chartType: Maybe<Scalars['String']['output']>;
  errorBars: Maybe<Scalars['Boolean']['output']>;
  filterOutEmptyValues: Maybe<Scalars['Boolean']['output']>;
  isLogScale: Maybe<Scalars['Boolean']['output']>;
  symbolSize: Maybe<Scalars['Float']['output']>;
  timeSeries: Maybe<Scalars['Boolean']['output']>;
};

/** The classification object */
export type Classification = {
  description: Maybe<Scalars['String']['output']>;
  displayName: Maybe<Scalars['String']['output']>;
  groupName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  schemeName: Maybe<Scalars['String']['output']>;
};

export type ClusterSet = {
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Represents color scheme data e.g. for track features customization. */
export type ColorScheme = {
  colors: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Column definition object */
export type Column = {
  attribute: Maybe<Attribute>;
  cellExpansion: Maybe<Scalars['String']['output']>;
  cellType: Maybe<Scalars['String']['output']>;
  columnId: Maybe<Scalars['Long']['output']>;
  dynamic: Maybe<Scalars['Boolean']['output']>;
  dynamicType: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  filterExpression: Maybe<Scalars['String']['output']>;
  filterable: Maybe<Scalars['Boolean']['output']>;
  fixed: Maybe<Scalars['Boolean']['output']>;
  groupField: Maybe<Scalars['String']['output']>;
  groupName: Maybe<Scalars['String']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  multiValuesContext: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  namespace: Maybe<Scalars['Int']['output']>;
  searchAttributes: Maybe<SearchAttribute>;
  sort: Maybe<SortData>;
  sortable: Maybe<Scalars['Boolean']['output']>;
};

/** A GDA column annotation */
export type ColumnAnnotation = {
  field: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  valueSet: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  values: Maybe<Array<Maybe<StringMapEntry>>>;
};

/** Represents a column set. */
export type ColumnSet = {
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** A filter criteria in the analytical dataset view state. */
export type ConditionFilter = {
  categoricalValues: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  maxNumericalValue: Maybe<Scalars['Float']['output']>;
  minNumericalValue: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** The config parameters */
export type Configuration = {
  application: Maybe<AppConfiguration>;
  /** True if audit logging is enabled, false otherwise. */
  auditLogEnabled: Maybe<Scalars['Boolean']['output']>;
  /** Authentication mode (LDAP or Oracle) */
  authenticationMode: Maybe<Scalars['String']['output']>;
  /** Checks the required grants for creating a new Oracle account. */
  canCreateOracleUser: Maybe<Scalars['Boolean']['output']>;
  license: Maybe<License>;
  oraclePasswordLimits: Maybe<OraclePasswordLimit>;
  /** The Selector system parameters */
  systemParameters: Maybe<SystemParameter>;
};

export type Connector = {
  input: Maybe<Scalars['String']['output']>;
  output: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type Constraints = {
  id: Maybe<Scalars['String']['output']>;
};

/** The parent component for the content browser */
export type ContentBrowser = {
  organisms: Maybe<Organisms>;
};

/** The expanded content browser view state object */
export type ContentBrowserViewState = {
  featureType: Maybe<Scalars['String']['output']>;
  groupByAttribute: Maybe<Scalars['String']['output']>;
  selectedEntry: Maybe<ListingMapEntry>;
  tableView: Maybe<TableViewState>;
};

/** The content type DTO */
export type ContentType = {
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  suffix: Maybe<Scalars['String']['output']>;
};

/** Contig object for contig data */
export type Contig = PageRow & {
  accession: Scalars['String']['output'];
  contigStatistics: ContigStatistics;
  creator: Maybe<User>;
  database: Database;
  description: Maybe<Scalars['String']['output']>;
  entered: Scalars['String']['output'];
  /** Records of events in which the contig was used as a resource of a playbook. */
  eventResources: Array<EventResource>;
  /** The region flags ordered by range start */
  flags: Array<RegionFlag>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  /** Internal references */
  internalReferences: Array<Sequence>;
  length: Scalars['Long']['output'];
  name: Maybe<Scalars['String']['output']>;
  organism: Organism;
  relatedProjects: Maybe<Array<Maybe<RelatedProject>>>;
  sequenceId: Scalars['String']['output'];
  sequenceType: Scalars['String']['output'];
  species: Species;
  type: Scalars['String']['output'];
  userGroups: Maybe<Array<Maybe<UserGroup>>>;
  version: Scalars['Int']['output'];
};

/** The contig found by a search. */
export type ContigSearch = {
  contigs: Array<Contig>;
  genome: Maybe<Organism>;
  limit: Maybe<Scalars['Int']['output']>;
  searchTerm: Maybe<Scalars['String']['output']>;
};

/** ContigStatistics object */
export type ContigStatistics = {
  aaFeaturesCount: Maybe<Array<Maybe<AaFeatureStats>>>;
  contigSize: Maybe<Scalars['Long']['output']>;
  geneCount: Maybe<Scalars['Int']['output']>;
  markersCount: Maybe<Array<Maybe<MarkerStats>>>;
  nuFeaturesCount: Maybe<Array<Maybe<NuFeatureStats>>>;
  nuProfilesCount: Maybe<Array<Maybe<NuProfileStats>>>;
  proteinsCount: Maybe<Scalars['Long']['output']>;
  transcriptsCount: Maybe<Scalars['Long']['output']>;
  variantCounts: Maybe<VariantCounts>;
};


/** ContigStatistics object */
export type ContigStatisticsVariantCountsArgs = {
  refGenomeId?: InputMaybe<Scalars['Long']['input']>;
};

export type ControlledValue = {
  label: Maybe<Scalars['String']['output']>;
};

export type Coordinate = PageRow & {
  coordinateList: CoordinateList;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Maybe<Scalars['String']['output']>;
  nuSequence: Contig;
  region: Maybe<Region>;
  score: Maybe<Scalars['BigDecimal']['output']>;
};

export type CoordinateList = PageRow & SavedItem & {
  count: Scalars['Long']['output'];
  created: Scalars['String']['output'];
  creator: Maybe<User>;
  deletable: Maybe<Scalars['Boolean']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  itemTags: Maybe<Array<Maybe<ItemTag>>>;
  modified: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  organism: Maybe<Organism>;
  owner: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
  samples: Maybe<Array<Maybe<Sample>>>;
  shared: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<Scalars['String']['output']>;
  typeDisplayName: Maybe<Scalars['String']['output']>;
};

export type CoordinateListUiContext = PlaybookUiContext & {
  context: UiContextEnum;
  genomeParam: ParameterMapping;
  tableParam: ParameterMapping;
};

export type Coverage = {
  coverage: Scalars['Float']['output'];
  range: Range;
};

/** A user home page dashboard */
export type Dashboard = {
  content: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
};

export type DataComponent = {
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type DataRow = {
  annotations: Maybe<Array<Maybe<StringMapEntry>>>;
  id: Maybe<Scalars['String']['output']>;
  values: Maybe<Array<Maybe<StringMapEntry>>>;
};

export type DataSeries = {
  name: Maybe<Scalars['String']['output']>;
  rows: Maybe<Array<Maybe<DataRow>>>;
};

/** The database DTO */
export type Database = {
  created: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  isShared: Maybe<Scalars['Boolean']['output']>;
  isUploadTarget: Maybe<Scalars['Boolean']['output']>;
  mnemonic: Maybe<Scalars['String']['output']>;
  modified: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisation: Maybe<Organisation>;
  owner: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['String']['output']>;
};

/** Properties of a dataseries */
export type DataseriesProperties = {
  color: Maybe<Scalars['String']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  splitByCondition: Maybe<Scalars['String']['output']>;
  splitMultiValueIndex: Maybe<Scalars['String']['output']>;
  splitParent: Maybe<Scalars['String']['output']>;
  splitValue: Maybe<Scalars['String']['output']>;
};

/** The abstract superclass of all dataset types. */
export type Dataset = {
  columnAnnotations: Maybe<Array<Maybe<ColumnAnnotation>>>;
  columns: Maybe<Array<Maybe<DatasetColumn>>>;
  dataSeries: Maybe<Array<Maybe<DataSeries>>>;
  dataSeriesSearch: Maybe<Array<Maybe<DataSeries>>>;
  description: Maybe<Scalars['String']['output']>;
  encodedPath: Maybe<Scalars['String']['output']>;
  fileMetadata: Maybe<ProjectFile>;
  genomes: Maybe<Array<Maybe<Organism>>>;
  id: Maybe<Scalars['Long']['output']>;
  isGenomeDefault: Maybe<Scalars['Boolean']['output']>;
  isGlobalDefault: Maybe<Scalars['Boolean']['output']>;
  maxValue: Maybe<Scalars['Float']['output']>;
  minValue: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  parameters: Maybe<Array<Maybe<StringMapEntry>>>;
  project: Maybe<Project>;
  rowAnnotations: Maybe<Array<Maybe<RowAnnotation>>>;
};


/** The abstract superclass of all dataset types. */
export type DatasetDataSeriesArgs = {
  dataSeriesNames: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The abstract superclass of all dataset types. */
export type DatasetDataSeriesSearchArgs = {
  dataSeriesSearchTerm: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type DatasetColumn = {
  annotations: Maybe<Array<Maybe<StringMapEntry>>>;
  field: Maybe<Scalars['String']['output']>;
  maxValue: Maybe<Scalars['Float']['output']>;
  minValue: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** The dataset view state */
export type DatasetViewState = {
  chartLayout: Maybe<ChartLayoutState>;
  chartSelection: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  chartTableSelection: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  dataSeries: Maybe<Array<Maybe<DataSeries>>>;
  dataset: Maybe<Dataset>;
  filteredOutAnnotations: Maybe<Array<Maybe<ConditionFilter>>>;
  groupMode: Maybe<Scalars['Boolean']['output']>;
  groupTableView: Maybe<TableViewState>;
  hideEmptyDataSeries: Maybe<Scalars['Boolean']['output']>;
  /** The number of conditions that are not available, because they are deleted or not visible to the user. */
  missingConditions: Maybe<Scalars['Int']['output']>;
  selectedAnnotations: Maybe<Array<Maybe<SelectedColumnAnnotation>>>;
  selectedDataSeries: Maybe<Array<Maybe<DataseriesProperties>>>;
  showFilterPanel: Maybe<Scalars['Boolean']['output']>;
  splitPaneLayout: Maybe<SplitPaneLayoutState>;
};

export type DateParam = ActivityParameter & {
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  optional: Scalars['Boolean']['output'];
  type: WorkflowParameterTypeEnum;
};

export type DateValue = ParameterValue & {
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** The deleted group */
export type DeletedGroup = {
  id: Maybe<Scalars['Long']['output']>;
  itemCount: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  typeDisplayName: Maybe<Scalars['String']['output']>;
};

export type DirectionalOrtholog = PageRow & {
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  protein: Maybe<Protein>;
};

/** Represents a dynamic vocabulary term. */
export type DynamicTerm = {
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type DynamicVocabularyTerm = {
  id: Maybe<Scalars['Long']['output']>;
  itmId: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  /** The type that the term refers to, if we support linking to it, null otherwise. */
  type: Maybe<Scalars['String']['output']>;
};

/** The EC number. */
export type EcNumber = {
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Holds the data necessary for showing the edit grid. */
export type EditSamplesGrid = {
  sampleAttributes: Maybe<Array<Maybe<Attribute>>>;
  samples: Maybe<Array<Maybe<Sample>>>;
};

/** The expanded entity summary view state object */
export type EntitySummaryViewState = {
  id: Maybe<Scalars['Long']['output']>;
  refGenomeId: Maybe<Scalars['Long']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** Resource associated to a playbook event. */
export type EventResource = {
  activity: Maybe<Scalars['String']['output']>;
  direction: Maybe<Scalars['String']['output']>;
  file: Maybe<ProjectFile>;
  folder: Maybe<EventResourceFolder>;
  organism: Maybe<Organism>;
  playbookEvent: Maybe<PlaybookEvent>;
  region: Maybe<Region>;
  resourceType: Maybe<Scalars['String']['output']>;
};

/** Folder Resource associated to a playbook event. */
export type EventResourceFolder = {
  deleted: Maybe<Scalars['Boolean']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  humanReadablePath: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
};

/** Sample association with a playbook event. */
export type EventSample = {
  /** The action of the event sample. There are two supported actions, creation ('C') and modification ('M'). */
  action: Maybe<Scalars['String']['output']>;
  playbookEvent: Maybe<PlaybookEvent>;
};

export type ExperimentInput = {
  correctedMandatory: Maybe<Scalars['Boolean']['output']>;
  correctedTypeId: Maybe<Scalars['Long']['output']>;
  description: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  trackerAttributeId: Maybe<Scalars['Long']['output']>;
  workflowParamDefault: Maybe<Scalars['String']['output']>;
  workflowParamId: Maybe<Scalars['String']['output']>;
};

/** Workflow field which can be exported */
export type ExportWorkflowField = {
  description: Maybe<Scalars['String']['output']>;
  isMultiValues: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  typeId: Maybe<Scalars['Long']['output']>;
};

/** An external reference */
export type ExternalReference = {
  /** The citation based on the article datastore, if present. */
  citation: Maybe<Scalars['String']['output']>;
  databaseName: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** The visible name as a combination of database name and entry name */
  displayName: Maybe<Scalars['String']['output']>;
  /** The ext entry id. */
  id: Maybe<Scalars['Long']['output']>;
  /** The formatted link to the external resource */
  link: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

/** Generic feature type for data to be shown in genome browser tracks */
export type Feature = {
  color: Maybe<Scalars['String']['output']>;
  dataSeries: Maybe<DataSeries>;
  description: Maybe<Scalars['String']['output']>;
  eValue: Maybe<Scalars['String']['output']>;
  extDatabaseName: Maybe<Scalars['String']['output']>;
  extReferences: Maybe<Array<Maybe<ExternalReference>>>;
  featureTypeId: Maybe<Scalars['Long']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  mappings: Maybe<Array<Maybe<Range>>>;
  name: Maybe<Scalars['String']['output']>;
  origRange: Maybe<Range>;
  protein: Maybe<Protein>;
  referenced: Maybe<Scalars['Boolean']['output']>;
  region: Maybe<Region>;
  score: Maybe<Scalars['BigDecimal']['output']>;
  sequence: Maybe<Scalars['String']['output']>;
  sequenceTypeId: Maybe<Scalars['Long']['output']>;
  status: Maybe<Scalars['String']['output']>;
  synonyms: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The id of the related entity that can be linked to. When no target is given, the id is used as fallback. */
  targetId: Maybe<Scalars['Long']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** Details on files */
export type FileChooser = {
  children: Maybe<Array<Maybe<ProjectFile>>>;
  parentFolder: Maybe<ProjectFile>;
};

export type FileConstraints = Constraints & {
  fileSelectionType: Maybe<FileSelectionTypeEnum>;
  fileTypes: Maybe<Array<Scalars['String']['output']>>;
  id: Maybe<Scalars['String']['output']>;
};

export type FileParam = ActivityParameter & {
  constraints: Maybe<FileConstraints>;
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  multiSelect: Scalars['Boolean']['output'];
  optional: Scalars['Boolean']['output'];
  type: WorkflowParameterTypeEnum;
};

export enum FileSelectionTypeEnum {
  /** FILE */
  File = 'FILE',
  /** FOLDER */
  Folder = 'FOLDER'
}

/** The summary information for a specific FileTypeData */
export type FileType = {
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type FileUploadResult = {
  id: Scalars['String']['output'];
  input: Maybe<Scalars['String']['output']>;
  savedAs: Maybe<Scalars['String']['output']>;
  uploaded: Maybe<Scalars['String']['output']>;
};

export type FileValue = ParameterValue & {
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  value: Array<Maybe<ProjectFile>>;
};

export type FullPileupAlignment = {
  attributes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  averageBaseQuality: Maybe<Scalars['Int']['output']>;
  cigar: Maybe<Scalars['String']['output']>;
  deletions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  duplicate: Maybe<Scalars['Boolean']['output']>;
  firstOfPair: Maybe<Scalars['Boolean']['output']>;
  hasDeletions: Maybe<Scalars['Boolean']['output']>;
  hasInsertions: Maybe<Scalars['Boolean']['output']>;
  insertSize: Maybe<Scalars['Int']['output']>;
  insertions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  mappingQuality: Maybe<Scalars['Int']['output']>;
  mateMapped: Maybe<Scalars['Boolean']['output']>;
  mateReferenceName: Maybe<Scalars['String']['output']>;
  mateStart: Maybe<Scalars['Int']['output']>;
  mateStrand: Maybe<Scalars['String']['output']>;
  paired: Maybe<Scalars['Boolean']['output']>;
  percentGC: Maybe<Scalars['Int']['output']>;
  properPaired: Maybe<Scalars['Boolean']['output']>;
  readGroup: Maybe<Scalars['String']['output']>;
  referenceName: Maybe<Scalars['String']['output']>;
  secondary: Maybe<Scalars['Boolean']['output']>;
  strand: Maybe<Scalars['String']['output']>;
  templateStrand: Maybe<Scalars['String']['output']>;
};

/** A mutation object. */
export type GenMutation = PageRow & {
  groupType: Scalars['String']['output'];
  /** Flag - true if there are gene mutations for the reference genome perspective. */
  hasAffectedGenes: Maybe<Scalars['Boolean']['output']>;
  /** Flag - true if there are protein mutations for the reference genome perspective. */
  hasAffectedProteins: Maybe<Scalars['Boolean']['output']>;
  /** Flag - true if there are mutations for the reference genome perspective. */
  hasRelatedMutations: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  /** The variants from the mutant genomes with the reference perspective that are present. */
  mutVariants: Maybe<Array<Maybe<Variant>>>;
  /** The variant on the reference genome with the reference perspective. */
  refVariant: Maybe<Variant>;
  relatedProjects: Maybe<Array<Maybe<RelatedProject>>>;
};

/** Gene object for gene table rows */
export type Gene = PageRow & {
  allClassifications: Maybe<Array<Maybe<Classification>>>;
  /** All external references except literature for use in summary pages. */
  allExternalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  classification: Maybe<Array<Maybe<Classification>>>;
  database: Maybe<Database>;
  description: Maybe<Scalars['String']['output']>;
  /** External references except literature */
  externalReference: Maybe<Array<Maybe<ExternalReference>>>;
  /** External references except literature */
  externalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  geneType: Maybe<Scalars['String']['output']>;
  genome: Maybe<Organism>;
  groupType: Scalars['String']['output'];
  hasVariants: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  length: Maybe<Scalars['Int']['output']>;
  /** External references of type literature */
  literatureReferences: Maybe<Array<Maybe<ExternalReference>>>;
  name: Maybe<Scalars['String']['output']>;
  proteinLocations: Maybe<Array<Maybe<ProteinLocation>>>;
  proteins: Maybe<Array<Maybe<Protein>>>;
  region: Maybe<Region>;
  relatedProjects: Maybe<Array<Maybe<RelatedProject>>>;
  /** The contig sequence for the gene region. */
  sequence: Maybe<Scalars['String']['output']>;
  strand: Maybe<Scalars['String']['output']>;
  synonyms: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  transcriptLocations: Maybe<Array<Maybe<TranscriptLocation>>>;
  transcripts: Maybe<Array<Maybe<Transcript>>>;
  userGroups: Maybe<Array<Maybe<UserGroup>>>;
};


/** Gene object for gene table rows */
export type GeneClassificationArgs = {
  classification: InputMaybe<Scalars['String']['input']>;
};


/** Gene object for gene table rows */
export type GeneExternalReferenceArgs = {
  externalReference: InputMaybe<Scalars['String']['input']>;
};


/** Gene object for gene table rows */
export type GeneSequenceArgs = {
  seqLengthLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** A gene mutation object based on an underlying gene mutation info entity. */
export type GeneMutation = PageRow & {
  classification: Maybe<Array<Maybe<Classification>>>;
  effect: Maybe<Scalars['String']['output']>;
  /** External references except literature */
  externalReference: Maybe<Array<Maybe<ExternalReference>>>;
  gene: Maybe<Gene>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  locationClass: Maybe<Scalars['String']['output']>;
  variant: Maybe<Variant>;
};


/** A gene mutation object based on an underlying gene mutation info entity. */
export type GeneMutationClassificationArgs = {
  classification: InputMaybe<Scalars['String']['input']>;
};


/** A gene mutation object based on an underlying gene mutation info entity. */
export type GeneMutationExternalReferenceArgs = {
  externalReference: InputMaybe<Scalars['String']['input']>;
};

export type GenomeAssembly = PageRow & {
  assemblyAccession: Maybe<Scalars['String']['output']>;
  assemblyName: Maybe<Scalars['String']['output']>;
  contigCount: Maybe<Scalars['Int']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  intraspecificName: Maybe<Scalars['String']['output']>;
  isolate: Maybe<Scalars['String']['output']>;
  moleculeCount: Maybe<Scalars['Int']['output']>;
  organismName: Maybe<Scalars['String']['output']>;
  releaseDate: Maybe<Scalars['String']['output']>;
  scaffoldCount: Maybe<Scalars['Int']['output']>;
  status: Maybe<Scalars['String']['output']>;
  submitter: Maybe<Scalars['String']['output']>;
  taxid: Maybe<Scalars['String']['output']>;
  totalLength: Maybe<Scalars['Long']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQuery = {
  analysisGroup: Maybe<VariantAnalysisGroup>;
  bamResources: Maybe<Array<Maybe<ProjectFile>>>;
  bamSummary: Maybe<BamSummary>;
  bedFeatures: Maybe<TrackFeatures>;
  coordinateFeatures: Maybe<TrackFeatures>;
  genomeAndSequenceStatistics: Maybe<GenomeBrowserStatistics>;
  ngsCoverage: Maybe<Array<Maybe<Coverage>>>;
  /** Get phenotypes (Tracker and Organism Property) data for genomes. If Tracker is not licensed, possible existing data is not included. */
  phenotypeTypesByOrganism: Maybe<Array<Maybe<GenomicFeature>>>;
  readTooltip: Maybe<FullPileupAlignment>;
  regionFlag: Maybe<RegionFlag>;
  selectedRegions: Maybe<Array<Maybe<Region>>>;
  trackFeatures: Maybe<TrackFeatures>;
  trackGroupAnnotations: Maybe<TrackGroupIndicator>;
  trackNgsReads: Maybe<Array<Maybe<PileupRow>>>;
  trackNuProfiles: Maybe<TrackNuProfile>;
  trackSequence: Maybe<TrackSequence>;
  trackVCFVariants: Maybe<TrackVcfVariants>;
  trackVariants: Maybe<TrackVariants>;
  validateBamReads: Maybe<Scalars['String']['output']>;
  validateBedFeatures: Maybe<Scalars['String']['output']>;
  validateContigOrVectorIsVisible: Maybe<Scalars['Boolean']['output']>;
  /** All existing phenotype values (Tracker and Organism Property) for the provided input. If Tracker is not licensed, possible existing data is not included. */
  valuesForOrganismPropertyTypesAndOrganisms: Maybe<Array<Maybe<OrganismPhenotype>>>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryAnalysisGroupArgs = {
  analysisGroupId: InputMaybe<Scalars['Long']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryBamResourcesArgs = {
  fileIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryBamSummaryArgs = {
  bamFileId: InputMaybe<Scalars['Long']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryBedFeaturesArgs = {
  bedFileId: InputMaybe<Scalars['Long']['input']>;
  contigId: InputMaybe<Scalars['Long']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  range: InputMaybe<InputRangeInput>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryCoordinateFeaturesArgs = {
  contigId: InputMaybe<Scalars['Long']['input']>;
  coordinateListId: InputMaybe<Scalars['Long']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  range: InputMaybe<InputRangeInput>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryGenomeAndSequenceStatisticsArgs = {
  genomeId: InputMaybe<Scalars['Long']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryNgsCoverageArgs = {
  BAMId: InputMaybe<Scalars['Long']['input']>;
  contigId: InputMaybe<Scalars['Long']['input']>;
  range: InputMaybe<InputRangeInput>;
  resolution: InputMaybe<Scalars['Int']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryPhenotypeTypesByOrganismArgs = {
  organismIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryReadTooltipArgs = {
  BAMId: InputMaybe<Scalars['Long']['input']>;
  pileupAlignmentStart: InputMaybe<Scalars['Int']['input']>;
  readName: InputMaybe<Scalars['String']['input']>;
  region: InputMaybe<InputRegionWithoutStrand>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryRegionFlagArgs = {
  flagId: InputMaybe<Scalars['Long']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQuerySelectedRegionsArgs = {
  featureIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  type: InputMaybe<Scalars['String']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryTrackFeaturesArgs = {
  contigId: InputMaybe<Scalars['Long']['input']>;
  datasetId?: InputMaybe<Scalars['Long']['input']>;
  featureTypeId?: InputMaybe<Scalars['Long']['input']>;
  rangeStart: InputMaybe<Scalars['Int']['input']>;
  rangeStop: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryTrackGroupAnnotationsArgs = {
  contigId: InputMaybe<Scalars['Long']['input']>;
  rangeStart: InputMaybe<Scalars['Int']['input']>;
  rangeStop: InputMaybe<Scalars['Int']['input']>;
  subTypeId?: InputMaybe<Scalars['Long']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryTrackNgsReadsArgs = {
  BAMId: InputMaybe<Scalars['Long']['input']>;
  includeSoftClipped?: InputMaybe<Scalars['Boolean']['input']>;
  lanesCount: InputMaybe<Scalars['Int']['input']>;
  maxElementCount: InputMaybe<Scalars['Int']['input']>;
  region: InputMaybe<InputRegionWithoutStrand>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryTrackNuProfilesArgs = {
  contigId: InputMaybe<Scalars['Long']['input']>;
  profileTypeId: InputMaybe<Scalars['Long']['input']>;
  rangeStart: InputMaybe<Scalars['Int']['input']>;
  rangeStop: InputMaybe<Scalars['Int']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryTrackSequenceArgs = {
  contigId: InputMaybe<Scalars['Long']['input']>;
  rangeStart: InputMaybe<Scalars['Int']['input']>;
  rangeStop: InputMaybe<Scalars['Int']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryTrackVcfVariantsArgs = {
  contigId: InputMaybe<Scalars['Long']['input']>;
  filterExpression?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  rangeStart: InputMaybe<Scalars['Int']['input']>;
  rangeStop: InputMaybe<Scalars['Int']['input']>;
  refGenomeId?: InputMaybe<Scalars['Long']['input']>;
  varGenomeIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryTrackVariantsArgs = {
  contigId: InputMaybe<Scalars['Long']['input']>;
  filterExpression?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  rangeStart: InputMaybe<Scalars['Int']['input']>;
  rangeStop: InputMaybe<Scalars['Int']['input']>;
  refGenomeId?: InputMaybe<Scalars['Long']['input']>;
  varGenomeIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryValidateBamReadsArgs = {
  BAMId: InputMaybe<Scalars['Long']['input']>;
  organismId: Scalars['Long']['input'];
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryValidateBedFeaturesArgs = {
  BEDId: InputMaybe<Scalars['Long']['input']>;
  organismId: Scalars['Long']['input'];
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryValidateContigOrVectorIsVisibleArgs = {
  contigOrVectorId: InputMaybe<Scalars['Long']['input']>;
  projectId: InputMaybe<Scalars['Long']['input']>;
};


/** The container for the data query endpoints of the Genome Viewer. */
export type GenomeBrowserQueryValuesForOrganismPropertyTypesAndOrganismsArgs = {
  attributeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  organismIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  organismPropertyTypeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Combined statistics on all sequences that may be displayed in the Genome Browser */
export type GenomeBrowserStatistics = {
  aaFeaturesCount: Maybe<Array<Maybe<AaFeatureStats>>>;
  geneCount: Maybe<Scalars['Long']['output']>;
  hasGenomeAnalysis: Maybe<Scalars['Boolean']['output']>;
  hasVcfGenomeAnalysis: Maybe<Scalars['Boolean']['output']>;
  markersCount: Maybe<Array<Maybe<MarkerStats>>>;
  nuFeaturesCount: Maybe<Array<Maybe<NuFeatureStats>>>;
  nuProfilesCount: Maybe<Array<Maybe<NuProfileStats>>>;
  proteinsCount: Maybe<Scalars['Long']['output']>;
  transcriptsCount: Maybe<Scalars['Long']['output']>;
  variantsCount: Maybe<Scalars['Long']['output']>;
};

export type GenomeConstraints = Constraints & {
  allowedTypes: Maybe<Array<SequencingTypeEnum>>;
  genomeSelectionType: Maybe<Array<GenomeSelectionTypeEnum>>;
  id: Maybe<Scalars['String']['output']>;
};

export type GenomeParam = ActivityParameter & {
  constraints: Maybe<GenomeConstraints>;
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  multiSelect: Scalars['Boolean']['output'];
  optional: Scalars['Boolean']['output'];
  type: WorkflowParameterTypeEnum;
};

/** The genome found by a hibernate search. */
export type GenomeSearch = {
  genomes: Array<Organism>;
  limit: Maybe<Scalars['Int']['output']>;
  searchTerm: Maybe<Scalars['String']['output']>;
};

export enum GenomeSelectionTypeEnum {
  /** DATABASE */
  Database = 'DATABASE',
  /** FILE */
  File = 'FILE',
  /** FOLDER */
  Folder = 'FOLDER'
}

/** GenomeStatistics object for Genomic Annotations Card */
export type GenomeStatistics = {
  aaFeaturesCount: Maybe<Array<Maybe<AaFeatureStats>>>;
  /** Counts all CDS from the genome */
  cdsCount: Maybe<Scalars['Long']['output']>;
  contigCount: Maybe<Scalars['Long']['output']>;
  ecCoverage: Maybe<Scalars['Float']['output']>;
  ecProteinAssignmentsCount: Maybe<Scalars['Long']['output']>;
  ecProteinAssignmentsDistinctCount: Maybe<Scalars['Long']['output']>;
  /** Counts all exons (transcript mappings) from the genome */
  exonCount: Maybe<Scalars['Long']['output']>;
  flagCount: Maybe<Scalars['Long']['output']>;
  geneCount: Maybe<Scalars['Long']['output']>;
  /** Counts all genes from the genome, except type pseudogene */
  geneWithoutPseudogeneCount: Maybe<Scalars['Long']['output']>;
  genesLinkedProteinsCount: Maybe<Scalars['Long']['output']>;
  genesLinkedTranscriptsCount: Maybe<Scalars['Long']['output']>;
  genomeSize: Maybe<Scalars['Long']['output']>;
  /** Counts all lncRNA transcripts from the genome */
  lncrnaCount: Maybe<Scalars['Long']['output']>;
  markersCount: Maybe<Array<Maybe<MarkerStats>>>;
  /** Counts all mRNA transcripts from the genome */
  mrnaCount: Maybe<Scalars['Long']['output']>;
  /** Counts all ncRNA transcripts from the genome */
  ncrnaCount: Maybe<Scalars['Long']['output']>;
  nuFeaturesCount: Maybe<Array<Maybe<NuFeatureStats>>>;
  nuProfilesCount: Maybe<Array<Maybe<NuProfileStats>>>;
  orfsCount: Maybe<Scalars['Long']['output']>;
  proteinsCount: Maybe<Scalars['Long']['output']>;
  /** Counts all pseudogenes from the genome */
  pseudogeneCount: Maybe<Scalars['Long']['output']>;
  /** Counts all rRNA transcripts from the genome */
  rrnaCount: Maybe<Scalars['Long']['output']>;
  /** Counts all snoRNA transcripts from the genome */
  snornaCount: Maybe<Scalars['Long']['output']>;
  /** Counts all snRNA transcripts from the genome */
  snrnaCount: Maybe<Scalars['Long']['output']>;
  transcriptsCount: Maybe<Scalars['Long']['output']>;
  /** Counts all tRNA transcripts from the genome */
  trnaCount: Maybe<Scalars['Long']['output']>;
  variantsCount: Maybe<Scalars['Long']['output']>;
};

export type GenomeValue = ParameterValue & {
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  value: Array<Maybe<Organism>>;
};

/** The expanded genome view state object */
export type GenomeViewState = {
  blastHit: Maybe<GenomeViewStateBlastHit>;
  condensedFlagsDisplay: Maybe<Scalars['Boolean']['output']>;
  contig: Maybe<Contig>;
  featureTableRestriction: Maybe<Scalars['String']['output']>;
  genome: Maybe<Organism>;
  headerWidth: Maybe<Scalars['Long']['output']>;
  hideFeatureTable: Maybe<Scalars['Boolean']['output']>;
  orderedMutantGenomes: Maybe<Array<Maybe<Organism>>>;
  range: Maybe<Range>;
  refGenome: Maybe<Organism>;
  showCommunityAnnotation: Maybe<Scalars['Boolean']['output']>;
  showFlags: Maybe<Scalars['Boolean']['output']>;
  tableView: Maybe<TableViewState>;
  tracks: Maybe<Array<Maybe<Track>>>;
  useSpecificFlagsColoring: Maybe<Scalars['Boolean']['output']>;
  variantExpressionFilters: Maybe<Scalars['String']['output']>;
  verticalLayout: Maybe<Scalars['Boolean']['output']>;
};

/** Reference to a single blast hit in a job */
export type GenomeViewStateBlastHit = {
  hitNum: Maybe<Scalars['Int']['output']>;
  jobId: Maybe<Scalars['Long']['output']>;
  queryId: Maybe<Scalars['Long']['output']>;
};

export type GenomeViewerUiContext = PlaybookUiContext & {
  context: UiContextEnum;
  genomeParam: ParameterMapping;
  regionParam: ParameterMapping;
};

export type GenomeViewerVariantTrackUiContext = PlaybookUiContext & {
  context: UiContextEnum;
  genomeParam: ParameterMapping;
  tableParam: ParameterMapping;
};

export type GenomicFeature = {
  description: Maybe<Scalars['String']['output']>;
  discreteValues: Maybe<Array<Maybe<Phenotype>>>;
  groupDescription: Maybe<Scalars['String']['output']>;
  groupName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  idType: Maybe<Scalars['String']['output']>;
  isDiscrete: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  valueType: Maybe<Scalars['String']['output']>;
};

/** The global search result */
export type GlobalSearchSuggestions = {
  categories: Maybe<Array<Maybe<Category>>>;
  searchTerm: Maybe<Scalars['String']['output']>;
};

/** A group of entities such as genes, transcripts or proteins */
export type Group = SavedItem & {
  analysisGroup: Maybe<VariantAnalysisGroup>;
  created: Scalars['String']['output'];
  creator: Maybe<User>;
  deletable: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  firstItemId: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  itemCount: Maybe<Scalars['Int']['output']>;
  itemSubTypeId: Maybe<Scalars['Long']['output']>;
  itemTags: Maybe<Array<Maybe<ItemTag>>>;
  modified: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
  samples: Maybe<Array<Maybe<Sample>>>;
  shared: Maybe<Scalars['Boolean']['output']>;
  temporary: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<Scalars['String']['output']>;
  typeDisplayName: Maybe<Scalars['String']['output']>;
  typeId: Maybe<Scalars['Long']['output']>;
};

/** A list of saved groups */
export type GroupList = {
  itemCount: Maybe<Scalars['Int']['output']>;
  items: Maybe<Array<Maybe<Group>>>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** Group notification data object */
export type GroupNotification = {
  description: Scalars['String']['output'];
  group: Maybe<Group>;
  id: Scalars['Long']['output'];
  producer: Scalars['String']['output'];
};

/** A pair of id and range. */
export type IdRangePair = {
  id: Maybe<Scalars['Long']['output']>;
  range: Maybe<Range>;
};

/** Contains a list of ids and a mode that determines how  */
export type IdSelection = {
  /** The intersection mode of the given ids with the other restrictions. */
  mode: Maybe<Scalars['String']['output']>;
  selectedResultIds: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
};

export type InaccessibleActivityResourcesData = {
  activityIdentifier: Scalars['String']['output'];
  files: Array<Maybe<ProjectFile>>;
  organisms: Array<Maybe<Organism>>;
};

export enum IndexStatus {
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** EXISTS */
  Exists = 'EXISTS',
  /** FAILED */
  Failed = 'FAILED',
  /** FAILED_NOT_SORTED */
  FailedNotSorted = 'FAILED_NOT_SORTED',
  /** INDEXING */
  Indexing = 'INDEXING',
  /** MISSING */
  Missing = 'MISSING'
}

/** DTO containing the most basic elements of an activity parameter input. */
export type InputActivityBasicParameterInput = {
  identifier: Scalars['String']['input'];
  values?: InputMaybe<InputValueWrapperInput>;
};

export type InputActivityExtendedInstanceInput = {
  identifier: Scalars['String']['input'];
  parameters?: InputMaybe<Array<InputMaybe<InputActivityExtendedParameterInput>>>;
};

export type InputActivityExtendedParameterInput = {
  constraints?: InputMaybe<InputConstraintsWrapperInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Short']['input']>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  values?: InputMaybe<InputValueWrapperInput>;
};

export type InputActivityIo = ActivityIo & {
  compatibleTypes: Array<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  maxConnections: Maybe<Scalars['Int']['output']>;
  minConnections: Scalars['Int']['output'];
  optional: Scalars['Boolean']['output'];
};

export type InputActivityInstanceInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  executor?: InputMaybe<SupportedExecutorsEnum>;
  identifier: Scalars['String']['input'];
  metadata: InputMetadata;
  name: Scalars['String']['input'];
  parameters: Array<InputActivityParameterInput>;
  skipped?: InputMaybe<Scalars['Boolean']['input']>;
  version: Scalars['String']['input'];
};

export type InputActivityParameterInput = {
  identifier: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  values?: InputMaybe<InputValueWrapperInput>;
};

/** The input object for adding users. */
export type InputAddProjectMemberInput = {
  emailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['Long']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Input data parameters for an advanced search */
export type InputAdvancedSearchInput = {
  attributesQueryExpression?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  quickSearchQuery?: InputMaybe<Scalars['String']['input']>;
  restrictionType?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<Scalars['String']['input']>;
  searchSubTypeId?: InputMaybe<Scalars['Long']['input']>;
  searchType?: InputMaybe<Scalars['String']['input']>;
};

/** Input object for mapping ids for launching analyzers. */
export type InputAnalyzerIdMappingInput = {
  inputEntityType?: InputMaybe<Scalars['String']['input']>;
  inputIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  resultEntityTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** An attribute default to be saved. */
export type InputAttributeDefaultInput = {
  defaultNumber?: InputMaybe<Scalars['Float']['input']>;
  defaultText?: InputMaybe<Scalars['String']['input']>;
  defaultVocabularyTermId?: InputMaybe<Scalars['Long']['input']>;
  template?: InputMaybe<Scalars['String']['input']>;
};

/** Input object for creating a new attribute. */
export type InputAttributeInput = {
  attributeTypeId?: InputMaybe<Scalars['Long']['input']>;
  automatic?: InputMaybe<Scalars['Boolean']['input']>;
  coloringRule?: InputMaybe<Scalars['String']['input']>;
  columnSetId?: InputMaybe<Scalars['Long']['input']>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  editOnce?: InputMaybe<Scalars['Boolean']['input']>;
  fileTypeId?: InputMaybe<Scalars['Long']['input']>;
  formulaText?: InputMaybe<Scalars['String']['input']>;
  frozen?: InputMaybe<Scalars['Boolean']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  /** The id if the attribute already exists, null otherwise */
  id?: InputMaybe<Scalars['Long']['input']>;
  idAccessor?: InputMaybe<Scalars['String']['input']>;
  isHead?: InputMaybe<Scalars['Boolean']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
  modifiable?: InputMaybe<Scalars['Boolean']['input']>;
  multipleValues?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  patternHint?: InputMaybe<Scalars['String']['input']>;
  sqlStatement?: InputMaybe<Scalars['String']['input']>;
  vocabularyTerms?: InputMaybe<Array<InputMaybe<InputVocabularyTermInput>>>;
};

/** An attribute to be saved. */
export type InputAttributeValueInput = {
  attributeId?: InputMaybe<Scalars['Long']['input']>;
  attributeTypeId?: InputMaybe<Scalars['Long']['input']>;
  dateValue?: InputMaybe<Scalars['String']['input']>;
  dynamicTerm?: InputMaybe<InputDynamicTerm>;
  numberValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  projectFilePath?: InputMaybe<Scalars['String']['input']>;
  textValue?: InputMaybe<Scalars['String']['input']>;
  vocabularyTermId?: InputMaybe<Scalars['Long']['input']>;
};

/** The raw formatted advanced BLAST options, for input. */
export type InputBlastAdvancedOptionsInput = {
  compositionalAdjustments?: InputMaybe<Scalars['String']['input']>;
  expectThreshold?: InputMaybe<Scalars['Float']['input']>;
  filterLowComplexity?: InputMaybe<Scalars['Boolean']['input']>;
  gapCost?: InputMaybe<Scalars['String']['input']>;
  genCode?: InputMaybe<Scalars['Int']['input']>;
  maskLower?: InputMaybe<Scalars['Boolean']['input']>;
  maskTable?: InputMaybe<Scalars['Boolean']['input']>;
  matchMismatchScores?: InputMaybe<Scalars['String']['input']>;
  matrix?: InputMaybe<Scalars['String']['input']>;
  /** The max number of HSPs per hit */
  maxMatches?: InputMaybe<Scalars['Int']['input']>;
  /** The number of hits */
  maxTargetSeqs?: InputMaybe<Scalars['Int']['input']>;
  shortQueries?: InputMaybe<Scalars['Boolean']['input']>;
  wordSize?: InputMaybe<Scalars['Int']['input']>;
};

/** The BLAST index input data object */
export type InputBlastIndexInput = {
  dbSize?: InputMaybe<Scalars['Long']['input']>;
  /** Either ORS_ID, DBS_ID, EXY_ID, or EXD_ID depending on the type of the index */
  id?: InputMaybe<Scalars['Long']['input']>;
  indexName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  secondaryName?: InputMaybe<Scalars['String']['input']>;
  sequenceType?: InputMaybe<Scalars['String']['input']>;
  /** Either genome, database or extDatabase depending on the source table */
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** Genome indexes can be virtual */
  virtual?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input parameters for a BLAST run. */
export type InputBlastParamsInput = {
  advancedOptions?: InputMaybe<InputBlastAdvancedOptionsInput>;
  blastType?: InputMaybe<Scalars['String']['input']>;
  /** Possibly empty list of uploaded files */
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** List of stringified BlastIndex input elements. */
  indexes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** content of textarea (seq or accessions) */
  sequenceQuery?: InputMaybe<Scalars['String']['input']>;
  /** List of the blast index data for output. */
  targets?: InputMaybe<Array<InputMaybe<InputBlastIndexInput>>>;
};

/** View state of the blast input page. */
export type InputBlastViewStateInput = {
  colorMismatchesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['Long']['input']>;
};

/** A chart layout input state */
export type InputChartLayoutStateInput = {
  chartType?: InputMaybe<Scalars['String']['input']>;
  errorBars?: InputMaybe<Scalars['Boolean']['input']>;
  filterOutEmptyValues?: InputMaybe<Scalars['Boolean']['input']>;
  isLogScale?: InputMaybe<Scalars['Boolean']['input']>;
  symbolSize?: InputMaybe<Scalars['Float']['input']>;
  timeSeries?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents color scheme data e.g. for track features customization. */
export type InputColorScheme = {
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The minimal column input data with the essential information for templates. */
export type InputColumnInput = {
  columnId?: InputMaybe<Scalars['Long']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  namespace?: InputMaybe<Scalars['Int']['input']>;
};

/** Column information required for views */
export type InputColumnView = {
  field?: InputMaybe<Scalars['String']['input']>;
  rowFilter?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<InputSortData>;
};

export type InputConnector = {
  input?: InputMaybe<Scalars['String']['input']>;
  output?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  target: Scalars['String']['input'];
};

export type InputConstraintsWrapperInput = {
  sequencedGenomeTypes?: InputMaybe<Array<SequencingTypeEnum>>;
};

/** Minimal input required to build a content browser view. */
export type InputContentBrowserViewStateInput = {
  featureType?: InputMaybe<Scalars['String']['input']>;
  groupByAttribute?: InputMaybe<Scalars['String']['input']>;
  selectedEntry?: InputMaybe<InputListingMapEntryInput>;
  tableView?: InputMaybe<InputTableViewStateInput>;
};

/** The input format used for coordinate list creation. */
export type InputCoordinateListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['String']['input'];
  genomeId: Scalars['Long']['input'];
  itemTagIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  name: Scalars['String']['input'];
  projectId: Scalars['Long']['input'];
};

/** Input data for creating a group */
export type InputCreateGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  itemTagIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Long']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  tableQuerySpec?: InputMaybe<InputTableQuerySpec>;
  targetType?: InputMaybe<Scalars['String']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input data for modifying a dashboard configuration */
export type InputDashboardInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** Minimal input required to build a dataset view. */
export type InputDatasetViewStateInput = {
  chartLayoutState?: InputMaybe<InputChartLayoutStateInput>;
  chartSelection?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  chartTableSelection?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  datasetId?: InputMaybe<Scalars['Long']['input']>;
  filteredOutAnnotations?: InputMaybe<Scalars['String']['input']>;
  groupMode?: InputMaybe<Scalars['Boolean']['input']>;
  groupTableViewState?: InputMaybe<InputTableViewStateInput>;
  hideEmptyDataSeries?: InputMaybe<Scalars['Boolean']['input']>;
  selectedAnnotations?: InputMaybe<Scalars['String']['input']>;
  selectedDataSeries?: InputMaybe<Scalars['String']['input']>;
  showFilterPanel?: InputMaybe<Scalars['Boolean']['input']>;
  splitPaneLayoutState?: InputMaybe<InputSplitPaneLayoutStateInput>;
};

/** Represents a dynamic vocabulary term. */
export type InputDynamicTerm = {
  id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputEditParentInput = {
  parentAttributes?: InputMaybe<Array<InputMaybe<InputAttributeValueInput>>>;
  parentId?: InputMaybe<Scalars['Long']['input']>;
};

/** Input object for the samples to be edited. */
export type InputEditSamplesInput = {
  samples?: InputMaybe<Array<InputMaybe<InputSampleInput>>>;
  statusForSampleTypes?: InputMaybe<Array<InputMaybe<InputStatusForSampleType>>>;
};

/** View state of an entity summary page page. */
export type InputEntitySummaryViewStateInput = {
  blastView?: InputMaybe<InputBlastViewStateInput>;
  id?: InputMaybe<Scalars['Long']['input']>;
  refGenomeId?: InputMaybe<Scalars['Long']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InputExperimentInput = {
  correctedMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  correctedTypeId?: InputMaybe<Scalars['Long']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  trackerAttributeId?: InputMaybe<Scalars['Long']['input']>;
  workflowParamDefault?: InputMaybe<Scalars['String']['input']>;
  workflowParamId?: InputMaybe<Scalars['String']['input']>;
};

/** Input data parameters for installing a list of NCBI genome assemblies */
export type InputGenomeAssembliesInput = {
  assemblies?: InputMaybe<Array<InputMaybe<InputNcbiParamsInputData>>>;
};

/** Input reference to a single blast hit in a job */
export type InputGenomeViewStateBlastHitInput = {
  hitNum?: InputMaybe<Scalars['Int']['input']>;
  jobId?: InputMaybe<Scalars['Long']['input']>;
  queryId?: InputMaybe<Scalars['Long']['input']>;
};

/** Minimal input required to build a genome view. */
export type InputGenomeViewStateInput = {
  blastHit?: InputMaybe<InputGenomeViewStateBlastHitInput>;
  blastView?: InputMaybe<InputBlastViewStateInput>;
  condensedFlagsDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  contigId?: InputMaybe<Scalars['Long']['input']>;
  featureTableRestriction?: InputMaybe<Scalars['String']['input']>;
  genomeId?: InputMaybe<Scalars['Long']['input']>;
  headerWidth?: InputMaybe<Scalars['Long']['input']>;
  hideFeatureTable?: InputMaybe<Scalars['Boolean']['input']>;
  orderedMutantGenomes?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  range?: InputMaybe<InputRangeInput2>;
  refGenomeId?: InputMaybe<Scalars['Long']['input']>;
  showCommunityAnnotation?: InputMaybe<Scalars['Boolean']['input']>;
  showFlags?: InputMaybe<Scalars['Boolean']['input']>;
  tableView?: InputMaybe<InputTableViewStateInput>;
  tracks?: InputMaybe<Array<InputMaybe<InputTrack>>>;
  useSpecificFlagsColoring?: InputMaybe<Scalars['Boolean']['input']>;
  variantExpressionFilters?: InputMaybe<Scalars['String']['input']>;
  verticalLayout?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains a list of ids and a mode that determines how  */
export type InputIdSelection = {
  /** The intersection mode of the given ids with the other restrictions. */
  mode?: InputMaybe<Scalars['String']['input']>;
  selectedResultIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** The input format used for tag creation. */
export type InputItemTagInput = {
  colour?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['Long']['input'];
};

/** The specification of a job to run. */
export type InputJobInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<InputJobParamsInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** The parameters input object of the job. */
export type InputJobParamsInput = {
  blast?: InputMaybe<InputBlastParamsInput>;
};

/** The necessary information to validate the input of a job. */
export type InputJobValidation = {
  /** The type of blast that is being used */
  blastType?: InputMaybe<Scalars['String']['input']>;
  /** The file input */
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The text input */
  sequenceQuery?: InputMaybe<Scalars['String']['input']>;
  /** The job type */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** A map entry with a number value and a column field. */
export type InputListingMapEntryInput = {
  columnField?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  tableFilter?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type InputMetadata = {
  position: InputPosition;
  width: Scalars['Long']['input'];
};

export type InputModifyOrganismInput = {
  organismId?: InputMaybe<Scalars['Long']['input']>;
  organismProperties?: InputMaybe<Array<InputMaybe<InputOrganismPropertyInput>>>;
};

export type InputModifyPlaybookEventInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['Long']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

/** Input object for project file edit data */
export type InputModifyProjectFileInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  isProtected?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organismIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Input object for project edit data */
export type InputModifyProjectInput = {
  actualEndDate?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endNote?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  initialEndDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyMembers?: InputMaybe<Scalars['Boolean']['input']>;
  projectedEndDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusNote?: InputMaybe<Scalars['String']['input']>;
};

/** Input object for saved item edit data */
export type InputModifySavedItemInput = {
  dataHeader?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
  itemTagIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organismIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  sampleIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InputNfParamInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<InputNfParamTypeInput>;
  values?: InputMaybe<Array<InputMaybe<InputNfParamValueInput>>>;
};

export type InputNfParamTypeInput = {
  subType?: InputMaybe<NfParamSubTypeEnum>;
  type?: InputMaybe<NfParamTypeEnum>;
};

export type InputNfParamValueInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  cfiId?: InputMaybe<Scalars['Long']['input']>;
  genome?: InputMaybe<InputPlaybookGenomeInput>;
  numberValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  region?: InputMaybe<InputRegionWithoutStrand>;
  tableQuerySpec?: InputMaybe<InputTableQuerySpec>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Nextflow activity attributes. */
export type InputNfPlaybookActivity = {
  cloudEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hpcEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputNfPlaybookConfigInput = {
  activities?: InputMaybe<Array<InputMaybe<InputNfPlaybookActivity>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trackerParameters?: InputMaybe<InputNfTrackerParamInput>;
  workflowName?: InputMaybe<Scalars['String']['input']>;
  workflowParameters?: InputMaybe<Array<InputMaybe<InputNfParamInput>>>;
};

export type InputNfSampleAttributeInput = {
  attributeId?: InputMaybe<Scalars['Long']['input']>;
  correctedMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  workflowParam?: InputMaybe<Scalars['String']['input']>;
};

export type InputNfTrackerParamInput = {
  sampleAttributes?: InputMaybe<Array<InputMaybe<InputNfSampleAttributeInput>>>;
};

export type InputNgsWorkflow = {
  workflowExportMappings?: InputMaybe<Array<InputMaybe<InputWorkflowExportMapping>>>;
  workflowId?: InputMaybe<Scalars['String']['input']>;
  workflowImportMappings?: InputMaybe<Array<InputMaybe<InputWorkflowParamAttributeMapping>>>;
};

/** Input parameters for a Ncbi run. */
export type InputNcbiParamsInputData = {
  assembly?: InputMaybe<Scalars['String']['input']>;
  database?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  kingdom?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  strain?: InputMaybe<Scalars['String']['input']>;
  taxonomy?: InputMaybe<Scalars['String']['input']>;
};

export type InputOrganismPropertyGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Short']['input']>;
};

export type InputOrganismPropertyInput = {
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  numValue?: InputMaybe<Scalars['BigDecimal']['input']>;
  /** The id if the organism property already exists, null otherwise */
  opoId?: InputMaybe<Scalars['Long']['input']>;
  orgPropertyTypeId?: InputMaybe<Scalars['Long']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InputOrganismPropertyTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<InputOrganismPropertyGroupInput>;
  /** The id if the organism property type already exists, null otherwise */
  id?: InputMaybe<Scalars['Long']['input']>;
  isDiscrete?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  predefinedOrgProperties?: InputMaybe<Array<InputMaybe<InputOrganismPropertyInput>>>;
  sortOrder?: InputMaybe<Scalars['Short']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type InputP2PlaybookConfigInput = {
  activitiesConfig?: InputMaybe<Array<InputMaybe<InputActivityExtendedInstanceInput>>>;
  contexts: Array<InputMaybe<InputPlaybookParametersUiWrapperInput>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['Long']['input']>;
};

export type InputPaginationInput = {
  /** The number of elements to fetch */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The number of items to skip */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type InputParameterMappingInput = {
  instanceId: Scalars['String']['input'];
  parameterId: Scalars['String']['input'];
};

/** Input object for creating samples from a parent */
export type InputParentInput = {
  parentAttributes?: InputMaybe<Array<InputMaybe<InputAttributeValueInput>>>;
  parentId?: InputMaybe<Scalars['Long']['input']>;
  parentTypeId?: InputMaybe<Scalars['Long']['input']>;
  /** The status for all contained samples */
  sampleStatusId?: InputMaybe<Scalars['Long']['input']>;
  sampleTypeId?: InputMaybe<Scalars['Long']['input']>;
  samples?: InputMaybe<Array<InputMaybe<InputSampleInput>>>;
};

/** A parent type to be created. */
export type InputParentTypeInput = {
  attributes?: InputMaybe<Array<InputMaybe<InputTypeAttributeInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The id if the parent type already exists, null otherwise */
  id?: InputMaybe<Scalars['Long']['input']>;
  isListed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A parent type set. */
export type InputParentTypeSetInput = {
  automatic?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the sample type if it already exists, null otherwise */
  id?: InputMaybe<Scalars['Long']['input']>;
  mandatory?: InputMaybe<Scalars['Boolean']['input']>;
  parentType?: InputMaybe<InputParentTypeInput>;
  recyclable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains the activity execution parameters. */
export type InputPlaybookActivityInput = {
  identifier: Scalars['String']['input'];
  parameters?: InputMaybe<Array<InputMaybe<InputActivityBasicParameterInput>>>;
};

/** Contains the attribute playbook. */
export type InputPlaybookAttributeInput = {
  attributeDefault?: InputMaybe<InputAttributeDefaultInput>;
  attributeId?: InputMaybe<Scalars['Long']['input']>;
};

export type InputPlaybookCategoryInput = {
  id?: InputMaybe<Scalars['Long']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** The JSON playbook configuration */
export type InputPlaybookConfig = {
  experimentInput?: InputMaybe<Array<InputMaybe<InputExperimentInput>>>;
  icon?: InputMaybe<Scalars['String']['input']>;
  ngsWorkflow?: InputMaybe<InputNgsWorkflow>;
  sampleInput?: InputMaybe<Array<InputMaybe<InputExperimentInput>>>;
  sampleStatus?: InputMaybe<InputPlaybookSampleStatuses>;
};

/** Contains information for making a playbook event. */
export type InputPlaybookEventInput = {
  /** Contains the activities configurations for the current Playbook execution. */
  activities?: InputMaybe<Array<InputMaybe<InputPlaybookActivityInput>>>;
  alias?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  playbookId?: InputMaybe<Scalars['Long']['input']>;
  projectId?: InputMaybe<Scalars['Long']['input']>;
};

/** Possible genome inputs of a playbook */
export type InputPlaybookGenomeInput = {
  fileId?: InputMaybe<Scalars['Long']['input']>;
  genomeId?: InputMaybe<Scalars['Long']['input']>;
};

/** Contains all information for making a playbook. */
export type InputPlaybookInput = {
  /** The P1 playbook configuration */
  config?: InputMaybe<InputPlaybookConfig>;
  /** The description text for this playbook */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The help link for this playbook */
  helpLink?: InputMaybe<Scalars['String']['input']>;
  /** The name of the playbook */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional playbook name suffix. */
  nameSuffix?: InputMaybe<Scalars['String']['input']>;
  /** The NF playbook configuration */
  nfConfig?: InputMaybe<InputNfPlaybookConfigInput>;
  /** The P2 playbook configuration */
  p2Config?: InputMaybe<InputP2PlaybookConfigInput>;
  /** All attributes that are contained in the  playbook with optional default values */
  playbookAttributes?: InputMaybe<Array<InputMaybe<InputPlaybookAttributeInput>>>;
  /** The playbook categories to which the playbook should belong. */
  playbookCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  /** Playbook modification needs the ID of the existing playbook. */
  playbookId?: InputMaybe<Scalars['Long']['input']>;
  /** The id of the associated playbook type */
  playbookType?: InputMaybe<Scalars['Long']['input']>;
  /** The id of the associated sample type, only required for sample type playbook. */
  sampleType?: InputMaybe<Scalars['Long']['input']>;
  /** The tooltip text for this playbook */
  tooltip?: InputMaybe<Scalars['String']['input']>;
};

export type InputPlaybookParametersUiWrapperInput = {
  context: UiContextEnum;
  genomeParam?: InputMaybe<InputParameterMappingInput>;
  genomicRegionParam?: InputMaybe<InputParameterMappingInput>;
  tableParam?: InputMaybe<InputParameterMappingInput>;
};

export type InputPlaybookSampleStatuses = {
  afterCompletion?: InputMaybe<Scalars['Long']['input']>;
  afterSubmission?: InputMaybe<Scalars['Long']['input']>;
  failure?: InputMaybe<Scalars['Long']['input']>;
  whileRunning?: InputMaybe<Scalars['Long']['input']>;
};

export type InputPosition = {
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

/** The input format used for project creation. */
export type InputProjectInput = {
  /** The capabilities to be associated with this project. In case of null, a set of default capabilities is used. */
  capabilityIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  emailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userGroupId?: InputMaybe<Scalars['Long']['input']>;
  userNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Genomic range input object */
export type InputRangeInput = {
  start: Scalars['Int']['input'];
  stop: Scalars['Int']['input'];
};

/** Genomic range input object 2 */
export type InputRangeInput2 = {
  start: Scalars['Int']['input'];
  stop: Scalars['Int']['input'];
};

/** The input format used for region flag creation. */
export type InputRegionFlagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  contigId?: InputMaybe<Scalars['Long']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  itemTagIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Long']['input']>;
  rangeStart?: InputMaybe<Scalars['Int']['input']>;
  rangeStop?: InputMaybe<Scalars['Int']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The input format used for region flag update. */
export type InputRegionFlagUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  itemTagIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** An object holding sequence region input data. */
export type InputRegionInput = {
  contigId?: InputMaybe<Scalars['Long']['input']>;
  range?: InputMaybe<InputRangeInput>;
  strand?: InputMaybe<Scalars['String']['input']>;
};

export type InputRegionWithoutStrand = {
  contigId: Scalars['Long']['input'];
  range?: InputMaybe<InputRangeInput>;
};

/** The input object for removing users. */
export type InputRemoveProjectMemberInput = {
  projectId?: InputMaybe<Scalars['Long']['input']>;
  /** Id of the user that needs to be removed from the project. */
  userId?: InputMaybe<Scalars['Long']['input']>;
};

/** Contains additional restrictions for tables */
export type InputRestriction = {
  /** Analysis group for variant sub row filtering. */
  analysisGroupId?: InputMaybe<Scalars['Long']['input']>;
  /** If present, the table should be limited to the specified types. */
  organismTypes?: InputMaybe<Array<InputMaybe<SequencingTypeEnum>>>;
  /** If present, the table should be limited to the specified project. */
  projectId?: InputMaybe<Scalars['Long']['input']>;
  /** Optional org_id of the reference genome for derived variants. */
  refGenomeId?: InputMaybe<Scalars['Long']['input']>;
  /** If present, the table should be limited to the specified region. */
  region?: InputMaybe<InputRegionWithoutStrand>;
  /** The selected ids and an intersection mode */
  selection?: InputMaybe<InputIdSelection>;
  /** List of visible variant genomes for sub row filtering. */
  variantGenomeIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Input object to define a user role. */
export type InputRoleInput = {
  /** The list of capabilities to of this role. */
  capabilityIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  /** Is this role a classic role,? Read-only but tolerated on input. */
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The list of capabilities to of this role. */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type InputSampleFileMappingInput = {
  fileIds?: InputMaybe<Array<Scalars['Long']['input']>>;
  sampleId: Scalars['Long']['input'];
};

/** Input object for the sample to be saved. */
export type InputSampleInput = {
  sampleAttributes?: InputMaybe<Array<InputMaybe<InputAttributeValueInput>>>;
  sampleId?: InputMaybe<Scalars['Long']['input']>;
};

/** A sample type to be created. */
export type InputSampleTypeInput = {
  allowManualStatusChange?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<InputTypeAttributeInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The id of the sample type if it already exists, null otherwise */
  id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentTypeSetInput?: InputMaybe<Array<InputMaybe<InputParentTypeSetInput>>>;
  statusSetID?: InputMaybe<Scalars['Long']['input']>;
};

export type InputSampleValueInput = {
  attributeId?: InputMaybe<Scalars['Long']['input']>;
  sampleFileMappings?: InputMaybe<Array<InputSampleFileMappingInput>>;
};

/** Input object for validating samples to be registered or edited. */
export type InputSamplesValidationInputData = {
  attributeId?: InputMaybe<Scalars['Long']['input']>;
  sampleIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Input data for focusing the search on specific entity type */
export type InputSearchEntityTypeInput = {
  subTypeId?: InputMaybe<Scalars['Long']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input for generating a list of sequence identifiers representing features or a selected region. */
export type InputSequenceIdentifiersInput = {
  featureIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  featureType?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<InputRegionInput>;
};

/** File path and name */
export type InputSequenceUploadFileInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
};

/** The specification of a sequence upload. */
export type InputSequenceUploadInput = {
  files?: InputMaybe<Array<InputSequenceUploadFileInput>>;
  genomeName?: InputMaybe<Scalars['String']['input']>;
  sequenceType?: InputMaybe<Scalars['Long']['input']>;
  userGroupIds: Array<Scalars['Long']['input']>;
};

/** The necessary information to validate the input of a sequence upload. */
export type InputSequenceUploadValidation = {
  files?: InputMaybe<Array<InputMaybe<InputSequenceUploadFileInput>>>;
  /** The sequence type input */
  sequenceType?: InputMaybe<Scalars['String']['input']>;
};

export type InputSetComparisonGroupInput = {
  includeLeft?: InputMaybe<Scalars['Boolean']['input']>;
  includeMiddle?: InputMaybe<Scalars['Boolean']['input']>;
  includeRight?: InputMaybe<Scalars['Boolean']['input']>;
  leftGroupId?: InputMaybe<Scalars['Long']['input']>;
  leftItems?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  referenceGenomeId?: InputMaybe<Scalars['Long']['input']>;
  rightGroupId?: InputMaybe<Scalars['Long']['input']>;
  rightItems?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input data for comparing the elements of the given sets */
export type InputSetComparisonInput = {
  leftGroupId?: InputMaybe<Scalars['Long']['input']>;
  leftItems?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  referenceGenomeId?: InputMaybe<Scalars['Long']['input']>;
  rightGroupId?: InputMaybe<Scalars['Long']['input']>;
  rightItems?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Column sort definition object */
export type InputSortData = {
  direction?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/** The input props describing the layout of a split pane */
export type InputSplitPaneLayoutStateInput = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  verticalLayout?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input object for changing the status for a sample type. */
export type InputStatusForSampleType = {
  sampleTypeId?: InputMaybe<Scalars['Long']['input']>;
  statusId?: InputMaybe<Scalars['Long']['input']>;
};

/** Specifies the parameters for a request of tabular data. */
export type InputTableQuerySpec = {
  /** Primary id for defining the table. Either a group id or an entity id. */
  id?: InputMaybe<Scalars['Long']['input']>;
  /** The type of 'id', either 'GROUP' or 'ENTITY'. */
  idType?: InputMaybe<Scalars['String']['input']>;
  /** Limits the result to a single page. */
  pagination?: InputMaybe<InputPaginationInput>;
  /** The type of the entity that 'id' refers to. Only set for 'idType' ENTITY. */
  queryType?: InputMaybe<Scalars['String']['input']>;
  /** Structurally limits the table to a genome, region and or selected ids. */
  restrictions?: InputMaybe<InputRestriction>;
  /** The sub type of rows for the table. Determines the concrete table type for nuFeature/aaFeature tables. Null otherwise. */
  resultSubTypeId?: InputMaybe<Scalars['Long']['input']>;
  /** The type of rows for the table. (e.g. Gene for a gene table.) */
  resultType?: InputMaybe<Scalars['String']['input']>;
  /** The RSQL formatted filter expressions that restrict the rows for this table. */
  rowFilter?: InputMaybe<Scalars['String']['input']>;
  /** The row sort order as comma separated list of fields where the '-' prefix indicates descending order. */
  rowSorting?: InputMaybe<Scalars['String']['input']>;
};

/** View state of a table view. */
export type InputTableViewStateInput = {
  columns?: InputMaybe<Array<InputMaybe<InputColumnView>>>;
  expansionPath?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filteredRowCount?: InputMaybe<Scalars['Int']['input']>;
  rowIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  selectedIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  tableQuerySpec?: InputMaybe<InputTableQuerySpec>;
  totalRowCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a feature track. */
export type InputTrack = {
  name?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['String']['input']>;
  subTypeId?: InputMaybe<Scalars['Long']['input']>;
  trackCustomization?: InputMaybe<InputTrackCustomization>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Represents bed configuration data. */
export type InputTrackBedConfiguration = {
  orderedBedFiles?: InputMaybe<Array<InputMaybe<InputTrackBedOrderedBedFile>>>;
};

/** Represents ordered bed files data. */
export type InputTrackBedOrderedBedFile = {
  bedFileId?: InputMaybe<Scalars['Long']['input']>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
};

/** Represents coordinate configuration data. */
export type InputTrackCoordinateConfiguration = {
  orderedCoordinateLists?: InputMaybe<Array<InputMaybe<InputTrackCoordinateOrderedCoordinateList>>>;
};

/** Represents ordered coordinate lists data. */
export type InputTrackCoordinateOrderedCoordinateList = {
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  coordinateListId?: InputMaybe<Scalars['Long']['input']>;
};

/** Represents track customization data. */
export type InputTrackCustomization = {
  bedConfiguration?: InputMaybe<InputTrackBedConfiguration>;
  configuredPhenotypes?: InputMaybe<Array<InputMaybe<InputTrackPhenotypeConfiguration>>>;
  coordinateConfiguration?: InputMaybe<InputTrackCoordinateConfiguration>;
  expressionColoring?: InputMaybe<InputTrackExpressionColoring>;
  ngsConfiguration?: InputMaybe<InputTrackNgsConfiguration>;
};

/** Represents track features expression coloring data. */
export type InputTrackExpressionColoring = {
  colorScheme?: InputMaybe<InputColorScheme>;
  conditions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  datasetId?: InputMaybe<Scalars['Long']['input']>;
  logScale?: InputMaybe<Scalars['Boolean']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents ngs configuration data. */
export type InputTrackNgsConfiguration = {
  coverageConfig?: InputMaybe<InputTrackNgsCoverageConfiguration>;
  orderedBamFiles?: InputMaybe<Array<InputMaybe<InputTrackNgsOrderedBamFilesData>>>;
};

/** Represents ngs coverage configuration data. */
export type InputTrackNgsCoverageConfiguration = {
  logScale?: InputMaybe<Scalars['Boolean']['input']>;
  yAxisScaling?: InputMaybe<Scalars['String']['input']>;
  yAxisScalingMax?: InputMaybe<Scalars['Float']['input']>;
  yAxisScalingMin?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents ngs ordered bam files data. */
export type InputTrackNgsOrderedBamFilesData = {
  bamFileId?: InputMaybe<Scalars['Long']['input']>;
  coverageColor?: InputMaybe<Scalars['String']['input']>;
  pileupColoring?: InputMaybe<Scalars['String']['input']>;
  pileupDensity?: InputMaybe<Scalars['String']['input']>;
  pileupIncludeSoftClippedReads?: InputMaybe<Scalars['Boolean']['input']>;
  pileupLanesCount?: InputMaybe<Scalars['Int']['input']>;
  visiblePileup?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents phenotype display configuration data in the variants tracks. */
export type InputTrackPhenotypeConfiguration = {
  colorScheme?: InputMaybe<InputColorScheme>;
  configuredTerms?: InputMaybe<Array<InputMaybe<InputTrackPhenotypeTermConfiguration>>>;
  id?: InputMaybe<Scalars['Long']['input']>;
  idType?: InputMaybe<Scalars['String']['input']>;
  logScale?: InputMaybe<Scalars['Boolean']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents phenotype term configuration data in the variants tracks. */
export type InputTrackPhenotypeTermConfiguration = {
  color?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

/** Input object for adding an attribute to a new sample/parent type. */
export type InputTypeAttributeInput = {
  attributeDefault?: InputMaybe<InputAttributeDefaultInput>;
  attributeId?: InputMaybe<Scalars['Long']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

/** The input object for changing roles of project members. */
export type InputUpdateProjectMemberRoleInput = {
  newRoleId: Scalars['Long']['input'];
  projectId?: InputMaybe<Scalars['Long']['input']>;
  userId?: InputMaybe<Scalars['Long']['input']>;
};

/** Input DTO for user account creation and modification */
export type InputUserAccountInput = {
  authenticationMode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  /** Account modification needs the ID of an existing account. Leaving this field empty implies a new account should be created. */
  userId?: InputMaybe<Scalars['Long']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** The user group input object, used to create/modify a user group. Fields with null values are ignored. */
export type InputUserGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organismIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  sampleTypeIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  sessionIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  userGroupId?: InputMaybe<Scalars['Long']['input']>;
};

/** The input object for updating the user configuration parameters */
export type InputUserParamsInput = {
  condensedFlagsDisplay?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTracks?: InputMaybe<Array<InputMaybe<InputTrack>>>;
  firstLogin?: InputMaybe<Scalars['Boolean']['input']>;
  homeItemSortOrder?: InputMaybe<Scalars['String']['input']>;
  lastAdvancedSearchSubTypeId?: InputMaybe<Scalars['Long']['input']>;
  lastAdvancedSearchType?: InputMaybe<Scalars['String']['input']>;
  lastSaveTarget?: InputMaybe<Scalars['Long']['input']>;
  projectItemSortOrder?: InputMaybe<Scalars['String']['input']>;
  referenceGenome?: InputMaybe<Scalars['Long']['input']>;
  showCommunityAnnotations?: InputMaybe<Scalars['Boolean']['input']>;
  showFlagsTrack?: InputMaybe<Scalars['Boolean']['input']>;
  showTips?: InputMaybe<Scalars['Boolean']['input']>;
  useSpecificFlagsColoring?: InputMaybe<Scalars['Boolean']['input']>;
  wrapColumnHeaders?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Container for parameters used to change the user password. */
export type InputUserPasswordChangeRequestInput = {
  newPassword?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type InputValueWrapperInput = {
  attributeId?: InputMaybe<Scalars['Long']['input']>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateValue?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Array<Scalars['Long']['input']>>;
  numberValue?: InputMaybe<Array<Scalars['BigDecimal']['input']>>;
  organismId?: InputMaybe<Array<Scalars['Long']['input']>>;
  region?: InputMaybe<InputRegionWithoutStrand>;
  sampleValue?: InputMaybe<InputSampleValueInput>;
  textValue?: InputMaybe<Array<Scalars['String']['input']>>;
  viewId?: InputMaybe<Scalars['Long']['input']>;
};

/** The input object for storing a view. */
export type InputViewInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  itemTagIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Long']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<InputViewStateInput>;
  viewLabel?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};

/** Minimal description of the view state to be saved. */
export type InputViewStateInput = {
  blastView?: InputMaybe<InputBlastViewStateInput>;
  contentBrowserView?: InputMaybe<InputContentBrowserViewStateInput>;
  datasetView?: InputMaybe<InputDatasetViewStateInput>;
  genomeView?: InputMaybe<InputGenomeViewStateInput>;
  summaryView?: InputMaybe<InputEntitySummaryViewStateInput>;
  tableView?: InputMaybe<InputTableViewStateInput>;
};

/** The specification of a virtual genome. */
export type InputVirtualGenomeInput = {
  componentOrgIds: Array<Scalars['Long']['input']>;
  genomeDescription?: InputMaybe<Scalars['String']['input']>;
  genomeName?: InputMaybe<Scalars['String']['input']>;
  userGroupIds: Array<Scalars['Long']['input']>;
};

/** A vocabulary term to be saved. */
export type InputVocabularyTermInput = {
  /** The vot_id if the term if it already exists, null otherwise */
  id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
};

export type InputWorkflowConfigInput = {
  activities: Array<InputActivityInstanceInput>;
  connectors: Array<InputConnector>;
  defaultExecutor?: InputMaybe<SupportedExecutorsEnum>;
  sampleTypeId?: InputMaybe<Scalars['Long']['input']>;
};

export type InputWorkflowEventInput = {
  /** The workflow configuration. */
  config: InputWorkflowConfigInput;
  /** The workflow event description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The unique workflow event name */
  name: Scalars['String']['input'];
  projectId: Scalars['Long']['input'];
  retentionRule: RetentionRuleEnum;
  workflowEventId?: InputMaybe<Scalars['Long']['input']>;
  /** First Workflow execution needs the ID of the workflow. */
  workflowId?: InputMaybe<Scalars['Long']['input']>;
};

export type InputWorkflowExportMapping = {
  exportedWorkflowFieldName?: InputMaybe<Scalars['String']['input']>;
  sampleAttributeId?: InputMaybe<Scalars['Long']['input']>;
};

export type InputWorkflowInput = {
  /** The workflow configuration. */
  config: InputWorkflowConfigInput;
  /** The workflow description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The unique workflow name */
  name: Scalars['String']['input'];
  usergroupId?: InputMaybe<Scalars['Long']['input']>;
  /** Workflow modification needs the ID of the existing workflow. */
  workflowId?: InputMaybe<Scalars['Long']['input']>;
};

export type InputWorkflowParamAttributeMapping = {
  attributeId?: InputMaybe<Scalars['Long']['input']>;
  workflowFieldId?: InputMaybe<Scalars['String']['input']>;
};

export type InputWorkflowParamInput = {
  /** The internal id of the parameter within the corresponding workflow */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The unique sample name if the param is specific to  a sample, null otherwise. */
  sampleName?: InputMaybe<Scalars['String']['input']>;
  /** All values for one input field */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The input object for storing a view that will be used by a Processor workflow as an input parameter. */
export type InputWorkflowViewParamInput = {
  path: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Long']['input']>;
  state: InputViewStateInput;
  viewLabel: Scalars['String']['input'];
  viewType: Scalars['String']['input'];
  workflowEventId?: InputMaybe<Scalars['Long']['input']>;
};

/** Global search result entity */
export type Item = {
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  region: Maybe<Region>;
  subTypeId: Maybe<Scalars['Long']['output']>;
  type: Maybe<Scalars['String']['output']>;
  typeName: Maybe<Scalars['String']['output']>;
};

/** The changes for an item in a single operation */
export type ItemChange = {
  /** The list of attribute changes for this item */
  changes: Maybe<Array<Maybe<AttributeChange>>>;
  dataComponent: Maybe<DataComponent>;
  /** The audit event that contained this change. */
  event: Maybe<AuditEvent>;
  id: Maybe<Scalars['Long']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** Holds the list of groups the item is part of */
export type ItemGroupIndicator = {
  groups: Maybe<Array<Maybe<Group>>>;
  itemId: Maybe<Scalars['Long']['output']>;
};

/** A tag labelling contents in a project */
export type ItemTag = {
  color: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  project: Project;
};

/** A job object for listing in the admin section */
export type JobAdmin = {
  created: Scalars['String']['output'];
  details: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  jobId: Maybe<Scalars['Long']['output']>;
  killable: Scalars['Boolean']['output'];
  owner: User;
  status: Maybe<JobStatusEnum>;
  title: Scalars['String']['output'];
  type: JobAdminType;
};

export enum JobAdminType {
  /** PLAYBOOK_EVENT */
  PlaybookEvent = 'PLAYBOOK_EVENT',
  /** WORKFLOW_EVENT */
  WorkflowEvent = 'WORKFLOW_EVENT'
}

export type JobData = {
  /** The expiation date, or null if the job isn't scheduled for purging (yet). */
  expirationDate: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  owner: Maybe<User>;
  status: Maybe<JobStatusEnum>;
  tool: Maybe<Scalars['String']['output']>;
};

/** The parameters of the job. */
export type JobParams = {
  blast: Maybe<BlastParams>;
};

/** A generic job result */
export type JobResult = {
  blastHits: Maybe<Array<Maybe<BlastHit>>>;
  id: Maybe<Scalars['Long']['output']>;
  jobId: Maybe<Scalars['Long']['output']>;
  query: Maybe<Sequence>;
};


/** A generic job result */
export type JobResultBlastHitsArgs = {
  bestHit?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum JobStatusEnum {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** ERROR */
  Error = 'ERROR',
  /** INITIALIZING */
  Initializing = 'INITIALIZING',
  /** QUEUED */
  Queued = 'QUEUED',
  /** RUNNING */
  Running = 'RUNNING',
  /** TERMINATED */
  Terminated = 'TERMINATED'
}

/** A map entry as a pair of key and label. */
export type KeyLabel = {
  key: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

/** The license data */
export type License = {
  customerName: Maybe<Scalars['String']['output']>;
  expirationDate: Maybe<Scalars['String']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  modules: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  numberOfFreeSeats: Maybe<Scalars['Int']['output']>;
  numberOfUsers: Maybe<Scalars['Int']['output']>;
  productName: Maybe<Scalars['String']['output']>;
};

/** A map entry with a number value and a column field. */
export type ListingMapEntry = {
  columnField: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  tableFilter: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Int']['output']>;
};

/** Marker object for marker table rows */
export type Marker = PageRow & {
  created: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  markerStatus: Maybe<MarkerStatus>;
  markerType: Maybe<MarkerType>;
  modified: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Scalars['String']['output']>;
  regions: Maybe<Array<Maybe<Region>>>;
  relatedProjects: Maybe<Array<Maybe<RelatedProject>>>;
  sequenceContent: Maybe<Scalars['String']['output']>;
  species: Maybe<Species>;
  synonyms: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Marker location object */
export type MarkerNus = PageRow & {
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  marker: Maybe<Marker>;
  region: Maybe<Region>;
};

/** MarkerStats object for marker table rows */
export type MarkerStats = {
  count: Maybe<Scalars['Long']['output']>;
  markerTypeId: Maybe<Scalars['Long']['output']>;
  markerTypeName: Maybe<Scalars['String']['output']>;
};

/** MarkerStatus object for marker table rows */
export type MarkerStatus = {
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** The summary information for a specific MarkerTypeData */
export type MarkerType = {
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type Metadata = {
  position: Position;
  width: Scalars['Long']['output'];
};

/** Root object for all GraphQL mutations */
export type Mutation = {
  /** The container for the data endpoints that require admin privileges. */
  admin: Maybe<AdminMutation>;
  administrateProject: Maybe<ProjectManagement>;
  copyGroups: Maybe<Scalars['Boolean']['output']>;
  copyProjectFiles: Maybe<Scalars['Boolean']['output']>;
  copyRegionFlags: Maybe<Scalars['Boolean']['output']>;
  copyViews: Maybe<Scalars['Boolean']['output']>;
  /** Save coordinates list. */
  createCoordinateList: Maybe<CoordinateList>;
  createGroup: Maybe<Group>;
  createGroupFromSets: Maybe<Scalars['Long']['output']>;
  createOrUpdateTag: Maybe<ItemTag>;
  /** Create a new organism property type. */
  createOrganismPropertyType: Maybe<OrganismPropertyType>;
  createProject: Maybe<Project>;
  createProjectComment: Maybe<ProjectActivity>;
  /** Create a new project folder. */
  createProjectFolder: Maybe<Scalars['Boolean']['output']>;
  createProjectHyperlink: Maybe<ProjectFile>;
  createRegionFlag: Maybe<RegionFlag>;
  createTemporaryGroup: Maybe<Group>;
  /** Creates union groups of saved items */
  createUnionGroup: Maybe<Group>;
  /** Create a virtual genome. */
  createVirtualGenome: Maybe<Organism>;
  deleteActivities: Maybe<Scalars['Boolean']['output']>;
  /** Delete coordinates list. */
  deleteCoordinatesList: Maybe<Scalars['Boolean']['output']>;
  deleteGroups: Maybe<Array<Maybe<DeletedGroup>>>;
  /** Remove an organism property type. */
  deleteOrganismPropertyTypes: Maybe<Scalars['Boolean']['output']>;
  deleteProject: Maybe<Scalars['Boolean']['output']>;
  deleteProjectFiles: Maybe<Scalars['Boolean']['output']>;
  deleteRegionFlags: Maybe<Array<Maybe<RegionFlag>>>;
  deleteTag: Maybe<Scalars['Boolean']['output']>;
  deleteViews: Maybe<Array<Maybe<View>>>;
  /** Edit the modifiable data for the given organisms. */
  editOrganism: Maybe<Scalars['Boolean']['output']>;
  groupByType: Maybe<Group>;
  groupInLegacyPortal: Maybe<Group>;
  /** Trigger BAM file indexing. */
  indexBamFile: Maybe<Scalars['Boolean']['output']>;
  logout: Maybe<Scalars['Boolean']['output']>;
  markAllNotificationsAsRead: Maybe<Scalars['Boolean']['output']>;
  markNotificationAsRead: Maybe<Scalars['Boolean']['output']>;
  /** Create a new organism property type. */
  modifyOrganismPropertyType: Maybe<OrganismPropertyType>;
  modifyProject: Maybe<Project>;
  modifyProjectFile: Maybe<ProjectFile>;
  modifySavedItem: Maybe<SavedItem>;
  moveProjectFiles: Maybe<Scalars['Boolean']['output']>;
  playbook: Maybe<PlaybookMutationApi>;
  sample: Maybe<SampleMutationApi>;
  saveView: Maybe<View>;
  search: Maybe<Search>;
  /** Submits a BLAST for asynchronous execution */
  submitJob: Maybe<BlastJob>;
  submitSequencesUpload: Maybe<Scalars['Boolean']['output']>;
  template: Maybe<TemplateContainer>;
  updateDashboard: Maybe<Scalars['Boolean']['output']>;
  updateRegionFlag: Maybe<RegionFlag>;
  updateUserParams: Maybe<UserParams>;
  user: Maybe<UserMutation>;
  userGroup: Maybe<UserGroupContainer>;
  workflow: WorkflowMutationApi;
};


/** Root object for all GraphQL mutations */
export type MutationCopyGroupsArgs = {
  groupIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  isPrivate: InputMaybe<Scalars['Boolean']['input']>;
  projectId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationCopyProjectFilesArgs = {
  fileIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  targetId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationCopyRegionFlagsArgs = {
  isPrivate: InputMaybe<Scalars['Boolean']['input']>;
  projectId: InputMaybe<Scalars['Long']['input']>;
  regionFlagIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationCopyViewsArgs = {
  isPrivate: InputMaybe<Scalars['Boolean']['input']>;
  projectId: InputMaybe<Scalars['Long']['input']>;
  viewIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateCoordinateListArgs = {
  coordinateListInputData: InputMaybe<InputCoordinateListInput>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateGroupArgs = {
  createGroupInput: InputMaybe<InputCreateGroupInput>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateGroupFromSetsArgs = {
  setComparisonGroupInput: InputMaybe<InputSetComparisonGroupInput>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateOrUpdateTagArgs = {
  itemTagInputData: InputMaybe<InputItemTagInput>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateOrganismPropertyTypeArgs = {
  organismPropertyTypeInput: InputMaybe<InputOrganismPropertyTypeInput>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateProjectArgs = {
  projectInputData: InputMaybe<InputProjectInput>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateProjectCommentArgs = {
  comment: InputMaybe<Scalars['String']['input']>;
  flagIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  parentIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  projectId: InputMaybe<Scalars['Long']['input']>;
  reportIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  viewIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateProjectFolderArgs = {
  folderId: InputMaybe<Scalars['Long']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateProjectHyperlinkArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  folderId: InputMaybe<Scalars['Long']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateRegionFlagArgs = {
  regionFlagInputData: InputMaybe<InputRegionFlagInput>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateTemporaryGroupArgs = {
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateUnionGroupArgs = {
  groupIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationCreateVirtualGenomeArgs = {
  virtualGenomeInput: InputMaybe<InputVirtualGenomeInput>;
};


/** Root object for all GraphQL mutations */
export type MutationDeleteActivitiesArgs = {
  activityIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationDeleteCoordinatesListArgs = {
  coordinateListsIds: Array<Scalars['Long']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationDeleteGroupsArgs = {
  groupIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationDeleteOrganismPropertyTypesArgs = {
  orgPropertyTypeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationDeleteProjectArgs = {
  projectId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationDeleteProjectFilesArgs = {
  fileIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationDeleteRegionFlagsArgs = {
  regionFlagIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationDeleteTagArgs = {
  itemTagId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationDeleteViewsArgs = {
  viewIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL mutations */
export type MutationEditOrganismArgs = {
  modifyOrganismInputDataList: InputMaybe<Array<InputMaybe<InputModifyOrganismInput>>>;
};


/** Root object for all GraphQL mutations */
export type MutationGroupByTypeArgs = {
  groupName: InputMaybe<Scalars['String']['input']>;
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
  targetType: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationGroupInLegacyPortalArgs = {
  groupName: InputMaybe<Scalars['String']['input']>;
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
};


/** Root object for all GraphQL mutations */
export type MutationIndexBamFileArgs = {
  fileId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationMarkNotificationAsReadArgs = {
  notificationId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationModifyOrganismPropertyTypeArgs = {
  organismPropertyTypeInput: InputMaybe<InputOrganismPropertyTypeInput>;
};


/** Root object for all GraphQL mutations */
export type MutationModifyProjectArgs = {
  modifyProjectInput: InputMaybe<InputModifyProjectInput>;
};


/** Root object for all GraphQL mutations */
export type MutationModifyProjectFileArgs = {
  modifyProjectFileInput: InputMaybe<InputModifyProjectFileInput>;
};


/** Root object for all GraphQL mutations */
export type MutationModifySavedItemArgs = {
  modifySavedItemInput: InputMaybe<InputModifySavedItemInput>;
};


/** Root object for all GraphQL mutations */
export type MutationMoveProjectFilesArgs = {
  fileIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  targetId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL mutations */
export type MutationSaveViewArgs = {
  viewInputData: InputMaybe<InputViewInput>;
};


/** Root object for all GraphQL mutations */
export type MutationSubmitJobArgs = {
  jobInputData: InputMaybe<InputJobInput>;
};


/** Root object for all GraphQL mutations */
export type MutationSubmitSequencesUploadArgs = {
  sequenceUploadInput: InputMaybe<InputSequenceUploadInput>;
};


/** Root object for all GraphQL mutations */
export type MutationUpdateDashboardArgs = {
  dashboardInput: InputMaybe<InputDashboardInput>;
};


/** Root object for all GraphQL mutations */
export type MutationUpdateRegionFlagArgs = {
  flagId: InputMaybe<Scalars['Long']['input']>;
  regionFlagUpdateInputData: InputMaybe<InputRegionFlagUpdateInput>;
};


/** Root object for all GraphQL mutations */
export type MutationUpdateUserParamsArgs = {
  userParams: InputMaybe<InputUserParamsInput>;
};

export enum NfParamSubTypeEnum {
  /** ALIGNED */
  Aligned = 'ALIGNED',
  /** DATASET */
  Dataset = 'DATASET',
  /** FILE */
  File = 'FILE',
  /** FOLDER */
  Folder = 'FOLDER',
  /** GENOME_ANNOTATION */
  GenomeAnnotation = 'GENOME_ANNOTATION',
  /** REPORT */
  Report = 'REPORT',
  /** UNALIGNED */
  Unaligned = 'UNALIGNED',
  /** UNALIGNED_PAIRED */
  UnalignedPaired = 'UNALIGNED_PAIRED',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

export enum NfParamTypeEnum {
  /** BOOLEAN */
  Boolean = 'BOOLEAN',
  /** FILE */
  File = 'FILE',
  /** GENOME */
  Genome = 'GENOME',
  /** NUMBER */
  Number = 'NUMBER',
  /** OUTPUT_DIR */
  OutputDir = 'OUTPUT_DIR',
  /** REGION */
  Region = 'REGION',
  /** STRING */
  String = 'STRING',
  /** TABLE_QUERY_SPEC */
  TableQuerySpec = 'TABLE_QUERY_SPEC'
}

export type NfParamTypeInput = {
  subType: Maybe<NfParamSubTypeEnum>;
  type: Maybe<NfParamTypeEnum>;
};

export type NfParamValue = {
  booleanValue: Maybe<Scalars['Boolean']['output']>;
  file: Maybe<ProjectFile>;
  numberValue: Maybe<Scalars['BigDecimal']['output']>;
  organism: Maybe<Organism>;
  region: Maybe<Region>;
  textValue: Maybe<Scalars['String']['output']>;
};

/** Nextflow activity attributes. */
export type NfPlaybookActivity = {
  cloudEnabled: Maybe<Scalars['Boolean']['output']>;
  hpcEnabled: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type NfPlaybookConfig = {
  activities: Maybe<Array<Maybe<NfPlaybookActivity>>>;
  icon: Maybe<Scalars['String']['output']>;
  profiles: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  trackerParameters: Maybe<NfTrackerParam>;
  workflowName: Maybe<Scalars['String']['output']>;
  workflowParameters: Maybe<Array<Maybe<NfPlaybookParam>>>;
};

export type NfPlaybookParam = {
  description: Maybe<Scalars['String']['output']>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  identifier: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  mandatory: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<NfParamTypeInput>;
  values: Maybe<Array<Maybe<NfParamValue>>>;
};

export type NfSampleAttribute = {
  attributeId: Maybe<Scalars['Long']['output']>;
  correctedMandatory: Maybe<Scalars['Boolean']['output']>;
  workflowParam: Maybe<Scalars['String']['output']>;
};

export type NfTrackerParam = {
  sampleAttributes: Maybe<Array<Maybe<NfSampleAttribute>>>;
};

/** Nextflow workflows. */
export type NfWorkflow = {
  activities: Maybe<Array<Maybe<NfPlaybookActivity>>>;
  name: Maybe<Scalars['String']['output']>;
  parameters: Maybe<Array<Maybe<NfWorkflowParam>>>;
  profiles: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Nextflow workflow parameters */
export type NfWorkflowParam = {
  defaultValue: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  identifier: Maybe<Scalars['String']['output']>;
  type: Maybe<NfParamTypeInput>;
};

export type NgsWorkflow = {
  workflowExportMappings: Maybe<Array<Maybe<WorkflowExportMapping>>>;
  workflowId: Maybe<Scalars['String']['output']>;
  workflowImportMappings: Maybe<Array<Maybe<WorkflowParamAttributeMapping>>>;
};

/** Notification data object */
export type Notification = {
  activity: Maybe<ProjectActivity>;
  created: Scalars['String']['output'];
  groupNotification: Maybe<GroupNotification>;
  id: Scalars['Long']['output'];
  /** The event associated with this notification. */
  playbookEvent: Maybe<PlaybookEvent>;
  read: Scalars['Boolean']['output'];
  status: Maybe<Scalars['String']['output']>;
  type: NotificationTypeEnum;
  /** The event associated with this notification. */
  workflowEvent: Maybe<WorkflowEvent>;
  workflowNotification: Maybe<WorkflowNotification>;
};

export enum NotificationTypeEnum {
  /** GROUP */
  Group = 'GROUP',
  /** JOB */
  Job = 'JOB',
  /** PROJECT_ACTIVITY */
  ProjectActivity = 'PROJECT_ACTIVITY',
  /** WORKFLOW */
  Workflow = 'WORKFLOW'
}

export type NuFeature = PageRow & {
  description: Maybe<Scalars['String']['output']>;
  externalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  gene: Maybe<Gene>;
  genome: Maybe<Organism>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Returns the dynamic organism property with the specified identifier */
  nuFeatureOrganismProperties: Maybe<Array<Maybe<NuFeatureOpo>>>;
  nuFeatureType: Maybe<NuFeatureType>;
  /** Returns the dynamic organism property with the specified identifier */
  organismProperty: Maybe<Array<Maybe<OrganismProperty>>>;
  pValue: Maybe<Scalars['String']['output']>;
  region: Maybe<Region>;
  relatedProjects: Maybe<Array<Maybe<RelatedProject>>>;
  score: Maybe<Scalars['Float']['output']>;
};


export type NuFeatureOrganismPropertyArgs = {
  organismProperty: InputMaybe<Scalars['String']['input']>;
};

export type NuFeatureOpo = {
  id: Maybe<Scalars['Long']['output']>;
  nuFeature: Maybe<NuFeature>;
  organismProperty: Maybe<OrganismProperty>;
  source: Maybe<Source>;
};

/** NuFeatureStats object for nu_feature table rows */
export type NuFeatureStats = {
  count: Maybe<Scalars['Long']['output']>;
  featureTypeColor: Maybe<Scalars['String']['output']>;
  featureTypeId: Maybe<Scalars['Long']['output']>;
  featureTypeName: Maybe<Scalars['String']['output']>;
};

/** Represents a NuFeatureType */
export type NuFeatureType = {
  color: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** A profile. */
export type NuProfile = {
  id: Scalars['Long']['output'];
  nuSequence: Contig;
  profileType: Maybe<NuProfileType>;
  rangeStart: Scalars['Long']['output'];
  rangeStop: Scalars['Long']['output'];
  score: Maybe<Scalars['BigDecimal']['output']>;
};

/** NuProfileStats object for nu_profile table rows */
export type NuProfileStats = {
  count: Maybe<Scalars['Long']['output']>;
  profileTypeId: Maybe<Scalars['Long']['output']>;
  profileTypeName: Maybe<Scalars['String']['output']>;
};

/** A type identifier for numerical feature data */
export type NuProfileType = {
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type NumberConstraints = Constraints & {
  controlledValues: Maybe<Array<NumberControlledValue>>;
  id: Maybe<Scalars['String']['output']>;
  maxDecimals: Maybe<Scalars['Int']['output']>;
  maxValue: Maybe<Scalars['BigDecimal']['output']>;
  minValue: Maybe<Scalars['BigDecimal']['output']>;
};

export type NumberControlledValue = ControlledValue & {
  description: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  value: Scalars['BigDecimal']['output'];
};

export type NumberParam = ActivityParameter & {
  constraints: Maybe<NumberConstraints>;
  defaultValue: Maybe<Array<Scalars['BigDecimal']['output']>>;
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  multiSelect: Scalars['Boolean']['output'];
  optional: Scalars['Boolean']['output'];
  type: WorkflowParameterTypeEnum;
};

export type NumberValue = ParameterValue & {
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  value: Array<Scalars['BigDecimal']['output']>;
};

/** The Oracle password verification limit parameters */
export type OraclePasswordLimit = {
  forbiddenChars: Maybe<Scalars['String']['output']>;
  maxPasswordBytesLength: Maybe<Scalars['Int']['output']>;
  minDigits: Maybe<Scalars['Int']['output']>;
  minLowerAsciiChars: Maybe<Scalars['Int']['output']>;
  minOtherChars: Maybe<Scalars['Int']['output']>;
  minPasswordCharLength: Maybe<Scalars['Int']['output']>;
  minUpperAsciiChars: Maybe<Scalars['Int']['output']>;
  profileName: Maybe<Scalars['String']['output']>;
};

export type OrgPropertyGroup = {
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  opgId: Maybe<Scalars['Long']['output']>;
  sortOrder: Maybe<Scalars['Short']['output']>;
};

/** The organisation DTO */
export type Organisation = {
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  note: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

/** Organism object for organism table rows */
export type Organism = PageRow & {
  /** External references except literature for use in summary pages. */
  allExternalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  /** Returns the dynamic sample attribute data with the specified identifier */
  attribute: Maybe<Array<Maybe<AttributeValue>>>;
  /** BAM files stored for the organism */
  bamFiles: Maybe<Array<Maybe<ProjectFile>>>;
  /** The component genomes for a virtual genome */
  components: Array<Organism>;
  contigs: Maybe<Array<Maybe<Contig>>>;
  created: Maybe<Scalars['String']['output']>;
  customId: Maybe<Scalars['String']['output']>;
  databases: Maybe<Array<Maybe<Database>>>;
  datasets: Maybe<Array<Maybe<Dataset>>>;
  description: Maybe<Scalars['String']['output']>;
  /** External references except literature */
  externalReference: Maybe<Array<Maybe<ExternalReference>>>;
  /** External references except literature */
  externalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  genomeStatistics: Maybe<GenomeStatistics>;
  genotypeDescription: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  hasContigs: Scalars['Boolean']['output'];
  hasFlags: Scalars['Boolean']['output'];
  hasGenes: Scalars['Boolean']['output'];
  /** Checks if the organism is in an analysis group that contains only sequenced genomes. */
  hasGenomeAnalysis: Maybe<Scalars['Boolean']['output']>;
  hasMarkers: Scalars['Boolean']['output'];
  hasNuFeatures: Scalars['Boolean']['output'];
  hasProteins: Scalars['Boolean']['output'];
  hasTranscripts: Scalars['Boolean']['output'];
  hasVariants: Maybe<Scalars['Boolean']['output']>;
  /** Checks if the organism is in an analysis group that contains unsequenced genomes. */
  hasVcfGenomeAnalysis: Maybe<Scalars['Boolean']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  identifier: Maybe<Scalars['String']['output']>;
  isReference: Maybe<Scalars['Boolean']['output']>;
  /** Virtual genomes are compositions of non virtual genomes */
  isVirtual: Scalars['Boolean']['output'];
  /** External references of type literature */
  literatureReferences: Maybe<Array<Maybe<ExternalReference>>>;
  modified: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organisation: Maybe<Organisation>;
  /** Organism Properties */
  organismProperties: Maybe<Array<Maybe<OrganismProperty>>>;
  /** Returns the dynamic organism property with the specified identifier */
  organismProperty: Maybe<OrganismProperty>;
  /** The source of the file used for re-sequenced VCF genomes. Can be either a source description, Selector path or the absolute path. */
  origin: Maybe<Scalars['String']['output']>;
  /** The sources of the files used for re-sequenced VCF genomes. Can be either a source description, Selector path or the absolute path.The order of the list corresponds to the order of the Analysis Groups in variantAnalysisGroups. */
  origins: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Records of events in which the genome used a resource of a playbook. */
  playbookEvents: Maybe<Array<Maybe<PlaybookEvent>>>;
  relatedProjects: Maybe<Array<Maybe<RelatedProject>>>;
  sample: Maybe<Sample>;
  sequenced: Scalars['Boolean']['output'];
  sequencingType: Maybe<Scalars['String']['output']>;
  species: Maybe<Species>;
  strain: Maybe<Scalars['String']['output']>;
  taxonomy: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  userGroups: Maybe<Array<Maybe<UserGroup>>>;
  variantAnalysisGroups: Maybe<Array<Maybe<VariantAnalysisGroup>>>;
  version: Maybe<Scalars['String']['output']>;
  /** The virtual genomes that contain this genome as component. */
  virtualGenomes: Array<Organism>;
};


/** Organism object for organism table rows */
export type OrganismAttributeArgs = {
  attribute: InputMaybe<Scalars['String']['input']>;
};


/** Organism object for organism table rows */
export type OrganismContigsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Organism object for organism table rows */
export type OrganismExternalReferenceArgs = {
  externalReference: InputMaybe<Scalars['String']['input']>;
};


/** Organism object for organism table rows */
export type OrganismOrganismPropertyArgs = {
  organismProperty: InputMaybe<Scalars['String']['input']>;
};


/** Organism object for organism table rows */
export type OrganismPlaybookEventsArgs = {
  eventsLimit?: InputMaybe<Scalars['Long']['input']>;
};

export type OrganismPhenotype = {
  organism: Maybe<Organism>;
  phenotypeValues: Maybe<Array<Maybe<Phenotype>>>;
};

export type OrganismProperty = {
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  numValue: Maybe<Scalars['BigDecimal']['output']>;
  organismPropertyType: Maybe<OrganismPropertyType>;
  value: Maybe<Scalars['String']['output']>;
};

export type OrganismPropertyType = {
  description: Maybe<Scalars['String']['output']>;
  group: Maybe<OrgPropertyGroup>;
  id: Maybe<Scalars['Long']['output']>;
  isDiscrete: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  properties: Maybe<Array<Maybe<OrganismProperty>>>;
  sortOrder: Maybe<Scalars['Short']['output']>;
  valueType: Maybe<Scalars['String']['output']>;
};

/** The genomes sub component of the content browser */
export type Organisms = {
  count: Maybe<Scalars['Long']['output']>;
  featureAnnotation: Maybe<OrganismsByFeatureAnnotation>;
  sequencingType: Maybe<OrganismsBySequencingType>;
  species: Maybe<OrganismsBySpecies>;
  taxonomy: Maybe<OrganismsByTaxonomy>;
  variantAnalysisGroup: Maybe<OrganismsByVariantAnalysisGroup>;
};

export type OrganismsByCreationTime = {
  info: Maybe<OrganismsInfo>;
  listing: Maybe<Array<Maybe<ListingMapEntry>>>;
};


export type OrganismsByCreationTimeInfoArgs = {
  arg0: InputMaybe<Scalars['String']['input']>;
};

/** The feature annotation component of the content browser */
export type OrganismsByFeatureAnnotation = {
  info: Maybe<OrganismsInfo>;
  listing: Maybe<Array<Maybe<ListingMapEntry>>>;
};


/** The feature annotation component of the content browser */
export type OrganismsByFeatureAnnotationInfoArgs = {
  filterKey: InputMaybe<Scalars['String']['input']>;
};

/** The genome type component of the content browser */
export type OrganismsBySequencingType = {
  info: Maybe<OrganismsInfo>;
  listing: Maybe<Array<Maybe<ListingMapEntry>>>;
};


/** The genome type component of the content browser */
export type OrganismsBySequencingTypeInfoArgs = {
  filterKey: InputMaybe<Scalars['String']['input']>;
};

/** The species sub component of the content browser */
export type OrganismsBySpecies = {
  info: Maybe<OrganismsInfo>;
  listing: Maybe<Array<Maybe<ListingMapEntry>>>;
};


/** The species sub component of the content browser */
export type OrganismsBySpeciesInfoArgs = {
  filterKey: InputMaybe<Scalars['String']['input']>;
};

/** The taxonomy category of the content browser */
export type OrganismsByTaxonomy = {
  info: Maybe<OrganismsInfo>;
  listing: Maybe<Array<Maybe<ListingMapEntry>>>;
};


/** The taxonomy category of the content browser */
export type OrganismsByTaxonomyInfoArgs = {
  filterKey: InputMaybe<Scalars['String']['input']>;
};

export type OrganismsByUserGroup = {
  info: Maybe<OrganismsInfo>;
  listing: Maybe<Array<Maybe<ListingMapEntry>>>;
};


export type OrganismsByUserGroupInfoArgs = {
  filterKey: InputMaybe<Scalars['String']['input']>;
};

/** The genome analysis group component of the content browser */
export type OrganismsByVariantAnalysisGroup = {
  info: Maybe<OrganismsInfo>;
  listing: Maybe<Array<Maybe<ListingMapEntry>>>;
};


/** The genome analysis group component of the content browser */
export type OrganismsByVariantAnalysisGroupInfoArgs = {
  filterKey: InputMaybe<Scalars['String']['input']>;
};

/** Additional information for the organism content browser view. */
export type OrganismsInfo = {
  all: Maybe<Scalars['Int']['output']>;
  derived: Maybe<Scalars['Int']['output']>;
  primary: Maybe<Scalars['Int']['output']>;
  reference: Maybe<Scalars['Int']['output']>;
  sequenced: Maybe<Scalars['Int']['output']>;
};

export type Ortholog = PageRow & {
  clusterSet: Maybe<ClusterSet>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  protein: Maybe<Protein>;
  userGroups: Maybe<Array<Maybe<UserGroup>>>;
};

/** OtherDna object for Other DNA data */
export type OtherDna = PageRow & {
  accession: Maybe<Scalars['String']['output']>;
  creator: Maybe<User>;
  database: Maybe<Database>;
  description: Maybe<Scalars['String']['output']>;
  entered: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  length: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  sequenceId: Maybe<Scalars['String']['output']>;
  sequenceType: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['Int']['output']>;
};

export type OutputActivityIo = ActivityIo & {
  description: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  types: Array<Scalars['String']['output']>;
};

export type P2PlaybookConfig = {
  contexts: Array<Maybe<PlaybookUiContext>>;
  icon: Maybe<Scalars['String']['output']>;
  workflow: Maybe<WorkflowP2>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PageRow = {
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
};

export type PaginationInput = {
  /** The number of elements to fetch */
  limit: Maybe<Scalars['Int']['output']>;
  /** The number of items to skip */
  offset: Maybe<Scalars['Int']['output']>;
};

export type ParameterGroup = {
  collapsed: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ParameterMapping = {
  instanceId: Scalars['String']['output'];
  parameterId: Scalars['String']['output'];
};

export type ParameterValue = {
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
};

/** Represents a parent. */
export type Parent = PageRow & SavedItem & {
  /** Returns the dynamic attribute with the specified identifier */
  attribute: Array<Maybe<AttributeValue>>;
  attributeValues: Array<Maybe<AttributeValue>>;
  created: Scalars['String']['output'];
  creator: Maybe<User>;
  deletable: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  itemTags: Maybe<Array<Maybe<ItemTag>>>;
  modified: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Scalars['String']['output']>;
  parentType: ParentType;
  /** @deprecated This field is imprecise. In case of multiple projects, the first sorted by name will be returned. */
  project: Maybe<Project>;
  projects: Maybe<Array<Maybe<Project>>>;
  sampleCount: Scalars['Long']['output'];
  samples: Array<Sample>;
  shared: Maybe<Scalars['Boolean']['output']>;
  status: Maybe<SampleStatus>;
  type: Maybe<Scalars['String']['output']>;
  typeDisplayName: Maybe<Scalars['String']['output']>;
};


/** Represents a parent. */
export type ParentAttributeArgs = {
  attribute: InputMaybe<Scalars['String']['input']>;
};

/** Contains information about affected entities when deleting a parent. */
export type ParentStatistic = {
  reportCount: Maybe<Scalars['Int']['output']>;
  sampleCount: Maybe<Scalars['Int']['output']>;
};

/** Represents a parent type. */
export type ParentType = {
  attributeCount: Scalars['Long']['output'];
  /** The attribute defaults for this parent type */
  attributeDefaults: Array<RawAttributeDefaultMapEntry>;
  created: Scalars['String']['output'];
  creator: User;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  isListed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentAttributes: Array<Attribute>;
  parents: Array<Parent>;
  /** Number of samples using this parent type */
  sampleCount: Scalars['Long']['output'];
  /** Number of sample types using this parent type */
  sampleTypeCount: Scalars['Long']['output'];
  /** The samples types for this parent type */
  sampleTypes: Array<SampleType>;
};

/** Represents a parent type set. */
export type ParentTypeSet = {
  id: Maybe<Scalars['Long']['output']>;
  isAutomatic: Maybe<Scalars['Boolean']['output']>;
  isMandatory: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Maybe<Scalars['Boolean']['output']>;
  isRecyclable: Maybe<Scalars['Boolean']['output']>;
  parentType: Maybe<ParentType>;
};

export type Pathway = {
  description: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type PermissionValidationResult = {
  inaccessibleActivityResourcesData: Array<Maybe<InaccessibleActivityResourcesData>>;
  inaccessibleSampleType: Maybe<SampleType>;
};

/** The Pfam DTO */
export type Pfam = {
  description: Maybe<Scalars['String']['output']>;
  externalReference: Maybe<ExternalReference>;
  location: Maybe<Range>;
  name: Maybe<Scalars['String']['output']>;
  pValue: Maybe<Scalars['String']['output']>;
  score: Maybe<Scalars['Float']['output']>;
};

export type Phenotype = {
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  numValue: Maybe<Scalars['BigDecimal']['output']>;
  phenotypeTypeData: Maybe<GenomicFeature>;
  value: Maybe<Scalars['String']['output']>;
};

export type PileupAlignment = {
  end: Maybe<Scalars['Int']['output']>;
  /** The bit-encoded read flags as given by SAM tools. */
  flags: Maybe<Scalars['Int']['output']>;
  /** The mate is on another chromosome, if it exists */
  interChromosomal: Maybe<Scalars['Boolean']['output']>;
  mappingQuality: Maybe<Scalars['Int']['output']>;
  mismatches: Maybe<Scalars['Int']['output']>;
  readLength: Maybe<Scalars['Int']['output']>;
  readName: Maybe<Scalars['String']['output']>;
  segments: Maybe<Array<Maybe<PileupAlignmentSegment>>>;
  /** No mate exists/mapped */
  singleton: Maybe<Scalars['Boolean']['output']>;
  softClipped: Maybe<Scalars['Boolean']['output']>;
  /** Flag indicating if the read is split or spliced */
  split: Maybe<Scalars['Boolean']['output']>;
  start: Maybe<Scalars['Int']['output']>;
  strand: Maybe<Scalars['String']['output']>;
  templateStrand: Maybe<Scalars['String']['output']>;
};

export type PileupAlignmentSegment = {
  deletion: Maybe<Scalars['Boolean']['output']>;
  insertion: Maybe<Scalars['Boolean']['output']>;
  length: Maybe<Scalars['Int']['output']>;
  match: Maybe<Scalars['Boolean']['output']>;
  mismatchBasesQualities: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  mismatchPositions: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  mismatchesBases: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Indicates that this segment was soft clipped by the aligner. */
  softClipped: Maybe<Scalars['Boolean']['output']>;
  start: Maybe<Scalars['Int']['output']>;
  stop: Maybe<Scalars['Int']['output']>;
};

export type PileupElement = {
  first: Maybe<PileupAlignment>;
  second: Maybe<PileupAlignment>;
};

export type PileupRow = {
  laneNumber: Maybe<Scalars['Int']['output']>;
  pileupElements: Maybe<Array<Maybe<PileupElement>>>;
};

/** Configuration of a playbook */
export type Playbook = {
  capability: Maybe<Capability>;
  categories: Array<PlaybookCategory>;
  /** The old way to configure a playbook. */
  config: Maybe<PlaybookConfig>;
  created: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  enabled: Maybe<Scalars['Boolean']['output']>;
  helpLink: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  identifier: Maybe<Scalars['String']['output']>;
  modified: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameSuffix: Maybe<Scalars['String']['output']>;
  /** Alternative for config, only present for nf playbooks. */
  nfConfig: Maybe<NfPlaybookConfig>;
  order: Maybe<Scalars['Int']['output']>;
  /** Alternative for config, only present for P2 playbooks. */
  p2Config: Maybe<P2PlaybookConfig>;
  /** Indicates if the user has access to the playbook. */
  protectedPlaybook: Maybe<Scalars['Boolean']['output']>;
  reportTemplateResources: Maybe<Array<Maybe<ReportTemplateResources>>>;
  roles: Maybe<Array<Maybe<Role>>>;
  sampleType: Maybe<SampleType>;
  /** Indicates if a playbook is configurable from the Selector UI. */
  standard: Maybe<Scalars['Boolean']['output']>;
  templateEvent: Maybe<PlaybookEvent>;
  tooltip: Maybe<Scalars['String']['output']>;
  type: PlaybookType;
  uiContexts: Maybe<Array<Maybe<UiContextEnum>>>;
  workflowApprovalDate: Maybe<Scalars['String']['output']>;
};

export type PlaybookCategory = {
  id: Scalars['Long']['output'];
  imageName: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  playbooks: Maybe<Array<Maybe<Playbook>>>;
  protectedCategory: Scalars['Boolean']['output'];
};

/** The JSON playbook configuration */
export type PlaybookConfig = {
  experimentInput: Maybe<Array<Maybe<ExperimentInput>>>;
  icon: Maybe<Scalars['String']['output']>;
  ngsWorkflow: Maybe<NgsWorkflow>;
  sampleInput: Maybe<Array<Maybe<ExperimentInput>>>;
  sampleStatus: Maybe<PlaybookSampleStatuses>;
};

/** PlaybookEvent object for event table rows */
export type PlaybookEvent = PageRow & {
  alias: Maybe<Scalars['String']['output']>;
  created: Scalars['String']['output'];
  displayedSampleCount: Maybe<Scalars['Long']['output']>;
  eventExpired: Maybe<Scalars['Boolean']['output']>;
  executionLogsAvailable: Maybe<Scalars['Boolean']['output']>;
  getErrors: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  inputs: Maybe<Array<PlaybookEventInput>>;
  job: Maybe<BlastJob>;
  lastModifier: User;
  modified: Maybe<Scalars['String']['output']>;
  note: Maybe<Scalars['String']['output']>;
  owner: User;
  parents: Maybe<Array<Parent>>;
  playbook: Playbook;
  primaryParent: Maybe<Parent>;
  project: Maybe<Project>;
  projectVisibleForUser: Maybe<Scalars['Boolean']['output']>;
  relatedSamples: Maybe<Array<Sample>>;
  results: Maybe<Array<Maybe<EventResource>>>;
  shortSummary: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  supportsLogFileDownload: Maybe<Scalars['Boolean']['output']>;
  totalSampleCount: Maybe<Scalars['Long']['output']>;
  workflowName: Maybe<Scalars['String']['output']>;
  /** Field containing the configuration used to run a Playbook based on a Processor workflow. */
  workflowP2ExtendedConfig: Maybe<WorkflowExtendedConfig>;
};

/** PlaybookEventInput object representing all text input (not resources) for a playbook event */
export type PlaybookEventInput = {
  id: Maybe<Scalars['Long']['output']>;
  inputValues: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  label: Scalars['String']['output'];
  resources: Maybe<Array<Maybe<EventResource>>>;
  workflowField: Maybe<Scalars['String']['output']>;
};

/** Possible genome inputs of a playbook */
export type PlaybookGenomeInput = {
  fileId: Maybe<Scalars['Long']['output']>;
  genomeId: Maybe<Scalars['Long']['output']>;
};

/** Root Mutation of the Playbook Management API schema. */
export type PlaybookMutationApi = {
  editPlaybookEvent: PlaybookEvent;
  runPlaybook: Maybe<Parent>;
  /** Submits a playbook for execution with the workflow management system */
  submit: Scalars['Boolean']['output'];
};


/** Root Mutation of the Playbook Management API schema. */
export type PlaybookMutationApiEditPlaybookEventArgs = {
  modifyPlaybookEventInput: InputMaybe<InputModifyPlaybookEventInput>;
};


/** Root Mutation of the Playbook Management API schema. */
export type PlaybookMutationApiRunPlaybookArgs = {
  editSamplesInput: InputMaybe<InputEditSamplesInput>;
  parentInputData: InputMaybe<InputParentInput>;
  playbookEventInput: InputMaybe<InputPlaybookEventInput>;
  workflowParams?: InputMaybe<Array<InputMaybe<InputWorkflowParamInput>>>;
};


/** Root Mutation of the Playbook Management API schema. */
export type PlaybookMutationApiSubmitArgs = {
  editSamplesInput: InputMaybe<InputEditSamplesInput>;
  parentInputData: InputMaybe<InputParentInput>;
  playbookEventInput: InputMaybe<InputPlaybookEventInput>;
  workflowParams: InputMaybe<Array<InputMaybe<InputNfParamInput>>>;
};

export type PlaybookPageUiContext = PlaybookUiContext & {
  context: UiContextEnum;
};

/** Root of the Playbook Management API schema. */
export type PlaybookQueryApi = {
  /** Returns all approved workflows present in the approved and demo folders. */
  approvedWorkflows: Maybe<Array<Maybe<Workflow>>>;
  event: Maybe<PlaybookEvent>;
  exportableFieldsFromWorkflow: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns a playbook category by its ID. */
  getCategoryById: Maybe<PlaybookCategory>;
  /** Returns the input parameters for the Nextflow workflow. */
  nfWorkflow: Maybe<NfWorkflow>;
  /** Returns all Nextflow workflows from the nextflow workflow folder. */
  nfWorkflows: Maybe<Array<Maybe<NfWorkflow>>>;
  /** The playbook for this id, if accessible for the current user. */
  playbook: Maybe<Playbook>;
  /** The list of all enabled, licensed playbooks for this user. */
  playbooks: Maybe<Array<Maybe<Playbook>>>;
  /** Returns the recent events for an optional playbook category. Offset and limit values are necessary for the listing. */
  recentEvents: Maybe<Array<Maybe<PlaybookEvent>>>;
};


/** Root of the Playbook Management API schema. */
export type PlaybookQueryApiApprovedWorkflowsArgs = {
  playbookTypeId: InputMaybe<Scalars['Long']['input']>;
  workflowID: InputMaybe<Scalars['String']['input']>;
};


/** Root of the Playbook Management API schema. */
export type PlaybookQueryApiEventArgs = {
  eventId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Playbook Management API schema. */
export type PlaybookQueryApiExportableFieldsFromWorkflowArgs = {
  workflowID: InputMaybe<Scalars['String']['input']>;
};


/** Root of the Playbook Management API schema. */
export type PlaybookQueryApiGetCategoryByIdArgs = {
  categoryId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Playbook Management API schema. */
export type PlaybookQueryApiNfWorkflowArgs = {
  workflowId: InputMaybe<Scalars['String']['input']>;
};


/** Root of the Playbook Management API schema. */
export type PlaybookQueryApiPlaybookArgs = {
  playbookId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Playbook Management API schema. */
export type PlaybookQueryApiRecentEventsArgs = {
  categoryId: InputMaybe<Scalars['Long']['input']>;
  currentUserOnly: InputMaybe<Scalars['Boolean']['input']>;
  eventsLimit: InputMaybe<Scalars['Long']['input']>;
  offset: InputMaybe<Scalars['Long']['input']>;
};

export type PlaybookSampleStatuses = {
  afterCompletion: Maybe<Scalars['Long']['output']>;
  afterSubmission: Maybe<Scalars['Long']['output']>;
  failure: Maybe<Scalars['Long']['output']>;
  whileRunning: Maybe<Scalars['Long']['output']>;
};

/** Configuration of a playbook type */
export type PlaybookType = {
  /** Class of the playbook from a Module point of view (e.g. license */
  class: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type PlaybookUiContext = {
  context: UiContextEnum;
};

export type Position = {
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

/** Probe object for probe data */
export type Probe = PageRow & {
  accession: Maybe<Scalars['String']['output']>;
  creator: Maybe<User>;
  database: Maybe<Database>;
  description: Maybe<Scalars['String']['output']>;
  entered: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  length: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  sequenceId: Maybe<Scalars['String']['output']>;
  sequenceType: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['Int']['output']>;
};

/** Profile derifved variant data. */
export type ProfileDerivedVariant = {
  genomeId: Maybe<Scalars['Long']['output']>;
  symbol: Maybe<Scalars['String']['output']>;
  zygosity: Maybe<ZygosityEnum>;
};

/** Profile variant data. */
export type ProfileVariantData = {
  genomeId: Maybe<Scalars['Long']['output']>;
  genomeName: Maybe<Scalars['String']['output']>;
  heterozygous: Maybe<Scalars['Boolean']['output']>;
  noCall: Maybe<Scalars['Boolean']['output']>;
  notApplicable: Maybe<Scalars['Boolean']['output']>;
  present: Maybe<Scalars['Boolean']['output']>;
  symbol: Maybe<Scalars['String']['output']>;
};

/** Project object */
export type Project = {
  activity: Maybe<Array<ProjectActivity>>;
  actualEndDate: Maybe<Scalars['String']['output']>;
  capabilities: Maybe<Scalars['ScalarMap']['output']>;
  color: Maybe<Scalars['String']['output']>;
  /** The creation date of the project. */
  created: Scalars['String']['output'];
  creator: Maybe<User>;
  description: Maybe<Scalars['String']['output']>;
  endNotes: Maybe<Scalars['String']['output']>;
  goal: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  initialEndDate: Maybe<Scalars['String']['output']>;
  isPrivateWorkspace: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  isUserAdmin: Scalars['Boolean']['output'];
  /** The last modified date for the current user. */
  lastModified: Maybe<Scalars['String']['output']>;
  lastUpdate: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentFileId: Maybe<Scalars['Long']['output']>;
  projectMembers: Maybe<Array<ProjectMember>>;
  projectStatistics: ProjectStatistics;
  projectedEndDate: Maybe<Scalars['String']['output']>;
  startDate: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  statusNotes: Maybe<Scalars['String']['output']>;
  userGroup: Maybe<UserGroup>;
};

/** Project activity data object */
export type ProjectActivity = {
  affectedUsers: Maybe<Array<User>>;
  commentBody: Maybe<Scalars['String']['output']>;
  coordinateLists: Array<CoordinateList>;
  created: Scalars['String']['output'];
  deletable: Scalars['Boolean']['output'];
  deletedGroups: Maybe<Array<DeletedGroup>>;
  flags: Maybe<Array<RegionFlag>>;
  groups: Maybe<Array<Maybe<Group>>>;
  id: Scalars['Long']['output'];
  isPrivate: Scalars['Boolean']['output'];
  parents: Maybe<Array<Parent>>;
  playbookEvent: Maybe<PlaybookEvent>;
  project: Maybe<Project>;
  projectFiles: Maybe<Array<ProjectFile>>;
  projectName: Scalars['String']['output'];
  type: ActivityTypeEnum;
  user: User;
  views: Maybe<Array<Maybe<View>>>;
};

/** A file saved to a project */
export type ProjectFile = {
  canChangeProtectedStatus: Scalars['Boolean']['output'];
  contentType: Maybe<ContentType>;
  created: Maybe<Scalars['String']['output']>;
  creator: Maybe<User>;
  deletable: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  eventResources: Maybe<Array<EventResource>>;
  fileBrowseType: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  fileType: Maybe<Scalars['String']['output']>;
  /** <USERGROUP GUID>/<PROJECT GUID>(/FOLDER PATH)/RESOURCE NAME */
  fullPath: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  humanReadablePath: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  indexingStatus: Maybe<IndexStatus>;
  isEditable: Scalars['Boolean']['output'];
  isProtected: Maybe<Scalars['Boolean']['output']>;
  lastModified: Maybe<Scalars['String']['output']>;
  lastModifier: Maybe<User>;
  organisms: Maybe<Array<Maybe<Organism>>>;
  /** List of sorted parent folder ids starting from the projects folder */
  parentFolderIds: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  /** List of sample parents */
  parents: Maybe<Array<Parent>>;
  /** The optional folder path, empty if the file is located directly below the project folder. */
  path: Maybe<Scalars['String']['output']>;
  playbookEvents: Maybe<Array<PlaybookEvent>>;
  previewable: Scalars['Boolean']['output'];
  project: Maybe<Project>;
  samples: Maybe<Array<Maybe<Sample>>>;
  /** The size in Bytes */
  size: Scalars['Long']['output'];
  typeDisplayName: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export type ProjectFileSearch = {
  extensionRegex: Maybe<Scalars['String']['output']>;
  projectFiles: Array<ProjectFile>;
  searchTerm: Maybe<Scalars['String']['output']>;
  totalCount: Maybe<Scalars['Long']['output']>;
};

/** ProjectList object */
export type ProjectList = {
  projects: Array<Project>;
};

/** Container object for project management related endpoints. */
export type ProjectManagement = {
  addUsers: Maybe<Array<Maybe<ProjectMember>>>;
  removeUser: Maybe<Scalars['Boolean']['output']>;
  updateProjectRole: Maybe<Scalars['Boolean']['output']>;
};


/** Container object for project management related endpoints. */
export type ProjectManagementAddUsersArgs = {
  addProjectMemberInputData: InputMaybe<InputAddProjectMemberInput>;
};


/** Container object for project management related endpoints. */
export type ProjectManagementRemoveUserArgs = {
  removeProjectMemberInputData: InputMaybe<InputRemoveProjectMemberInput>;
};


/** Container object for project management related endpoints. */
export type ProjectManagementUpdateProjectRoleArgs = {
  updateProjectMemberRoleInputData: InputMaybe<InputUpdateProjectMemberRoleInput>;
};

/** Information on a project member. */
export type ProjectMember = {
  roleId: Maybe<Scalars['Long']['output']>;
  user: Maybe<User>;
};

/** Statistics object for Project */
export type ProjectStatistics = {
  eventCount: Maybe<Scalars['Long']['output']>;
};

/** Protein object for protein table rows */
export type Protein = PageRow & {
  accession: Maybe<Scalars['String']['output']>;
  allClassifications: Maybe<Array<Maybe<Classification>>>;
  /** All external references except literature for use in summary pages. */
  allExternalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  alternativeName: Maybe<Scalars['String']['output']>;
  /** Blast results */
  bestBlastResults: Maybe<Array<Maybe<BlastResult>>>;
  /** Blast results */
  blastResults: Maybe<Array<Maybe<BlastResult>>>;
  classification: Maybe<Array<Maybe<Classification>>>;
  creator: Maybe<User>;
  database: Maybe<Database>;
  description: Maybe<Scalars['String']['output']>;
  ecNumbers: Maybe<Array<Maybe<EcNumber>>>;
  /** External references except literature */
  externalReference: Maybe<Array<Maybe<ExternalReference>>>;
  /** External references except literature */
  externalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  /** AA Feature Stats */
  featureStatsData: Maybe<Array<Maybe<AaFeatureStats>>>;
  /** The %GC of the underlying cDNA (Complete genomic region including introns ignoring multiple mappings) */
  gc: Maybe<Scalars['Int']['output']>;
  gene: Maybe<Gene>;
  genes: Maybe<Array<Maybe<Gene>>>;
  genome: Maybe<Organism>;
  groupType: Scalars['String']['output'];
  hasVariants: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  /** Internal references */
  internalReferences: Maybe<Array<Maybe<Sequence>>>;
  isoelectricPoint: Maybe<Scalars['Float']['output']>;
  length: Maybe<Scalars['Long']['output']>;
  /** External references of type literature */
  literatureReferences: Maybe<Array<Maybe<ExternalReference>>>;
  molecularWeight: Maybe<Scalars['Float']['output']>;
  note: Maybe<Scalars['String']['output']>;
  orthologTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** All pathways linked to the protein referenced via EcNumber or Enzyme */
  pathways: Maybe<Array<Maybe<Pathway>>>;
  /** Pfam motifs */
  pfamMotifs: Maybe<Array<Maybe<Pfam>>>;
  proteinLocations: Maybe<Array<Maybe<ProteinLocation>>>;
  proteinNames: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  relatedProjects: Maybe<Array<Maybe<RelatedProject>>>;
  sequenceId: Maybe<Scalars['String']['output']>;
  species: Maybe<Species>;
  systematicName: Maybe<Scalars['String']['output']>;
  transcripts: Maybe<Array<Maybe<Transcript>>>;
  userGroups: Maybe<Array<Maybe<UserGroup>>>;
  version: Maybe<Scalars['Int']['output']>;
};


/** Protein object for protein table rows */
export type ProteinClassificationArgs = {
  classification: InputMaybe<Scalars['String']['input']>;
};


/** Protein object for protein table rows */
export type ProteinExternalReferenceArgs = {
  externalReference: InputMaybe<Scalars['String']['input']>;
};

/** ProteinLocation object */
export type ProteinLocation = PageRow & {
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  protein: Maybe<Protein>;
  proteinLocationMappings: Maybe<Array<Maybe<Range>>>;
  region: Maybe<Region>;
};

/** A protein mutation object based on an underlying protein mutation info entity. */
export type ProteinMutation = PageRow & {
  effect: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Maybe<Scalars['String']['output']>;
  proteinLocation: Maybe<ProteinLocation>;
  range: Maybe<Range>;
  variant: Maybe<Variant>;
};

/** Root object for all GraphQL queries */
export type Query = {
  aaFeature: Maybe<AaFeature>;
  account: Maybe<UserContainer>;
  admin: Maybe<AdminQuery>;
  /** The container for the content browser for usergroup assignments in the admin section. */
  adminBrowser: Maybe<AdminBrowser>;
  allProjectCapabilities: Maybe<Array<Maybe<Capability>>>;
  analyzerIdMapping: Maybe<Array<Maybe<AnalyzerIdMapping>>>;
  /** Get available options to filter audit report */
  auditFilterOptions: AuditFilterOption;
  blastIndices: Maybe<Array<Maybe<BlastIndex>>>;
  blastInputValidation: Maybe<Array<Maybe<ValidationError>>>;
  /** Checks that all organisms defined either in the table spec or in the id list are sequenced genomes. */
  checkSequencedOrganisms: Maybe<Scalars['Boolean']['output']>;
  /** The list of all subdirectories relative to the given path inside the collector directory including the parent information. */
  collectorDirectoriesInfo: Maybe<FileChooser>;
  configuration: Maybe<Configuration>;
  /** The container for the content browser. */
  contentBrowser: Maybe<ContentBrowser>;
  contig: Maybe<Contig>;
  coordinateLists: Array<CoordinateList>;
  coordinateListsByGenome: Array<CoordinateList>;
  dashboards: Maybe<Array<Maybe<Dashboard>>>;
  databaseMnemonicExists: Maybe<Scalars['Boolean']['output']>;
  dataset: Maybe<Dataset>;
  datasets: Maybe<Array<Maybe<Dataset>>>;
  defaultDataset: Maybe<Dataset>;
  fileNameExistsInCollector: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fileScan: Maybe<Scalars['Boolean']['output']>;
  fileScanSynchronous: Maybe<Scalars['Boolean']['output']>;
  gene: Maybe<Gene>;
  /** The container for the genome viewer. */
  genomeViewer: Maybe<GenomeBrowserQuery>;
  /** Get virtual genomes that match the given component genomes */
  getVirtualGenomesForComponents: Maybe<Array<Maybe<Organism>>>;
  group: Maybe<Group>;
  groups: Maybe<GroupList>;
  /** Check Genome Identifier Validity and Uniqueness */
  isValidGenomeIdentifier: Maybe<Scalars['String']['output']>;
  /** Check Genome Name Validity and Uniqueness */
  isValidGenomeName: Maybe<Scalars['String']['output']>;
  /** The list of all accessible tags for this user. */
  itemTags: Array<ItemTag>;
  job: Maybe<JobData>;
  marker: Maybe<Marker>;
  /** The mutation information from the perspective of the selected reference. */
  mutation: Maybe<GenMutation>;
  notification: Maybe<Notification>;
  notifications: Maybe<Array<Maybe<Notification>>>;
  nuFeature: Maybe<NuFeature>;
  organism: Organism;
  /** A single organism property type */
  organismPropertyType: Maybe<OrganismPropertyType>;
  /** The list of organism property types filtered by organism or all if no list of organisms given. */
  organismPropertyTypes: Maybe<Array<Maybe<OrganismPropertyType>>>;
  organisms: Array<Organism>;
  playbook: Maybe<PlaybookQueryApi>;
  project: Maybe<Project>;
  projectActivities: Maybe<Array<Maybe<ProjectActivity>>>;
  projectActivity: Maybe<ProjectActivity>;
  /** Get project file by its ID. */
  projectFileById: Maybe<ProjectFile>;
  /** The list of project files visible to the user, by project visibility. Folders and index files are excluded. */
  projectFiles: Maybe<Array<Maybe<ProjectFile>>>;
  /** Get project files by their ID. */
  projectFilesById: Array<Maybe<ProjectFile>>;
  /** Returns the list of projects, optionally filtered and/or sorted for a dashboard card */
  projectList: Maybe<ProjectList>;
  projectNameDefined: Maybe<Scalars['Boolean']['output']>;
  protein: Maybe<Protein>;
  /** Provides a list of items related to recent activities ordered by most recent creation date. */
  recentItems: Maybe<Array<Maybe<RecentItem>>>;
  sample: Maybe<SampleQueryApi>;
  savedItems: Maybe<SavedItems>;
  savedVariantGroups: Maybe<GroupList>;
  search: Search;
  sequence: Maybe<Sequence>;
  sequenceFeatureTypes: Maybe<SequenceFeatureTypes>;
  sequenceGroupTypes: Maybe<Array<Maybe<SequenceGroupTypeCount>>>;
  sequenceIdentifiers: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Provides a list of available sequence types (excludes probe/probeset). */
  sequenceTypes: Maybe<Array<Maybe<SequenceType>>>;
  sequenceUploadValidation: Maybe<Array<Maybe<ValidationError>>>;
  setComparison: Maybe<SetComparison>;
  table: Maybe<Table>;
  template: Maybe<TemplateContainer>;
  transcript: Maybe<Transcript>;
  user: Maybe<User>;
  userGroup: Maybe<UserGroupContainer>;
  userParams: Maybe<UserParams>;
  /** A list of all existing values of a specific organism property type for the provided search term. The search is insensitive case, and if the search term is empty or null, all values for the specified type are returned. */
  valuesForOrganismPropertyType: Maybe<Array<Maybe<OrganismProperty>>>;
  /** @deprecated Deprecated */
  variant: Maybe<Variant>;
  variantAnalysisGroup: Maybe<VariantAnalysisGroup>;
  variantRelatedGenomes: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  view: Maybe<View>;
  workflow: WorkflowQueryApi;
};


/** Root object for all GraphQL queries */
export type QueryAaFeatureArgs = {
  aaFeatureId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryAnalyzerIdMappingArgs = {
  analyzerIdMappingInput: InputMaybe<InputAnalyzerIdMappingInput>;
};


/** Root object for all GraphQL queries */
export type QueryBlastIndicesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryBlastInputValidationArgs = {
  jobValidationData: InputMaybe<InputJobValidation>;
};


/** Root object for all GraphQL queries */
export type QueryCheckSequencedOrganismsArgs = {
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
};


/** Root object for all GraphQL queries */
export type QueryCollectorDirectoriesInfoArgs = {
  folderId: InputMaybe<Scalars['Long']['input']>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryContigArgs = {
  contigId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryCoordinateListsArgs = {
  coordinateListIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL queries */
export type QueryCoordinateListsByGenomeArgs = {
  genomeId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryDatabaseMnemonicExistsArgs = {
  mnemonic: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryDatasetArgs = {
  datasetId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryDatasetsArgs = {
  organismId?: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryDefaultDatasetArgs = {
  organismId?: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryFileNameExistsInCollectorArgs = {
  fileNames: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  folderId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryFileScanArgs = {
  relativeDir: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryFileScanSynchronousArgs = {
  relativeDir: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryGeneArgs = {
  geneId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryGetVirtualGenomesForComponentsArgs = {
  genomeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL queries */
export type QueryGroupArgs = {
  groupId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryGroupsArgs = {
  projectId?: InputMaybe<Scalars['Long']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryIsValidGenomeIdentifierArgs = {
  identifier: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryIsValidGenomeNameArgs = {
  name: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryItemTagsArgs = {
  projectId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryJobArgs = {
  jobId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryMarkerArgs = {
  markerId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryMutationArgs = {
  mutationId: InputMaybe<Scalars['Long']['input']>;
  refGenomeId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryNotificationArgs = {
  notificationId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryNotificationsArgs = {
  oldNotificationLimit: InputMaybe<Scalars['Int']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryNuFeatureArgs = {
  nuFeatureId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryOrganismArgs = {
  organismId: Scalars['Long']['input'];
};


/** Root object for all GraphQL queries */
export type QueryOrganismPropertyTypeArgs = {
  orgPropertyTypeId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryOrganismPropertyTypesArgs = {
  organismIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL queries */
export type QueryOrganismsArgs = {
  organismIds: Array<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryProjectArgs = {
  projectId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryProjectActivitiesArgs = {
  projectId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryProjectActivityArgs = {
  activityId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryProjectFileByIdArgs = {
  fileId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryProjectFilesArgs = {
  projectId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryProjectFilesByIdArgs = {
  fileIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root object for all GraphQL queries */
export type QueryProjectListArgs = {
  includeStagedProjects?: InputMaybe<Scalars['Boolean']['input']>;
  projectIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  sayId: InputMaybe<Scalars['Long']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryProjectNameDefinedArgs = {
  projectId?: InputMaybe<Scalars['Long']['input']>;
  projectName: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryProteinArgs = {
  proteinId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryRecentItemsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
};


/** Root object for all GraphQL queries */
export type QuerySavedItemsArgs = {
  filterTerm?: InputMaybe<Scalars['String']['input']>;
  itemTagIds: InputMaybe<Array<Scalars['Long']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QuerySavedVariantGroupsArgs = {
  analysisGroupId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QuerySequenceArgs = {
  sequenceId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QuerySequenceGroupTypesArgs = {
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
};


/** Root object for all GraphQL queries */
export type QuerySequenceIdentifiersArgs = {
  sequenceIdentifiersInputData: InputMaybe<InputSequenceIdentifiersInput>;
};


/** Root object for all GraphQL queries */
export type QuerySequenceUploadValidationArgs = {
  validationData: InputMaybe<InputSequenceUploadValidation>;
};


/** Root object for all GraphQL queries */
export type QuerySetComparisonArgs = {
  setComparisonInput: InputMaybe<InputSetComparisonInput>;
};


/** Root object for all GraphQL queries */
export type QueryTableArgs = {
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
};


/** Root object for all GraphQL queries */
export type QueryTranscriptArgs = {
  transcriptId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryValuesForOrganismPropertyTypeArgs = {
  orgPropertyTypeId: InputMaybe<Scalars['Long']['input']>;
  searchTerm: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryVariantArgs = {
  variantId: InputMaybe<Scalars['Long']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryVariantAnalysisGroupArgs = {
  entityId: InputMaybe<Scalars['Long']['input']>;
  mutationGroupId: InputMaybe<Scalars['Long']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};


/** Root object for all GraphQL queries */
export type QueryVariantRelatedGenomesArgs = {
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
};


/** Root object for all GraphQL queries */
export type QueryViewArgs = {
  viewId: InputMaybe<Scalars['Long']['input']>;
};

/** Genomic region object */
export type Range = {
  start: Scalars['Int']['output'];
  stop: Scalars['Int']['output'];
};

/** Genomic range input object */
export type RangeInput = {
  start: Scalars['Int']['output'];
  stop: Scalars['Int']['output'];
};

/** Contains the values for attribute defaults that can be resolved as a scalar. */
export type RawAttributeDefault = {
  defaultNumber: Maybe<Scalars['Float']['output']>;
  defaultTerm: Maybe<VocabularyTerm>;
  defaultText: Maybe<Scalars['String']['output']>;
  template: Maybe<Scalars['String']['output']>;
};

/** Maps the raw attribute default values to an attribute id */
export type RawAttributeDefaultMapEntry = {
  attributeId: Maybe<Scalars['Long']['output']>;
  data: Maybe<RawAttributeDefault>;
};

export type RecentItem = {
  created: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  subType: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

/** A region containing all information for a location on a contig. */
export type Region = {
  contig: Maybe<Contig>;
  hidden: Scalars['Boolean']['output'];
  range: Maybe<Range>;
  strand: Maybe<Scalars['String']['output']>;
};

/** A flag labelling a genomic region */
export type RegionFlag = PageRow & SavedItem & {
  color: Maybe<Scalars['String']['output']>;
  created: Scalars['String']['output'];
  creator: Maybe<User>;
  deletable: Maybe<Scalars['Boolean']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  itemTags: Maybe<Array<Maybe<ItemTag>>>;
  lastModifier: Maybe<User>;
  modified: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
  region: Maybe<Region>;
  samples: Maybe<Array<Maybe<Sample>>>;
  shared: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<Scalars['String']['output']>;
  typeDisplayName: Maybe<Scalars['String']['output']>;
};

export type RegionParam = ActivityParameter & {
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  optional: Scalars['Boolean']['output'];
  type: WorkflowParameterTypeEnum;
};

export type RegionValue = ParameterValue & {
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  value: Maybe<Region>;
};

export type RegionWithoutStrand = {
  contigId: Scalars['Long']['output'];
  range: Maybe<RangeInput>;
};

/** RelatedProjectData object */
export type RelatedProject = {
  activities: Maybe<Array<Maybe<ProjectActivity>>>;
  project: Maybe<Project>;
};

/** Resource files for the report template construction. */
export type ReportTemplateResources = {
  name: Maybe<Scalars['String']['output']>;
  size: Maybe<Scalars['Long']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** Contains additional restrictions for tables */
export type Restriction = {
  /** Analysis group for variant sub row filtering. */
  analysisGroupId: Maybe<Scalars['Long']['output']>;
  /** If present, the table should be limited to the specified types. */
  organismTypes: Maybe<Array<Maybe<SequencingTypeEnum>>>;
  /** If present, the table should be limited to the specified project. */
  projectId: Maybe<Scalars['Long']['output']>;
  /** Optional org_id of the reference genome for derived variants. */
  refGenomeId: Maybe<Scalars['Long']['output']>;
  /** If present, the table should be limited to the specified region. */
  region: Maybe<RegionWithoutStrand>;
  /** The selected ids and an intersection mode */
  selection: Maybe<IdSelection>;
  /** List of visible variant genomes for sub row filtering. */
  variantGenomeIds: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
};

export enum RetentionRuleEnum {
  /** D */
  D = 'D',
  /** M */
  M = 'M',
  /** N */
  N = 'N',
  /** W */
  W = 'W'
}

/** A user role */
export type Role = {
  /** The capabilities of this role, filtered by license key */
  capabilities: Maybe<Array<Maybe<Capability>>>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  legacy: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** The users that are assigned to this role. */
  users: Maybe<Array<Maybe<User>>>;
};

/** A GDA row annotation */
export type RowAnnotation = {
  field: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** A pair containing an item id and its index in the table. */
export type RowIndex = {
  id: Maybe<Scalars['Long']['output']>;
  rowIndex: Maybe<Scalars['Int']['output']>;
};

export type Sample = PageRow & {
  /** All applicable values for a sample as attribute values (including those for representer attributes). */
  allApplicableValues: Maybe<Array<Array<Maybe<AttributeValue>>>>;
  /** Returns the dynamic attribute with the specified identifier */
  attribute: Array<Maybe<AttributeValue>>;
  created: Maybe<Scalars['String']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Sample associations of playbook events. */
  eventSamples: Array<EventSample>;
  groupType: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  /** The list of changes for this sample ordered from newest to oldest. */
  history: Maybe<Array<ItemChange>>;
  id: Scalars['Long']['output'];
  locked: Maybe<Scalars['Boolean']['output']>;
  modified: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organism: Maybe<Organism>;
  parents: Array<Parent>;
  primaryParent: Maybe<Parent>;
  /** The project for this sample if it exists and is visible. */
  project: Maybe<Project>;
  receiver: Maybe<User>;
  relatedProjects: Array<RelatedProject>;
  /** List of reports link by the parent */
  reports: Array<ProjectFile>;
  status: Maybe<SampleStatus>;
  submitter: Maybe<User>;
  type: Maybe<SampleType>;
  /** All values belonging to the optional set of attribute IDs (including parent attributes). Additionally, the result set can also be filtered by the optional set of column set IDs. */
  valuesByAttributeId: Array<AttributeMultiValue>;
};


export type SampleAttributeArgs = {
  attribute: InputMaybe<Scalars['String']['input']>;
};


export type SampleValuesByAttributeIdArgs = {
  attributeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  columnSetIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Represents the count of the number of samples with given statuses. */
export type SampleCount = {
  parentType: Maybe<ParentType>;
  sampleCounts: Maybe<Array<Maybe<SampleCountStatus>>>;
  sampleType: Maybe<SampleType>;
};

/** Represents the count of the number of samples with a given status. */
export type SampleCountStatus = {
  modified: Maybe<Scalars['String']['output']>;
  parentCount: Maybe<Scalars['Long']['output']>;
  sampleCount: Maybe<Scalars['Long']['output']>;
  sampleStatus: Maybe<SampleStatus>;
};

export type SampleFileMapping = {
  projectFiles: Array<Maybe<ProjectFile>>;
  sample: Sample;
};

/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApi = {
  /** Create a new attribute from the given input. */
  createAttribute: Maybe<Attribute>;
  createParentType: Maybe<ParentType>;
  createSampleType: Maybe<SampleType>;
  /** Create a union group of samples from a list of parents. */
  createUnionSampleGroupFromParents: Maybe<Group>;
  /** Delete a list of existing attributes. */
  deleteAttributes: Maybe<Scalars['Boolean']['output']>;
  /** Delete existing parent types if possible. */
  deleteParentTypes: Maybe<Scalars['Boolean']['output']>;
  /** Delete a list of existing parents. */
  deleteParents: Maybe<Scalars['Boolean']['output']>;
  /** Delete existing sample types if possible. */
  deleteSampleTypes: Maybe<Scalars['Boolean']['output']>;
  /** Edit existing, delete or add sample parent attribute values */
  editParentAttributes: Maybe<Parent>;
  editParentType: Maybe<ParentType>;
  editSampleType: Maybe<SampleType>;
  editSamples: Maybe<Scalars['Boolean']['output']>;
  /** Change the modifiable properties of an existing attribute. */
  modifyAttribute: Maybe<Attribute>;
  /** Lock/unlock samples. */
  modifySampleLockingStatus: Maybe<Scalars['Boolean']['output']>;
  /**
   * Submits the data defined by the parents for analysis, as specified in the playbook for the given identifier.
   * @deprecated Explicit submission of NGS analysis is de-supported with Selector 6
   */
  submitAnalysis: Maybe<Scalars['Boolean']['output']>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiCreateAttributeArgs = {
  createAttributeInput: InputMaybe<InputAttributeInput>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiCreateParentTypeArgs = {
  createParentTypeInput: InputMaybe<InputParentTypeInput>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiCreateSampleTypeArgs = {
  createSampleTypeInput: InputMaybe<InputSampleTypeInput>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiCreateUnionSampleGroupFromParentsArgs = {
  parentIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiDeleteAttributesArgs = {
  attributeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiDeleteParentTypesArgs = {
  parentTypeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiDeleteParentsArgs = {
  parentIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiDeleteSampleTypesArgs = {
  sampleTypeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiEditParentAttributesArgs = {
  editParentInput: InputMaybe<InputEditParentInput>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiEditParentTypeArgs = {
  editParentTypeInput: InputMaybe<InputParentTypeInput>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiEditSampleTypeArgs = {
  editSampleTypeInput: InputMaybe<InputSampleTypeInput>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiEditSamplesArgs = {
  editSamplesInput: InputMaybe<InputEditSamplesInput>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiModifyAttributeArgs = {
  attributeInput: InputMaybe<InputAttributeInput>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiModifySampleLockingStatusArgs = {
  locked: Scalars['Boolean']['input'];
  sampleIds: Array<Scalars['Long']['input']>;
};


/** Root Mutation of the Sample Management API schema. */
export type SampleMutationApiSubmitAnalysisArgs = {
  identifier: InputMaybe<Scalars['String']['input']>;
  parentIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

export type SampleParam = ActivityParameter & {
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  multiSelect: Scalars['Boolean']['output'];
  optional: Scalars['Boolean']['output'];
  type: WorkflowParameterTypeEnum;
};

/** Root of the Sample Management API schema. */
export type SampleQueryApi = {
  /** Get all distinct sample attributes group names currently available in the database. */
  allSampleAttributesGroupNames: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Provides one single attribute. */
  attribute: Maybe<Attribute>;
  /** Provides all attributes that have a default with resolved default values. */
  attributeDefaults: Maybe<Array<Maybe<AttributeDefaultValueMapEntry>>>;
  /** Provides all attributes. */
  attributes: Maybe<Array<Maybe<Attribute>>>;
  dataset: Maybe<Dataset>;
  editSamplesGrid: Maybe<EditSamplesGrid>;
  parent: Maybe<Parent>;
  /** Provide information which entities will be deleted when deleting a parent */
  parentStatistics: Maybe<Array<Maybe<ParentStatistic>>>;
  parentType: Maybe<ParentType>;
  /** Validate a parent type name exists */
  parentTypeExists: Maybe<Scalars['Boolean']['output']>;
  parentTypes: Maybe<Array<Maybe<ParentType>>>;
  parents: Maybe<Array<Maybe<Parent>>>;
  /** Provides the raw/unresolved attribute defaults for the given sample type. */
  rawAttributeDefaults: Maybe<Array<Maybe<RawAttributeDefaultMapEntry>>>;
  sample: Maybe<Sample>;
  /** Provide information about the number of samples and parents with the specified statuses */
  sampleCounts: Maybe<SampleCount>;
  sampleStatusSets: Maybe<Array<Maybe<StatusSet>>>;
  sampleStatuses: Maybe<Array<Maybe<SampleStatus>>>;
  /** Returns the requested sample type if it is visible to the logged in user */
  sampleType: Maybe<SampleType>;
  /** Returns the requested sample type without checking for visibility */
  sampleTypeAdmin: Maybe<SampleType>;
  /** Validate a sample type name exists */
  sampleTypeExists: Maybe<Scalars['Boolean']['output']>;
  /** Returns all sample types that are visible to the logged in user */
  sampleTypes: Maybe<Array<Maybe<SampleType>>>;
  /** Returns all sample types */
  sampleTypesAdmin: Maybe<Array<Maybe<SampleType>>>;
  samples: Maybe<Array<Maybe<Sample>>>;
  samplesForParents: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  /** Returns the number of co-occurrences of the values for a sample type for use in an attribute value template. */
  templateCount: Maybe<Scalars['Int']['output']>;
  /** Counts the number of co-occurrences of the values for a sample type for use in an attribute value template, and returns the next number in sequence. */
  templateNext: Maybe<Scalars['Int']['output']>;
  /** Counts the number of co-occurrences of the values for a sample type for use in an attribute value template, and returns the next available sequence element. The sequence wraps when the count exceeds the sequence size. */
  templateNextElement: Maybe<Scalars['String']['output']>;
  /** Validate if a name can be assigned to a given parent. */
  validateParentNameInput: Maybe<Scalars['Boolean']['output']>;
  validateSamplesInput: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  valueIndexesOfSamples: Maybe<Scalars['ScalarMap']['output']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiAttributeArgs = {
  attributeId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiAttributeDefaultsArgs = {
  sampleTypeId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiDatasetArgs = {
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiEditSamplesGridArgs = {
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiParentArgs = {
  parentId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiParentStatisticsArgs = {
  parentIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiParentTypeArgs = {
  parentTypeId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiParentTypeExistsArgs = {
  parentTypeName: InputMaybe<Scalars['String']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiParentsArgs = {
  parentStatus: InputMaybe<Scalars['String']['input']>;
  parentType: InputMaybe<Scalars['String']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiRawAttributeDefaultsArgs = {
  sampleTypeId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiSampleArgs = {
  sampleId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiSampleCountsArgs = {
  parentType?: InputMaybe<Scalars['Long']['input']>;
  sampleType: InputMaybe<Scalars['Long']['input']>;
  statuses: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiSampleStatusesArgs = {
  statusClassId: InputMaybe<Scalars['Long']['input']>;
  statusSetId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiSampleTypeArgs = {
  sampleTypeId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiSampleTypeAdminArgs = {
  sampleTypeId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiSampleTypeExistsArgs = {
  sampleTypeName: InputMaybe<Scalars['String']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiSampleTypesArgs = {
  userGroupIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiSamplesArgs = {
  sampleIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiSamplesForParentsArgs = {
  parentIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiTemplateCountArgs = {
  sampleTypeId: InputMaybe<Scalars['Long']['input']>;
  values: InputMaybe<Array<InputMaybe<InputAttributeValueInput>>>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiTemplateNextArgs = {
  sampleTypeId: InputMaybe<Scalars['Long']['input']>;
  values: InputMaybe<Array<InputMaybe<InputAttributeValueInput>>>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiTemplateNextElementArgs = {
  loopOverSequence?: InputMaybe<Scalars['Boolean']['input']>;
  sampleTypeId: InputMaybe<Scalars['Long']['input']>;
  sequence: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  values: InputMaybe<Array<InputMaybe<InputAttributeValueInput>>>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiValidateParentNameInputArgs = {
  name: InputMaybe<Scalars['String']['input']>;
  parentId: InputMaybe<Scalars['Long']['input']>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiValidateSamplesInputArgs = {
  samplesValidationInput: InputMaybe<InputSamplesValidationInputData>;
};


/** Root of the Sample Management API schema. */
export type SampleQueryApiValueIndexesOfSamplesArgs = {
  attributeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  sampleIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Represents a sample status. */
export type SampleStatus = {
  color: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  statusClass: StatusClass;
  statusSets: Array<StatusSet>;
};

/** Represents a sample type. */
export type SampleType = PageRow & {
  allowManualStatusChange: Scalars['Boolean']['output'];
  attributeCount: Scalars['Long']['output'];
  created: Scalars['String']['output'];
  creator: User;
  deletedSampleCount: Scalars['Long']['output'];
  description: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  /** The filtered list of parent attributes for registration. */
  parentAttributes: Array<Attribute>;
  parentTypeSets: Array<ParentTypeSet>;
  playbooks: Array<Playbook>;
  /** The filtered list of sample attributes for registration. */
  sampleAttributes: Array<Attribute>;
  sampleCount: Scalars['Long']['output'];
  sampleStatuses: Array<SampleStatus>;
  /** Status set assigned to this Sample Type */
  statusSet: StatusSet;
  userGroups: Array<Maybe<UserGroup>>;
};


/** Represents a sample type. */
export type SampleTypeParentAttributesArgs = {
  unfiltered?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a sample type. */
export type SampleTypeSampleAttributesArgs = {
  excludeAnalytical?: InputMaybe<Scalars['Boolean']['input']>;
  unfiltered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SampleTypesByProjectGroup = {
  listing: Maybe<Array<Maybe<ListingMapEntry>>>;
};

export type SampleValue = ParameterValue & {
  attribute: Maybe<Attribute>;
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  value: Array<Maybe<SampleFileMapping>>;
};

export type SavedItem = {
  created: Scalars['String']['output'];
  creator: Maybe<User>;
  deletable: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  itemTags: Maybe<Array<Maybe<ItemTag>>>;
  modified: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
  samples: Maybe<Array<Maybe<Sample>>>;
  shared: Maybe<Scalars['Boolean']['output']>;
  type: Maybe<Scalars['String']['output']>;
  typeDisplayName: Maybe<Scalars['String']['output']>;
};

/** The container class for all saved items either by project or overall */
export type SavedItems = {
  /** The saved items of the specified type and optional subType, if required, limited by the project specified for the container. */
  items: Maybe<Array<Maybe<SavedItem>>>;
  listing: Maybe<Array<Maybe<SavedItemsListing>>>;
};


/** The container class for all saved items either by project or overall */
export type SavedItemsItemsArgs = {
  subType: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};

/** Provides summary information for saved items of a particular type. */
export type SavedItemsListing = {
  count: Maybe<Scalars['Long']['output']>;
  filteredCount: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  subType: Maybe<Scalars['String']['output']>;
  subTypeId: Maybe<Scalars['Long']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

/** Container object for search related endpoints. */
export type Search = {
  advancedSearch: Maybe<AdvancedSearchPreview>;
  advancedSearchConfig: Maybe<AdvancedSearchConfig>;
  assignableGenomes: Maybe<GenomeSearch>;
  contigSearch: ContigSearch;
  createAdvancedSearchResult: Maybe<SearchResult>;
  createSearchResult: Maybe<SearchResult>;
  globalSearch: Maybe<GlobalSearchSuggestions>;
  projectFilesContextSearch: ProjectFileSearch;
  /** Search project files with name starting by the given prefix. Search is case-insensitive and user group restrictions are applied. An optional regular expression representing the file extension can also be provided. */
  projectFilesSearch: Array<ProjectFileSearch>;
  searchResult: Maybe<SearchResult>;
  searchScopes: Maybe<Array<Maybe<SearchScope>>>;
  sequenceSearch: Maybe<SequenceSearch>;
  sequencedGenomes: GenomeSearch;
};


/** Container object for search related endpoints. */
export type SearchAdvancedSearchArgs = {
  searchParams: InputMaybe<InputAdvancedSearchInput>;
};


/** Container object for search related endpoints. */
export type SearchAssignableGenomesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Container object for search related endpoints. */
export type SearchContigSearchArgs = {
  genomeId: InputMaybe<Scalars['Long']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Container object for search related endpoints. */
export type SearchCreateAdvancedSearchResultArgs = {
  searchParams: InputMaybe<InputAdvancedSearchInput>;
};


/** Container object for search related endpoints. */
export type SearchCreateSearchResultArgs = {
  searchTerm: InputMaybe<Scalars['String']['input']>;
  types: InputMaybe<Array<InputMaybe<InputSearchEntityTypeInput>>>;
};


/** Container object for search related endpoints. */
export type SearchGlobalSearchArgs = {
  genomeId: InputMaybe<Scalars['Long']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  refGenomeId?: InputMaybe<Scalars['Long']['input']>;
  searchTerm: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<InputSearchEntityTypeInput>>>;
};


/** Container object for search related endpoints. */
export type SearchProjectFilesContextSearchArgs = {
  eventIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  fileExtensions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  folderId: InputMaybe<Scalars['Long']['input']>;
  genomeIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  parentIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  projectId: InputMaybe<Scalars['Long']['input']>;
  sampleIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  searchTerm: InputMaybe<Scalars['String']['input']>;
  sortOrder: InputMaybe<Scalars['String']['input']>;
};


/** Container object for search related endpoints. */
export type SearchProjectFilesSearchArgs = {
  extensionRegex: InputMaybe<Scalars['String']['input']>;
  searchTerms: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Container object for search related endpoints. */
export type SearchSearchResultArgs = {
  searchResultId: InputMaybe<Scalars['Long']['input']>;
};


/** Container object for search related endpoints. */
export type SearchSearchScopesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  restrictionType: InputMaybe<Scalars['String']['input']>;
  searchTerm: InputMaybe<Scalars['String']['input']>;
};


/** Container object for search related endpoints. */
export type SearchSequenceSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


/** Container object for search related endpoints. */
export type SearchSequencedGenomesArgs = {
  excludeVirtualGenomes?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type SearchAttribute = {
  cellType: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  field: Maybe<Scalars['String']['output']>;
  groupName: Maybe<Scalars['String']['output']>;
  /** Indicator if the number is an integer value. */
  isInteger: Maybe<Scalars['Boolean']['output']>;
  /** The optional upper bound of the value */
  maxValue: Maybe<Scalars['Float']['output']>;
  /** The optional lower bound of the value */
  minValue: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** The operators as key label pairs */
  operators: Maybe<Array<Maybe<KeyLabel>>>;
  /** The optional attributeData. Only present for sample columns backed by an attribute in the advanced search. */
  sampleAttribute: Maybe<Attribute>;
  /** The elements of the controlled vocabulary */
  values: Maybe<Array<Maybe<KeyLabel>>>;
};

/** The search results. */
export type SearchResult = {
  advancedSearchParams: Maybe<AdvancedSearchParams>;
  groups: Maybe<Array<Maybe<Group>>>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type SearchScope = {
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  restrictionType: Maybe<Scalars['String']['output']>;
  secondaryName: Maybe<Scalars['String']['output']>;
};

export type SearchType = {
  entityType: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  subTypeId: Maybe<Scalars['Long']['output']>;
  subTypeLabel: Maybe<Scalars['String']['output']>;
};

/** A selected column annotation */
export type SelectedColumnAnnotation = {
  conditionValues: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  label: Maybe<Scalars['String']['output']>;
};

/** A generic sequence DTO that can hold nucleotide and protein sequences */
export type Sequence = PageRow & {
  accession: Maybe<Scalars['String']['output']>;
  allClassifications: Maybe<Array<Maybe<Classification>>>;
  creator: Maybe<User>;
  database: Maybe<Database>;
  description: Maybe<Scalars['String']['output']>;
  entered: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  hidden: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  identifier: Maybe<Scalars['String']['output']>;
  /** Internal references */
  internalReferences: Maybe<Array<Maybe<Sequence>>>;
  length: Maybe<Scalars['Long']['output']>;
  mw: Maybe<Scalars['Float']['output']>;
  name: Maybe<Scalars['String']['output']>;
  organism: Maybe<Organism>;
  proteins: Maybe<Array<Maybe<Protein>>>;
  relatedProjects: Maybe<Array<Maybe<RelatedProject>>>;
  sequence: Maybe<Scalars['String']['output']>;
  sequenceGroup: Maybe<SequenceGroup>;
  sequenceId: Maybe<Scalars['String']['output']>;
  sequenceType: Maybe<Scalars['String']['output']>;
  species: Maybe<Species>;
  transcripts: Maybe<Array<Maybe<Transcript>>>;
  version: Maybe<Scalars['Int']['output']>;
};


/** A generic sequence DTO that can hold nucleotide and protein sequences */
export type SequenceSequenceArgs = {
  seqLengthLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** All available NuFeatureTypes, AaFeatureTypes, MarkerTypes */
export type SequenceFeatureTypes = {
  aaFeatureTypes: Maybe<Array<Maybe<AaFeatureType>>>;
  markerTypes: Maybe<Array<Maybe<MarkerType>>>;
  nuFeatureTypes: Maybe<Array<Maybe<NuFeatureType>>>;
};

/** A sequence group */
export type SequenceGroup = {
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Represents the count of the number of sequences with given sequence group type. */
export type SequenceGroupTypeCount = {
  genericSeqIds: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  sequenceGroup: Maybe<SequenceGroup>;
};

/** The sequence found by a search. */
export type SequenceSearch = {
  limit: Maybe<Scalars['Int']['output']>;
  searchTerm: Maybe<Scalars['String']['output']>;
  vectors: Maybe<Array<Maybe<Sequence>>>;
};

/** A sequence type */
export type SequenceType = {
  groupType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  label: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export enum SequencingTypeEnum {
  /** NOT_SEQUENCED */
  NotSequenced = 'NOT_SEQUENCED',
  /** PANGENOME */
  Pangenome = 'PANGENOME',
  /** PROTEIN_SYNTENY */
  ProteinSynteny = 'PROTEIN_SYNTENY',
  /** RE_SEQUENCED */
  ReSequenced = 'RE_SEQUENCED',
  /** RE_SEQUENCED_VCF */
  ReSequencedVcf = 'RE_SEQUENCED_VCF',
  /** SEQUENCED_ASSEMBLY */
  SequencedAssembly = 'SEQUENCED_ASSEMBLY',
  /** UNKNOWN */
  Unknown = 'UNKNOWN',
  /** VECTOR */
  Vector = 'VECTOR',
  /** VIRTUAL */
  Virtual = 'VIRTUAL'
}

/** Container for information about the servers */
export type Server = {
  /** Status info for the specified module */
  status: Maybe<ServerStatusInfo>;
};


/** Container for information about the servers */
export type ServerStatusArgs = {
  module: InputMaybe<Scalars['String']['input']>;
};

/** The status of an external (web) server */
export type ServerStatusInfo = {
  build: Maybe<Scalars['String']['output']>;
  jre: Maybe<Scalars['String']['output']>;
  /** Total available memory (MB) */
  memTotal: Maybe<Scalars['Int']['output']>;
  /** Currently used memory (MB) */
  memUsed: Maybe<Scalars['Int']['output']>;
  os: Maybe<Scalars['String']['output']>;
  remote: Maybe<Scalars['String']['output']>;
  runtime: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['String']['output']>;
};

/** Contains the element counts for the subsets of input sets. */
export type SetComparison = {
  left: Maybe<Scalars['Int']['output']>;
  middle: Maybe<Scalars['Int']['output']>;
  right: Maybe<Scalars['Int']['output']>;
};

/** A Simple Job */
export type SimpleJob = JobData & {
  created: Maybe<Scalars['String']['output']>;
  errorDescription: Maybe<Scalars['String']['output']>;
  /** The expiation date, or null if the job isn't scheduled for purging (yet). */
  expirationDate: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  owner: Maybe<User>;
  status: Maybe<JobStatusEnum>;
  tool: Maybe<Scalars['String']['output']>;
};

/** Column sort definition object */
export type SortData = {
  direction: Maybe<Scalars['String']['output']>;
  priority: Maybe<Scalars['Int']['output']>;
};

export enum SortOrderEnum {
  /** CUSTOM */
  Custom = 'CUSTOM',
  /** LAST_MODIFIED */
  LastModified = 'LAST_MODIFIED',
  /** NAME */
  Name = 'NAME',
  /** NEWEST */
  Newest = 'NEWEST',
  /** OWNER */
  Owner = 'OWNER',
  /** PROJECT */
  Project = 'PROJECT'
}

export type Source = {
  id: Maybe<Scalars['Long']['output']>;
  organisation: Maybe<Organisation>;
  owner: Maybe<Scalars['String']['output']>;
  sourceType: Maybe<SourceType>;
};

export type SourceType = {
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** The species DTO */
export type Species = {
  commonName: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  lineage: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  synonym: Maybe<Scalars['String']['output']>;
};

/** The props describing the layout of a split pane */
export type SplitPaneLayoutState = {
  hidden: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  verticalLayout: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a sample status class. */
export type StatusClass = {
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Represents a sample status set. */
export type StatusSet = {
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  statuses: Array<SampleStatus>;
};

export type StringConstraints = Constraints & {
  controlledValues: Maybe<Array<StringControlledValue>>;
  id: Maybe<Scalars['String']['output']>;
};

export type StringControlledValue = ControlledValue & {
  description: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** A map entry with a string value. */
export type StringMapEntry = {
  key: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  multiValueIndex: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['String']['output']>;
};

export type StringParam = ActivityParameter & {
  constraints: Maybe<StringConstraints>;
  defaultValue: Maybe<Array<Scalars['String']['output']>>;
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  multiSelect: Scalars['Boolean']['output'];
  optional: Scalars['Boolean']['output'];
  type: WorkflowParameterTypeEnum;
};

export type StringValue = ParameterValue & {
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  value: Array<Scalars['String']['output']>;
};

export enum SupportedExecutorsEnum {
  /** AWS */
  Aws = 'AWS',
  /** CLUSTER */
  Cluster = 'CLUSTER',
  /** LOCAL */
  Local = 'LOCAL'
}

/** Provides system parameters that should be exposed to the client. */
export type SystemParameter = {
  projectLabel: Maybe<Scalars['String']['output']>;
};

/** Table data object */
export type Table = {
  column: Maybe<Column>;
  columns: Maybe<Array<Maybe<Column>>>;
  filterExpression: Maybe<Scalars['String']['output']>;
  /** The count of items that passed all filters. */
  filteredRowCount: Maybe<Scalars['Int']['output']>;
  pageRows: Maybe<Array<Maybe<PageRow>>>;
  /** The total count restricted to the given region */
  restrictedRowCount: Maybe<Scalars['Int']['output']>;
  rowIds: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  rowIndex: Maybe<RowIndex>;
  templates: Maybe<Array<Maybe<Template>>>;
  /** The item count without row filters */
  totalRowCount: Maybe<Scalars['Int']['output']>;
};


/** Table data object */
export type TableColumnArgs = {
  columnId: InputMaybe<Scalars['Long']['input']>;
};


/** Table data object */
export type TableRowIndexArgs = {
  itemId: InputMaybe<Scalars['Long']['input']>;
};

export type TableParam = ActivityParameter & {
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  optional: Scalars['Boolean']['output'];
  tableType: TableParamTypeEnum;
  type: WorkflowParameterTypeEnum;
};

export enum TableParamTypeEnum {
  /** COORDINATE_LIST */
  CoordinateList = 'COORDINATE_LIST',
  /** VARIANT */
  Variant = 'VARIANT'
}

/** Specifies the parameters for a request of tabular data. */
export type TableQuerySpec = {
  /** Primary id for defining the table. Either a group id or an entity id. */
  id: Maybe<Scalars['Long']['output']>;
  /** The type of 'id', either 'GROUP' or 'ENTITY'. */
  idType: Maybe<Scalars['String']['output']>;
  /** Limits the result to a single page. */
  pagination: Maybe<PaginationInput>;
  /** The type of the entity that 'id' refers to. Only set for 'idType' ENTITY. */
  queryType: Maybe<Scalars['String']['output']>;
  /** Structurally limits the table to a genome, region and or selected ids. */
  restrictions: Maybe<Restriction>;
  /** The sub type of rows for the table. Determines the concrete table type for nuFeature/aaFeature tables. Null otherwise. */
  resultSubTypeId: Maybe<Scalars['Long']['output']>;
  /** The type of rows for the table. (e.g. Gene for a gene table.) */
  resultType: Maybe<Scalars['String']['output']>;
  /** The RSQL formatted filter expressions that restrict the rows for this table. */
  rowFilter: Maybe<Scalars['String']['output']>;
  /** The row sort order as comma separated list of fields where the '-' prefix indicates descending order. */
  rowSorting: Maybe<Scalars['String']['output']>;
};

export type TableValue = ParameterValue & {
  deleted: Maybe<Scalars['Boolean']['output']>;
  entityId: Maybe<Scalars['Long']['output']>;
  hidden: Scalars['Boolean']['output'];
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  value: Maybe<View>;
};

/** View state of a table view. */
export type TableViewState = {
  columns: Maybe<Array<Maybe<Column>>>;
  expansionPath: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filteredRowCount: Maybe<Scalars['Int']['output']>;
  rowIds: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  selectedIds: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  tableQuerySpec: Maybe<TableQuerySpec>;
  totalRowCount: Maybe<Scalars['Int']['output']>;
};

export type Tag = {
  color: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Taxonomy = PageRow & {
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Maybe<Scalars['String']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
};

/** Represents a template. */
export type Template = {
  active: Maybe<Scalars['Boolean']['output']>;
  columns: Maybe<Array<Maybe<Column>>>;
  default: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  selected: Maybe<Scalars['Boolean']['output']>;
};

/** Contains endpoints for handling templates */
export type TemplateContainer = {
  /** Deletes an existing template. */
  deleteTemplate: Maybe<Scalars['Boolean']['output']>;
  /** Loads an existing template. */
  loadTemplate: Maybe<Template>;
  /** Saves a new template. */
  saveTemplate: Maybe<Template>;
  /** Applies changes to the active template. */
  updateActive: Maybe<Scalars['Boolean']['output']>;
  /** Updates an existing template. */
  updateTemplate: Maybe<Template>;
};


/** Contains endpoints for handling templates */
export type TemplateContainerDeleteTemplateArgs = {
  templateId: InputMaybe<Scalars['Long']['input']>;
};


/** Contains endpoints for handling templates */
export type TemplateContainerLoadTemplateArgs = {
  tableSpec: InputMaybe<InputTableQuerySpec>;
  templateId: InputMaybe<Scalars['Long']['input']>;
};


/** Contains endpoints for handling templates */
export type TemplateContainerSaveTemplateArgs = {
  columns: InputMaybe<Array<InputMaybe<InputColumnInput>>>;
  name: InputMaybe<Scalars['String']['input']>;
  tableSpec: InputMaybe<InputTableQuerySpec>;
};


/** Contains endpoints for handling templates */
export type TemplateContainerUpdateActiveArgs = {
  columns: InputMaybe<Array<InputMaybe<InputColumnInput>>>;
  tableSpec: InputMaybe<InputTableQuerySpec>;
};


/** Contains endpoints for handling templates */
export type TemplateContainerUpdateTemplateArgs = {
  columns: InputMaybe<Array<InputMaybe<InputColumnInput>>>;
  tableSpec: InputMaybe<InputTableQuerySpec>;
  templateId: InputMaybe<Scalars['Long']['input']>;
};

export type Tool = {
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  requireInternetConnection: Maybe<Scalars['Boolean']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

/** Represents a feature track. */
export type Track = {
  name: Maybe<Scalars['String']['output']>;
  pinned: Maybe<Scalars['String']['output']>;
  subTypeId: Maybe<Scalars['Long']['output']>;
  trackCustomization: Maybe<TrackCustomization>;
  type: Maybe<Scalars['String']['output']>;
};

/** Represents bed configuration data. */
export type TrackBedConfiguration = {
  orderedBedFiles: Maybe<Array<Maybe<TrackBedOrderedBedFile>>>;
};

/** Represents ordered bed files data. */
export type TrackBedOrderedBedFile = {
  bedFileId: Maybe<Scalars['Long']['output']>;
  collapsed: Maybe<Scalars['Boolean']['output']>;
  color: Maybe<Scalars['String']['output']>;
};

/** Represents coordinate configuration data. */
export type TrackCoordinateConfiguration = {
  orderedCoordinateLists: Maybe<Array<Maybe<TrackCoordinateOrderedCoordinateList>>>;
};

/** Represents ordered coordinate lists data. */
export type TrackCoordinateOrderedCoordinateList = {
  collapsed: Maybe<Scalars['Boolean']['output']>;
  color: Maybe<Scalars['String']['output']>;
  coordinateListId: Maybe<Scalars['Long']['output']>;
};

/** Represents track customization data. */
export type TrackCustomization = {
  bedConfiguration: Maybe<TrackBedConfiguration>;
  configuredPhenotypes: Maybe<Array<Maybe<TrackPhenotypeConfiguration>>>;
  coordinateConfiguration: Maybe<TrackCoordinateConfiguration>;
  expressionColoring: Maybe<TrackExpressionColoring>;
  ngsConfiguration: Maybe<TrackNgsConfiguration>;
};

/** Represents track features expression coloring data. */
export type TrackExpressionColoring = {
  colorScheme: Maybe<ColorScheme>;
  conditions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  datasetId: Maybe<Scalars['Long']['output']>;
  logScale: Maybe<Scalars['Boolean']['output']>;
  maxValue: Maybe<Scalars['Float']['output']>;
  minValue: Maybe<Scalars['Float']['output']>;
};

/** Data container for features returned by a genome browser track range query */
export type TrackFeatures = {
  contig: Maybe<Contig>;
  featureType: Maybe<Scalars['String']['output']>;
  features: Maybe<Array<Maybe<Feature>>>;
  overflow: Maybe<Scalars['Boolean']['output']>;
  range: Maybe<Range>;
  subTypeId: Maybe<Scalars['Long']['output']>;
};

/** Bundles items and the groups the items are part of - or nothing in case of data overflow */
export type TrackGroupIndicator = {
  itemGroupIndicatorData: Maybe<Array<Maybe<ItemGroupIndicator>>>;
  overflow: Maybe<Scalars['Boolean']['output']>;
};

/** Represents ngs configuration data. */
export type TrackNgsConfiguration = {
  coverageConfig: Maybe<TrackNgsCoverageConfiguration>;
  orderedBamFiles: Maybe<Array<Maybe<TrackNgsOrderedBamFilesData>>>;
};

/** Represents ngs coverage configuration data. */
export type TrackNgsCoverageConfiguration = {
  logScale: Maybe<Scalars['Boolean']['output']>;
  yAxisScaling: Maybe<Scalars['String']['output']>;
  yAxisScalingMax: Maybe<Scalars['Float']['output']>;
  yAxisScalingMin: Maybe<Scalars['Float']['output']>;
};

/** Represents ngs ordered bam files data. */
export type TrackNgsOrderedBamFilesData = {
  bamFileId: Maybe<Scalars['Long']['output']>;
  coverageColor: Maybe<Scalars['String']['output']>;
  pileupColoring: Maybe<Scalars['String']['output']>;
  pileupDensity: Maybe<Scalars['String']['output']>;
  pileupIncludeSoftClippedReads: Maybe<Scalars['Boolean']['output']>;
  pileupLanesCount: Maybe<Scalars['Int']['output']>;
  visiblePileup: Maybe<Scalars['Boolean']['output']>;
};

/** Container for nu profiles returned by a genome browser track range query */
export type TrackNuProfile = {
  contig: Maybe<Contig>;
  overflow: Maybe<Scalars['Boolean']['output']>;
  profiles: Maybe<Array<Maybe<NuProfile>>>;
  range: Maybe<Range>;
  type: Maybe<Scalars['String']['output']>;
};

/** Represents phenotype display configuration data in the variants tracks. */
export type TrackPhenotypeConfiguration = {
  colorScheme: Maybe<ColorScheme>;
  configuredTerms: Maybe<Array<Maybe<TrackPhenotypeTermConfiguration>>>;
  id: Maybe<Scalars['Long']['output']>;
  idType: Maybe<Scalars['String']['output']>;
  logScale: Maybe<Scalars['Boolean']['output']>;
  maxValue: Maybe<Scalars['Float']['output']>;
  minValue: Maybe<Scalars['Float']['output']>;
};

/** Represents phenotype term configuration data in the variants tracks. */
export type TrackPhenotypeTermConfiguration = {
  color: Maybe<Scalars['String']['output']>;
  term: Maybe<Scalars['String']['output']>;
};

/** The contig sequence for a genomic region */
export type TrackSequence = {
  contig: Maybe<Contig>;
  range: Maybe<Range>;
  sequence: Maybe<Scalars['String']['output']>;
};

/** The mutations contained in a sequence region. */
export type TrackVcfVariants = {
  /** The reference contig */
  contig: Maybe<Contig>;
  filterExpression: Maybe<Scalars['String']['output']>;
  overflow: Maybe<Scalars['Boolean']['output']>;
  range: Maybe<Range>;
  refGenomeId: Maybe<Scalars['Long']['output']>;
  variantCount: Maybe<Scalars['Int']['output']>;
  variants: Maybe<Array<Maybe<VcfVariant>>>;
};

/** The mutations contained in a sequence region. */
export type TrackVariants = {
  contig: Maybe<Contig>;
  filterExpression: Maybe<Scalars['String']['output']>;
  overflow: Maybe<Scalars['Boolean']['output']>;
  range: Maybe<Range>;
  refGenomeId: Maybe<Scalars['Long']['output']>;
  variantCount: Maybe<Scalars['Int']['output']>;
  variants: Maybe<Array<Maybe<Variant>>>;
};

export enum TrackerEnum {
  /** INPUT */
  Input = 'INPUT',
  /** OUTPUT */
  Output = 'OUTPUT'
}

export type TrackerParam = ActivityParameter & {
  description: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  group: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  multiSelect: Scalars['Boolean']['output'];
  optional: Scalars['Boolean']['output'];
  tracker: TrackerEnum;
  type: WorkflowParameterTypeEnum;
};

export type TrackerValue = ParameterValue & {
  /** IGNORE! Interface of polymorphic GraphQL objects must declare at least one field. Since there's no common field for this use-case, this field is used and will always return NULL. */
  id: Maybe<Scalars['String']['output']>;
  value: Maybe<Attribute>;
};

/** Transcript object for */
export type Transcript = PageRow & {
  accession: Maybe<Scalars['String']['output']>;
  allClassifications: Maybe<Array<Maybe<Classification>>>;
  /** External references except literature for use in summary pages. */
  allExternalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  classification: Maybe<Array<Maybe<Classification>>>;
  creator: Maybe<User>;
  database: Maybe<Database>;
  description: Maybe<Scalars['String']['output']>;
  /** External references except literature */
  externalReference: Maybe<Array<Maybe<ExternalReference>>>;
  /** External references except literature */
  externalReferences: Maybe<Array<Maybe<ExternalReference>>>;
  gene: Maybe<Gene>;
  genes: Maybe<Array<Maybe<Gene>>>;
  genome: Maybe<Organism>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  /** Internal references */
  internalReferences: Maybe<Array<Maybe<Sequence>>>;
  length: Maybe<Scalars['Long']['output']>;
  /** External references of type literature */
  literatureReferences: Maybe<Array<Maybe<ExternalReference>>>;
  name: Maybe<Scalars['String']['output']>;
  proteins: Maybe<Array<Maybe<Protein>>>;
  relatedProjects: Maybe<Array<Maybe<RelatedProject>>>;
  sequenceId: Maybe<Scalars['String']['output']>;
  sequenceType: Maybe<Scalars['String']['output']>;
  sequenceTypeId: Maybe<Scalars['Long']['output']>;
  species: Maybe<Species>;
  transcriptLocations: Maybe<Array<Maybe<TranscriptLocation>>>;
  userGroups: Maybe<Array<Maybe<UserGroup>>>;
  version: Maybe<Scalars['Int']['output']>;
};


/** Transcript object for */
export type TranscriptClassificationArgs = {
  classification: InputMaybe<Scalars['String']['input']>;
};


/** Transcript object for */
export type TranscriptExternalReferenceArgs = {
  externalReference: InputMaybe<Scalars['String']['input']>;
};

/** TranscriptLocation object */
export type TranscriptLocation = PageRow & {
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  region: Maybe<Region>;
  transcript: Maybe<Transcript>;
  transcriptMappings: Maybe<Array<Maybe<Range>>>;
};

export enum UiContextEnum {
  /** COORDINATE_LISTS */
  CoordinateLists = 'COORDINATE_LISTS',
  /** GENOME_VIEWER */
  GenomeViewer = 'GENOME_VIEWER',
  /** GENOME_VIEWER_VARIANTS_TRACK */
  GenomeViewerVariantsTrack = 'GENOME_VIEWER_VARIANTS_TRACK',
  /** PLAYBOOK_PAGE */
  PlaybookPage = 'PLAYBOOK_PAGE',
  /** VARIANTS */
  Variants = 'VARIANTS'
}

/** The information of a user session. */
export type User = PageRow & {
  accountStatus: Maybe<UserAccountStatusEnum>;
  capabilities: Maybe<Array<Maybe<Capability>>>;
  display: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  isActive: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  lastUse: Maybe<Scalars['String']['output']>;
  params: Maybe<UserParams>;
  picture: Maybe<Scalars['String']['output']>;
  roles: Maybe<Array<Maybe<Role>>>;
  userGroups: Maybe<Array<Maybe<UserGroup>>>;
  username: Maybe<Scalars['String']['output']>;
};

export enum UserAccountStatusEnum {
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** EXPIRED_AND_LOCKED */
  ExpiredAndLocked = 'EXPIRED_AND_LOCKED',
  /** EXPIRED_AND_LOCKED_TIMED */
  ExpiredAndLockedTimed = 'EXPIRED_AND_LOCKED_TIMED',
  /** EXPIRED_GRACE */
  ExpiredGrace = 'EXPIRED_GRACE',
  /** EXPIRED_GRACE_AND_LOCKED */
  ExpiredGraceAndLocked = 'EXPIRED_GRACE_AND_LOCKED',
  /** EXPIRED_GRACE_AND_LOCKED_TIMED */
  ExpiredGraceAndLockedTimed = 'EXPIRED_GRACE_AND_LOCKED_TIMED',
  /** LOCKED */
  Locked = 'LOCKED',
  /** LOCKED_TIMED */
  LockedTimed = 'LOCKED_TIMED',
  /** OPEN */
  Open = 'OPEN',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

/** Container object that contains user related endpoints. */
export type UserContainer = {
  /** Get the limits for Oracle passwords */
  oraclePasswordLimits: Maybe<OraclePasswordLimit>;
};

/** The user group that defines access rights of user to genomes. */
export type UserGroup = {
  accessibleProjects: Array<Project>;
  description: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  isPrivate: Scalars['Boolean']['output'];
  members: Array<User>;
  name: Scalars['String']['output'];
  organisms: Array<Organism>;
  projects: Array<Project>;
  sampleTypes: Array<SampleType>;
  sequencedOrganisms: Array<Organism>;
};


/** The user group that defines access rights of user to genomes. */
export type UserGroupAccessibleProjectsArgs = {
  includeStagedProjects: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


/** The user group that defines access rights of user to genomes. */
export type UserGroupProjectsArgs = {
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};

/** Container object that contains user group related endpoints. */
export type UserGroupContainer = {
  accessibleUserGroups: Array<UserGroup>;
  /** Checks if all given flags can be copied to the given project. */
  canCopyFlags: Maybe<Scalars['Boolean']['output']>;
  /** Checks if all given groups can be copied to the given project. */
  canCopyGroups: Maybe<Scalars['Boolean']['output']>;
  /** Checks if all given views can be copied to the given project. */
  canCopyViews: Maybe<Scalars['Boolean']['output']>;
  /** Checks the content of the view is valid for the selected project. */
  canSaveView: Maybe<Scalars['Boolean']['output']>;
  create: Maybe<UserGroup>;
  delete: Scalars['Boolean']['output'];
  modify: Maybe<UserGroup>;
  nameExists: Scalars['Boolean']['output'];
  userGroups: Array<UserGroup>;
  validateItems: Maybe<UserGroupItemValidationResult>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerAccessibleUserGroupsArgs = {
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerCanCopyFlagsArgs = {
  flagIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  projectId: InputMaybe<Scalars['Long']['input']>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerCanCopyGroupsArgs = {
  groupIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  projectId: InputMaybe<Scalars['Long']['input']>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerCanCopyViewsArgs = {
  projectId: InputMaybe<Scalars['Long']['input']>;
  viewIds: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerCanSaveViewArgs = {
  viewInputData: InputMaybe<InputViewInput>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerCreateArgs = {
  userGroupInputData: InputMaybe<InputUserGroupInput>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerDeleteArgs = {
  userGroupId: InputMaybe<Scalars['Long']['input']>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerModifyArgs = {
  userGroupInputData: InputMaybe<InputUserGroupInput>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerNameExistsArgs = {
  userGroupInputData: InputMaybe<InputUserGroupInput>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerUserGroupsArgs = {
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


/** Container object that contains user group related endpoints. */
export type UserGroupContainerValidateItemsArgs = {
  projectId: InputMaybe<Scalars['Long']['input']>;
  tableQuerySpec: InputMaybe<InputTableQuerySpec>;
  targetType: InputMaybe<Scalars['String']['input']>;
};

export type UserGroupItemValidationResult = {
  totalItemCount: Maybe<Scalars['Int']['output']>;
  userGroup: Maybe<Scalars['String']['output']>;
  visibleItemCount: Maybe<Scalars['Int']['output']>;
};

/** Container object that contains user mutation related endpoints which do not require admin rights. */
export type UserMutation = {
  /** Change your own password */
  changeYourPassword: Maybe<Scalars['Boolean']['output']>;
  /** Generate REST API authentication token. */
  generateRestToken: Maybe<Scalars['String']['output']>;
};


/** Container object that contains user mutation related endpoints which do not require admin rights. */
export type UserMutationChangeYourPasswordArgs = {
  userPasswordChangeRequestInput: InputMaybe<InputUserPasswordChangeRequestInput>;
};


/** Container object that contains user mutation related endpoints which do not require admin rights. */
export type UserMutationGenerateRestTokenArgs = {
  lifetime: InputMaybe<Scalars['Int']['input']>;
};

/** The user parameters */
export type UserParams = {
  condensedFlagsDisplay: Maybe<Scalars['Boolean']['output']>;
  defaultTracks: Maybe<Array<Maybe<Track>>>;
  firstLogin: Maybe<Scalars['Boolean']['output']>;
  homeItemSortOrder: Maybe<Scalars['String']['output']>;
  lastAdvancedSearchSubTypeId: Maybe<Scalars['Long']['output']>;
  lastAdvancedSearchType: Maybe<Scalars['String']['output']>;
  lastSaveTarget: Maybe<Scalars['Long']['output']>;
  projectItemSortOrder: Maybe<Scalars['String']['output']>;
  referenceGenome: Maybe<Scalars['Long']['output']>;
  showCommunityAnnotations: Maybe<Scalars['Boolean']['output']>;
  showFlagsTrack: Maybe<Scalars['Boolean']['output']>;
  showTips: Maybe<Scalars['Boolean']['output']>;
  useSpecificFlagsColoring: Maybe<Scalars['Boolean']['output']>;
  wrapColumnHeaders: Maybe<Scalars['Boolean']['output']>;
};

export type UsersByUserGroup = {
  listing: Maybe<Array<Maybe<ListingMapEntry>>>;
};

/** A sequence variation object based a mutation. */
export type VcfVariant = PageRow & {
  allele: Maybe<Scalars['String']['output']>;
  alleleLength: Maybe<Scalars['Long']['output']>;
  altAllele: Maybe<Scalars['String']['output']>;
  altAlleleLength: Maybe<Scalars['Int']['output']>;
  annAaPosByLength: Maybe<Scalars['String']['output']>;
  annAllele: Maybe<Scalars['String']['output']>;
  annAnnotation: Maybe<Scalars['String']['output']>;
  annAnnotationImpact: Maybe<Scalars['String']['output']>;
  annCDNAPosByLength: Maybe<Scalars['String']['output']>;
  annCdsPosByLength: Maybe<Scalars['String']['output']>;
  annDistance: Maybe<Scalars['String']['output']>;
  annErrorsWarningsInfo: Maybe<Scalars['String']['output']>;
  annFeatureId: Maybe<Scalars['String']['output']>;
  annFeatureType: Maybe<Scalars['String']['output']>;
  annGeneId: Maybe<Scalars['String']['output']>;
  annGeneName: Maybe<Scalars['String']['output']>;
  annHgvsC: Maybe<Scalars['String']['output']>;
  annHgvsP: Maybe<Scalars['String']['output']>;
  annRank: Maybe<Scalars['String']['output']>;
  annTranscriptBioType: Maybe<Scalars['String']['output']>;
  fractionInformativeReads: Maybe<Scalars['BigDecimal']['output']>;
  groupType: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  interpolatedGeneticPosition: Maybe<Scalars['String']['output']>;
  isPresent: Maybe<Scalars['Boolean']['output']>;
  isReference: Maybe<Scalars['Boolean']['output']>;
  lofGeneId: Maybe<Scalars['String']['output']>;
  lofGeneName: Maybe<Scalars['String']['output']>;
  lofNunTranscriptsInGene: Maybe<Scalars['String']['output']>;
  lofPercTranscriptsAffected: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  nmdGeneId: Maybe<Scalars['String']['output']>;
  nmdGeneName: Maybe<Scalars['String']['output']>;
  nmdNumTranscriptsInGene: Maybe<Scalars['String']['output']>;
  nmdPercTranscriptsAffected: Maybe<Scalars['String']['output']>;
  profile: Maybe<Scalars['String']['output']>;
  profileVariant: Maybe<Array<Maybe<ProfileVariantData>>>;
  refAllele: Maybe<Scalars['String']['output']>;
  refAlleleLength: Maybe<Scalars['Long']['output']>;
  /** Genome as listed in the index, if present. */
  refGenome: Maybe<Organism>;
  region: Maybe<Region>;
  varianceConfidenceQuality: Maybe<Scalars['BigDecimal']['output']>;
  variantType: Maybe<Scalars['String']['output']>;
  vcfVariantInstances: Maybe<Array<Maybe<VcfVariantInstance>>>;
};

/** VCF Variant Instance data. */
export type VcfVariantInstance = {
  alleleFraction: Maybe<Scalars['String']['output']>;
  getVarGenomeId: Maybe<Scalars['Long']['output']>;
  indelCount: Maybe<Scalars['String']['output']>;
  noCall: Maybe<Scalars['Boolean']['output']>;
  qiAllelicDepthsOrderedByGt: Maybe<Scalars['Int']['output']>;
  qiCallStrength: Maybe<Scalars['String']['output']>;
  qiCallTotals: Maybe<Scalars['Int']['output']>;
  qiGenotype: Maybe<Scalars['String']['output']>;
  qiGenotypeQuality: Maybe<Scalars['Int']['output']>;
  qiGenotypeTotals: Maybe<Scalars['Int']['output']>;
  qiReadDepth: Maybe<Scalars['Int']['output']>;
  qiSampleCountWithCoverage: Maybe<Scalars['Int']['output']>;
  qiVariantStatus: Maybe<Scalars['String']['output']>;
  snpPhredLikelihood: Maybe<Scalars['String']['output']>;
  varGenome: Maybe<Organism>;
  zygosity: Maybe<Scalars['String']['output']>;
};

/** Description of a validation failure */
export type ValidationError = {
  inputName: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
};

/** A sequence variation object based on an underlying mutation info entity. */
export type Variant = PageRow & {
  affectedGenomes: Maybe<Array<Maybe<Organism>>>;
  allele: Maybe<Scalars['String']['output']>;
  alleleLength: Maybe<Scalars['Long']['output']>;
  altAllele: Maybe<Scalars['String']['output']>;
  altAlleleLength: Maybe<Scalars['Long']['output']>;
  coverage: Maybe<Scalars['Long']['output']>;
  description: Maybe<Scalars['String']['output']>;
  effect: Maybe<Scalars['String']['output']>;
  geneMutations: Maybe<Array<Maybe<GeneMutation>>>;
  genome: Maybe<Organism>;
  groupType: Scalars['String']['output'];
  /** The genes that start the closest after end of this variant. */
  higherGenes: Maybe<Array<Maybe<Gene>>>;
  /** The variants that start the closest after the end of this variant. */
  higherVariants: Maybe<Array<Maybe<Variant>>>;
  id: Scalars['Long']['output'];
  isPresent: Maybe<Scalars['Boolean']['output']>;
  isReference: Maybe<Scalars['Boolean']['output']>;
  locationClass: Maybe<Scalars['String']['output']>;
  /** The genes that end the closest before the start of this variant. */
  lowerGenes: Maybe<Array<Maybe<Gene>>>;
  /** The variants that end the closet before the start of this variant. */
  lowerVariants: Maybe<Array<Maybe<Variant>>>;
  /** @deprecated Deprecated */
  matchesReference: Maybe<Scalars['Boolean']['output']>;
  mutId: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  preferredName: Maybe<Scalars['String']['output']>;
  profile: Maybe<Array<Maybe<ProfileDerivedVariant>>>;
  proteinMutations: Maybe<Array<Maybe<ProteinMutation>>>;
  quality: Maybe<Scalars['Float']['output']>;
  refAllele: Maybe<Scalars['String']['output']>;
  refAlleleLength: Maybe<Scalars['Long']['output']>;
  refGenome: Maybe<Organism>;
  refRegion: Maybe<Region>;
  refVariant: Maybe<Variant>;
  refVariants: Maybe<Array<Maybe<Variant>>>;
  region: Maybe<Region>;
  userGroups: Maybe<Array<Maybe<UserGroup>>>;
  variantAnalysisGroup: Maybe<VariantAnalysisGroup>;
  variantType: Maybe<Scalars['String']['output']>;
  zygosity: Maybe<Scalars['String']['output']>;
};

/** The analysis group DTO */
export type VariantAnalysisGroup = {
  genomes: Maybe<Array<Maybe<Organism>>>;
  id: Maybe<Scalars['Long']['output']>;
  name: Maybe<Scalars['String']['output']>;
  refGenomes: Maybe<Array<Maybe<Organism>>>;
  totalGenomeCount: Maybe<Scalars['Long']['output']>;
};


/** The analysis group DTO */
export type VariantAnalysisGroupGenomesArgs = {
  genomeIds?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
};

/** Stats object with the counts for each mutation type on this contig */
export type VariantCounts = {
  deletion: Maybe<Scalars['Long']['output']>;
  indel: Maybe<Scalars['Long']['output']>;
  insertion: Maybe<Scalars['Long']['output']>;
  point: Maybe<Scalars['Long']['output']>;
  translocationDeletion: Maybe<Scalars['Long']['output']>;
  translocationInsertion: Maybe<Scalars['Long']['output']>;
};

export type VariantUiContext = PlaybookUiContext & {
  context: UiContextEnum;
  genomeParam: ParameterMapping;
  tableParam: ParameterMapping;
};

export type Version = {
  color: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** A saved view with params and state */
export type View = SavedItem & {
  created: Scalars['String']['output'];
  creator: Maybe<User>;
  deletable: Maybe<Scalars['Boolean']['output']>;
  deleted: Maybe<Scalars['Boolean']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  itemTags: Maybe<Array<Maybe<ItemTag>>>;
  modified: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  owner: Maybe<Scalars['String']['output']>;
  params: Maybe<Scalars['String']['output']>;
  project: Maybe<Project>;
  samples: Maybe<Array<Maybe<Sample>>>;
  shared: Maybe<Scalars['Boolean']['output']>;
  state: Maybe<ViewState>;
  type: Maybe<Scalars['String']['output']>;
  typeDisplayName: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['Int']['output']>;
  viewLabel: Maybe<Scalars['String']['output']>;
  viewType: Maybe<Scalars['String']['output']>;
};

/** The expanded view state object */
export type ViewState = {
  blastView: Maybe<BlastViewState>;
  contentBrowserView: Maybe<ContentBrowserViewState>;
  datasetView: Maybe<DatasetViewState>;
  genomeView: Maybe<GenomeViewState>;
  summaryView: Maybe<EntitySummaryViewState>;
  tableView: Maybe<TableViewState>;
};

/** Represents a vocabulary term. */
export type VocabularyTerm = {
  attribute: Attribute;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
};

/** Approved workflows coming from Processor. */
export type Workflow = {
  approvalDate: Maybe<Scalars['String']['output']>;
  exportedFields: Maybe<Array<Maybe<ExportWorkflowField>>>;
  isDemo: Maybe<Scalars['Boolean']['output']>;
  isValid: Maybe<Scalars['Boolean']['output']>;
  modelName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  sourceId: Maybe<Scalars['String']['output']>;
  sourceName: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  workflowParams: Maybe<Array<Maybe<WorkflowParam>>>;
};

export type WorkflowActivitiesCollector = {
  activities: Array<WorkflowActivity>;
  errors: Array<WorkflowActivityErrors>;
};

export type WorkflowActivity = {
  default: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  inputs: Maybe<Array<InputActivityIo>>;
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  outputs: Maybe<Array<OutputActivityIo>>;
  parameterGroups: Maybe<Array<ParameterGroup>>;
  parameters: Maybe<Array<ActivityParameter>>;
  path: Scalars['String']['output'];
  process: ActivityProcess;
  readme: Maybe<Scalars['String']['output']>;
  skippable: Scalars['Boolean']['output'];
  tags: Maybe<Array<Tag>>;
  type: WorkflowActivityType;
  version: Version;
};

export type WorkflowActivityErrors = {
  messages: Maybe<Array<Scalars['String']['output']>>;
  name: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  version: Maybe<Scalars['String']['output']>;
};

export enum WorkflowActivityStatusEnum {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** ERROR */
  Error = 'ERROR',
  /** RUNNING */
  Running = 'RUNNING',
  /** TERMINATED */
  Terminated = 'TERMINATED'
}

export enum WorkflowActivityType {
  /** ADMIN */
  Admin = 'ADMIN',
  /** STANDARD */
  Standard = 'STANDARD'
}

export type WorkflowConfig = {
  activities: Array<ActivityInstance>;
  connectors: Array<Connector>;
  outputFolder: Maybe<ProjectFile>;
  sampleType: Maybe<SampleType>;
};

/** WorkflowEvent object for event table rows */
export type WorkflowEvent = {
  alias: Maybe<Scalars['String']['output']>;
  /** The configuration (json) of the workflow event. */
  config: WorkflowConfig;
  created: Scalars['String']['output'];
  expires: Maybe<Scalars['String']['output']>;
  lastExecution: Maybe<Scalars['String']['output']>;
  lastExecutor: Maybe<User>;
  lastModifier: User;
  modified: Maybe<Scalars['String']['output']>;
  note: Maybe<Scalars['String']['output']>;
  owner: User;
  project: Maybe<Project>;
  retentionRule: RetentionRuleEnum;
  status: Maybe<JobStatusEnum>;
  workflow: Maybe<WorkflowP2>;
  workflowEventId: Scalars['Long']['output'];
  workflowName: Maybe<Scalars['String']['output']>;
};

export type WorkflowExportMapping = {
  exportedWorkflowFieldName: Maybe<Scalars['String']['output']>;
  sampleAttributeId: Maybe<Scalars['Long']['output']>;
};

export type WorkflowExtendedConfig = {
  activities: Array<ActivityExtendedInstance>;
  connectors: Array<Connector>;
  outputFolder: Maybe<ProjectFile>;
  sampleType: Maybe<SampleType>;
};

/** A Workflow Job */
export type WorkflowJob = JobData & {
  /** The configuration (json) of the workflow. */
  config: WorkflowConfig;
  created: Maybe<Scalars['String']['output']>;
  errorDescription: Maybe<Scalars['String']['output']>;
  /** The expiation date, or null if the job isn't scheduled for purging (yet). */
  expirationDate: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  owner: Maybe<User>;
  status: Maybe<JobStatusEnum>;
  tool: Maybe<Scalars['String']['output']>;
};

/** Contains the mutation api for Workflows. */
export type WorkflowMutationApi = {
  executeWorkflow: WorkflowEvent;
  /** Same behavior as 'saveWorkflowEvent' but adapted to cleanup temporary data and keep the configuration consistent. */
  importTemplateToWorkflowEvent: WorkflowEvent;
  publishWorkflow: WorkflowP2;
  resetWorkflow: WorkflowEvent;
  saveTableParamViewInput: TableValue;
  saveWorkflow: WorkflowP2;
  saveWorkflowEvent: WorkflowEvent;
  stopWorkflow: Scalars['Boolean']['output'];
  stopWorkflows: Scalars['Boolean']['output'];
};


/** Contains the mutation api for Workflows. */
export type WorkflowMutationApiExecuteWorkflowArgs = {
  targetActivity: InputMaybe<Scalars['String']['input']>;
  workflowEventId: Scalars['Long']['input'];
};


/** Contains the mutation api for Workflows. */
export type WorkflowMutationApiImportTemplateToWorkflowEventArgs = {
  workflowEventInput: InputWorkflowEventInput;
};


/** Contains the mutation api for Workflows. */
export type WorkflowMutationApiPublishWorkflowArgs = {
  projectId: Scalars['Long']['input'];
  workflowInput: InputWorkflowInput;
};


/** Contains the mutation api for Workflows. */
export type WorkflowMutationApiResetWorkflowArgs = {
  nodeIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workflowEventId: Scalars['Long']['input'];
};


/** Contains the mutation api for Workflows. */
export type WorkflowMutationApiSaveTableParamViewInputArgs = {
  viewInput: InputWorkflowViewParamInput;
};


/** Contains the mutation api for Workflows. */
export type WorkflowMutationApiSaveWorkflowArgs = {
  workflowInput: InputMaybe<InputWorkflowInput>;
};


/** Contains the mutation api for Workflows. */
export type WorkflowMutationApiSaveWorkflowEventArgs = {
  workflowEventInput: InputWorkflowEventInput;
};


/** Contains the mutation api for Workflows. */
export type WorkflowMutationApiStopWorkflowArgs = {
  workflowEventId: Scalars['Long']['input'];
};


/** Contains the mutation api for Workflows. */
export type WorkflowMutationApiStopWorkflowsArgs = {
  eventIds: Array<InputMaybe<Scalars['Long']['input']>>;
};

export type WorkflowName = {
  exists: Scalars['Boolean']['output'];
  workflowName: Scalars['String']['output'];
};

/** Workflow notification data object */
export type WorkflowNotification = {
  id: Scalars['Long']['output'];
  parent: Maybe<Parent>;
  status: Maybe<SampleStatus>;
  subtype: Scalars['String']['output'];
};

export type WorkflowP2 = {
  /** The configuration of the workflow. */
  config: WorkflowConfig;
  created: Scalars['String']['output'];
  creator: Maybe<User>;
  description: Maybe<Scalars['String']['output']>;
  /** The extended configuration of the workflow, including (if any) override of configurations. */
  extendedConfig: WorkflowExtendedConfig;
  id: Scalars['Long']['output'];
  modified: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  usergroup: UserGroup;
};

export type WorkflowParam = {
  /** The unique identifier of the activity the param belongs to */
  activityId: Maybe<Scalars['String']['output']>;
  activityIndex: Maybe<Scalars['Int']['output']>;
  /** The name of the activity the param belongs to */
  activityName: Maybe<Scalars['String']['output']>;
  defaultParams: Maybe<WorkflowParamDefault>;
  description: Maybe<Scalars['String']['output']>;
  /** Unique and stable identifier for this parameter in one workflow */
  id: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
  /** Indicator if multiple files or folders can be selected, null for other fields. */
  multiSelect: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** The option-keys for multi-select inputs, null otherwise */
  optionKeys: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The option-labels for multi-select inputs, null otherwise */
  optionLabels: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required: Maybe<Scalars['Boolean']['output']>;
  usage: Maybe<Scalars['String']['output']>;
  valueTypeId: Maybe<Scalars['Long']['output']>;
  values: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type WorkflowParamAttributeMapping = {
  attributeId: Maybe<Scalars['Long']['output']>;
  workflowFieldId: Maybe<Scalars['String']['output']>;
};

export type WorkflowParamDefault = {
  files: Maybe<Array<Maybe<ProjectFile>>>;
  organism: Maybe<Organism>;
  /** The index of the selected option for multi-select inputs, null otherwise */
  selectedIndex: Maybe<Scalars['Int']['output']>;
  values: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum WorkflowParameterTypeEnum {
  /** BOOLEAN */
  Boolean = 'BOOLEAN',
  /** DATE */
  Date = 'DATE',
  /** FILE */
  File = 'FILE',
  /** GENOME */
  Genome = 'GENOME',
  /** GENOMIC_REGION */
  GenomicRegion = 'GENOMIC_REGION',
  /** NUMBER */
  Number = 'NUMBER',
  /** SAMPLE */
  Sample = 'SAMPLE',
  /** TABLE */
  Table = 'TABLE',
  /** TEXT */
  Text = 'TEXT'
}

/** Contains the query api for Workflows. */
export type WorkflowQueryApi = {
  activityCollector: WorkflowActivitiesCollector;
  activityLog: ActivityLog;
  findWorkflowById: Maybe<WorkflowP2>;
  findWorkflowEventById: Maybe<WorkflowEvent>;
  getTableValueParamForViewId: TableValue;
  listWorkflowEvents: Array<WorkflowEvent>;
  listWorkflows: Array<WorkflowP2>;
  nextflowLog: Maybe<Scalars['String']['output']>;
  /** Validate if the provided parameters have Public visibility */
  publishPermissionCheck: PermissionValidationResult;
  /** The list of all published workflows. */
  publishedWorkflows: Array<WorkflowP2>;
  /** Validate a workflow event name exists */
  workflowEventNameExists: Scalars['Boolean']['output'];
  /** Validate a workflow name exists */
  workflowNameExists: WorkflowName;
};


/** Contains the query api for Workflows. */
export type WorkflowQueryApiActivityLogArgs = {
  activityId: Scalars['String']['input'];
  workflowEventId: Scalars['Long']['input'];
};


/** Contains the query api for Workflows. */
export type WorkflowQueryApiFindWorkflowByIdArgs = {
  workflowId: InputMaybe<Scalars['Long']['input']>;
};


/** Contains the query api for Workflows. */
export type WorkflowQueryApiFindWorkflowEventByIdArgs = {
  workflowEventId: InputMaybe<Scalars['Long']['input']>;
};


/** Contains the query api for Workflows. */
export type WorkflowQueryApiGetTableValueParamForViewIdArgs = {
  viewId: Scalars['Long']['input'];
};


/** Contains the query api for Workflows. */
export type WorkflowQueryApiListWorkflowEventsArgs = {
  pagination: InputMaybe<InputPaginationInput>;
  projectId: InputMaybe<Scalars['Long']['input']>;
  searchTerm: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnum>;
  workflowId: InputMaybe<Scalars['Long']['input']>;
};


/** Contains the query api for Workflows. */
export type WorkflowQueryApiNextflowLogArgs = {
  workflowEventId: InputMaybe<Scalars['Long']['input']>;
};


/** Contains the query api for Workflows. */
export type WorkflowQueryApiPublishPermissionCheckArgs = {
  workflowEventId: InputMaybe<Scalars['Long']['input']>;
};


/** Contains the query api for Workflows. */
export type WorkflowQueryApiWorkflowEventNameExistsArgs = {
  projectId: Scalars['Long']['input'];
  workflowEventId: InputMaybe<Scalars['Long']['input']>;
  workflowEventName: Scalars['String']['input'];
};


/** Contains the query api for Workflows. */
export type WorkflowQueryApiWorkflowNameExistsArgs = {
  userGroupId: InputMaybe<Scalars['Long']['input']>;
  workflowId: InputMaybe<Scalars['Long']['input']>;
  workflowName: Scalars['String']['input'];
};

export enum ZygosityEnum {
  /** HETERO_ZYGOUS */
  HeteroZygous = 'HETERO_ZYGOUS',
  /** HOMO_ZYGOUS */
  HomoZygous = 'HOMO_ZYGOUS'
}

export type ProjectBasisFragment = { id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, lastModified: string | null, userGroup: { name: string } | null };

export type ProjectColoredWidgetFragment = { id: number, name: string, color: string | null };

export type GetProjectListForNavigationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectListForNavigationQuery = { projectList: { projects: Array<{ id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, lastModified: string | null, userGroup: { name: string } | null }> } | null };

export type GetAccessibleProjectGroupsQueryVariables = Exact<{
  includeStagedProjects?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAccessibleProjectGroupsQuery = { userGroup: { accessibleUserGroups: Array<{ id: number, name: string, accessibleProjects: Array<{ capabilities: Map<unknown, unknown> | null, id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, lastModified: string | null, userGroup: { name: string } | null }> }> } | null, userParams: { lastSaveTarget: number | null } | null };

export type GetProjectForPagesQueryVariables = Exact<{
  projectId: Scalars['Long']['input'];
}>;


export type GetProjectForPagesQuery = { project: { id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, lastModified: string | null, userGroup: { name: string } | null } | null };

export type GetProjectStatisticsQueryVariables = Exact<{
  projectId: Scalars['Long']['input'];
}>;


export type GetProjectStatisticsQuery = { project: { projectStatistics: { eventCount: number | null } } | null };

export type GetProjectSettingsQueryVariables = Exact<{
  projectId: Scalars['Long']['input'];
}>;


export type GetProjectSettingsQuery = { project: { isUserAdmin: boolean, isPublic: boolean, capabilities: Map<unknown, unknown> | null, created: string, lastModified: string | null, startDate: string | null, projectedEndDate: string | null, initialEndDate: string | null, actualEndDate: string | null, status: string | null, statusNotes: string | null, endNotes: string | null, goal: string | null, lastUpdate: string | null, id: number, parentFileId: number | null, name: string, description: string | null, isPrivateWorkspace: boolean, color: string | null, projectMembers: Array<{ roleId: number | null, user: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null }> | null, userGroup: { id: number, name: string, description: string | null, members: Array<{ id: number, firstName: string | null, lastName: string | null, username: string | null }> } | null, creator: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null } | null };

export type GetAllFilesInProjectForAttachmentsQueryVariables = Exact<{
  projectId: Scalars['Long']['input'];
}>;


export type GetAllFilesInProjectForAttachmentsQuery = { projectFiles: Array<{ id: number, created: string | null, description: string | null, fileName: string | null, fileType: string | null, lastModified: string | null, typeDisplayName: string | null, creator: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null, organisms: Array<{ id: number, name: string | null, species: { name: string } | null } | null> | null, parents: Array<{ id: number, name: string | null, parentType: { name: string } }> | null, contentType: { name: string | null, description: string | null, id: number | null } | null } | null> | null };

export type GetTagsQueryVariables = Exact<{
  projectId: InputMaybe<Scalars['Long']['input']>;
}>;


export type GetTagsQuery = { itemTags: Array<{ id: number, name: string, color: string | null, project: { id: number, name: string } }> };

export type AddTagMutationVariables = Exact<{
  itemTagInputData: InputItemTagInput;
}>;


export type AddTagMutation = { createOrUpdateTag: { id: number } | null };

export type DeleteTagMutationVariables = Exact<{
  itemTagId: Scalars['Long']['input'];
}>;


export type DeleteTagMutation = { deleteTag: boolean | null };

export type UserBasicsFragment = { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null };

export const ProjectBasisFragmentDoc = gql`
    fragment ProjectBasis on Project {
  id
  parentFileId
  name
  description
  isPrivateWorkspace
  color
  lastModified
  userGroup {
    name
  }
}
    `;
export const ProjectColoredWidgetFragmentDoc = gql`
    fragment ProjectColoredWidget on Project {
  id
  name
  color
}
    `;
export const UserBasicsFragmentDoc = gql`
    fragment UserBasics on User {
  id
  username
  firstName
  lastName
  email
  display
}
    `;
export const GetProjectListForNavigationDocument = gql`
    query getProjectListForNavigation {
  projectList(sortOrder: "name") {
    projects {
      ...ProjectBasis
    }
  }
}
    ${ProjectBasisFragmentDoc}`;
export const GetAccessibleProjectGroupsDocument = gql`
    query getAccessibleProjectGroups($includeStagedProjects: Boolean = false) {
  userGroup {
    accessibleUserGroups {
      id
      name
      accessibleProjects(includeStagedProjects: $includeStagedProjects) {
        ...ProjectBasis
        capabilities
      }
    }
  }
  userParams {
    lastSaveTarget
  }
}
    ${ProjectBasisFragmentDoc}`;
export const GetProjectForPagesDocument = gql`
    query getProjectForPages($projectId: Long!) {
  project(projectId: $projectId) {
    ...ProjectBasis
  }
}
    ${ProjectBasisFragmentDoc}`;
export const GetProjectStatisticsDocument = gql`
    query getProjectStatistics($projectId: Long!) {
  project(projectId: $projectId) {
    projectStatistics {
      eventCount
    }
  }
}
    `;
export const GetProjectSettingsDocument = gql`
    query getProjectSettings($projectId: Long!) {
  project(projectId: $projectId) {
    ...ProjectBasis
    isUserAdmin
    isPublic
    capabilities
    created
    lastModified
    startDate
    projectedEndDate
    initialEndDate
    actualEndDate
    status
    statusNotes
    endNotes
    status
    statusNotes
    endNotes
    goal
    startDate
    lastUpdate
    initialEndDate
    actualEndDate
    projectedEndDate
    projectMembers {
      roleId
      user {
        ...UserBasics
      }
    }
    userGroup {
      id
      name
      description
      members {
        id
        firstName
        lastName
        username
      }
    }
    creator {
      ...UserBasics
    }
  }
}
    ${ProjectBasisFragmentDoc}
${UserBasicsFragmentDoc}`;
export const GetAllFilesInProjectForAttachmentsDocument = gql`
    query getAllFilesInProjectForAttachments($projectId: Long!) {
  projectFiles(projectId: $projectId) {
    id
    created
    creator {
      ...UserBasics
    }
    organisms {
      id
      name
      species {
        name
      }
    }
    parents {
      id
      name
      parentType {
        name
      }
    }
    description
    fileName
    fileType
    lastModified
    typeDisplayName
    contentType {
      name
      description
      id
    }
  }
}
    ${UserBasicsFragmentDoc}`;
export const GetTagsDocument = gql`
    query getTags($projectId: Long) {
  itemTags(projectId: $projectId) {
    project {
      id
      name
    }
    id
    name
    color
  }
}
    `;
export const AddTagDocument = gql`
    mutation addTag($itemTagInputData: InputItemTagInput!) {
  createOrUpdateTag(itemTagInputData: $itemTagInputData) {
    id
  }
}
    `;
export const DeleteTagDocument = gql`
    mutation deleteTag($itemTagId: Long!) {
  deleteTag(itemTagId: $itemTagId)
}
    `;
export type Requester<C = {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    getProjectListForNavigation(variables?: GetProjectListForNavigationQueryVariables, options?: C): Promise<GetProjectListForNavigationQuery> {
      return requester<GetProjectListForNavigationQuery, GetProjectListForNavigationQueryVariables>(GetProjectListForNavigationDocument, variables, options) as Promise<GetProjectListForNavigationQuery>;
    },
    getAccessibleProjectGroups(variables?: GetAccessibleProjectGroupsQueryVariables, options?: C): Promise<GetAccessibleProjectGroupsQuery> {
      return requester<GetAccessibleProjectGroupsQuery, GetAccessibleProjectGroupsQueryVariables>(GetAccessibleProjectGroupsDocument, variables, options) as Promise<GetAccessibleProjectGroupsQuery>;
    },
    getProjectForPages(variables: GetProjectForPagesQueryVariables, options?: C): Promise<GetProjectForPagesQuery> {
      return requester<GetProjectForPagesQuery, GetProjectForPagesQueryVariables>(GetProjectForPagesDocument, variables, options) as Promise<GetProjectForPagesQuery>;
    },
    getProjectStatistics(variables: GetProjectStatisticsQueryVariables, options?: C): Promise<GetProjectStatisticsQuery> {
      return requester<GetProjectStatisticsQuery, GetProjectStatisticsQueryVariables>(GetProjectStatisticsDocument, variables, options) as Promise<GetProjectStatisticsQuery>;
    },
    getProjectSettings(variables: GetProjectSettingsQueryVariables, options?: C): Promise<GetProjectSettingsQuery> {
      return requester<GetProjectSettingsQuery, GetProjectSettingsQueryVariables>(GetProjectSettingsDocument, variables, options) as Promise<GetProjectSettingsQuery>;
    },
    getAllFilesInProjectForAttachments(variables: GetAllFilesInProjectForAttachmentsQueryVariables, options?: C): Promise<GetAllFilesInProjectForAttachmentsQuery> {
      return requester<GetAllFilesInProjectForAttachmentsQuery, GetAllFilesInProjectForAttachmentsQueryVariables>(GetAllFilesInProjectForAttachmentsDocument, variables, options) as Promise<GetAllFilesInProjectForAttachmentsQuery>;
    },
    getTags(variables?: GetTagsQueryVariables, options?: C): Promise<GetTagsQuery> {
      return requester<GetTagsQuery, GetTagsQueryVariables>(GetTagsDocument, variables, options) as Promise<GetTagsQuery>;
    },
    addTag(variables: AddTagMutationVariables, options?: C): Promise<AddTagMutation> {
      return requester<AddTagMutation, AddTagMutationVariables>(AddTagDocument, variables, options) as Promise<AddTagMutation>;
    },
    deleteTag(variables: DeleteTagMutationVariables, options?: C): Promise<DeleteTagMutation> {
      return requester<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, variables, options) as Promise<DeleteTagMutation>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;